(function() {
    'use strict';
    if (window.__twNotificationsModuleInit) return;
    window.__twNotificationsModuleInit = true;

    // Обновление access-token при 401 — только в utils.js (makeAuthenticatedRequest / axios interceptor).

    /**
     * @param {string} [detail] — раскрываемый текст (только textContent); для админов в production
     */
    function showNotification(type, message, title = '', detail) {
        $('.notification-container').remove();

        const wrap = document.createElement('div');
        wrap.className = 'notification-container position-fixed top-0 end-0 p-3';
        wrap.style.cssText = 'z-index: 10000; margin-top: 10px; width: auto; max-width: min(420px, 100vw);';

        const toast = document.createElement('div');
        const bgClass = type === 'error' ? 'bg-danger' : type === 'success' ? 'bg-success' : type === 'warning' ? 'bg-warning' : 'bg-info';
        const bgColor = type === 'error' ? '#dc3545' : type === 'success' ? '#198754' : type === 'warning' ? '#ffc107' : '#0dcaf0';
        toast.className = 'toast align-items-center text-white border-0 ' + bgClass;
        toast.style.cssText = 'opacity: 1; background-color: ' + bgColor + ' !important;';
        toast.setAttribute('role', 'alert');
        toast.setAttribute('aria-live', 'assertive');
        toast.setAttribute('aria-atomic', 'true');

        const inner = document.createElement('div');
        inner.className = 'd-flex';

        const body = document.createElement('div');
        body.className = 'toast-body flex-grow-1';
        if (title) {
            const strong = document.createElement('strong');
            strong.textContent = title;
            body.appendChild(strong);
            body.appendChild(document.createElement('br'));
        }
        const msgSpan = document.createElement('span');
        msgSpan.textContent = message != null ? String(message) : '';
        body.appendChild(msgSpan);

        if (detail && String(detail).trim() !== '') {
            const det = document.createElement('details');
            det.className = 'mt-2';
            const sum = document.createElement('summary');
            sum.className = 'small';
            sum.textContent = 'Подробнее';
            sum.style.cursor = 'pointer';
            det.appendChild(sum);
            const pre = document.createElement('pre');
            pre.className = 'mb-0 mt-1 small text-white-50';
            pre.style.whiteSpace = 'pre-wrap';
            pre.style.maxHeight = '12rem';
            pre.style.overflow = 'auto';
            pre.textContent = String(detail);
            det.appendChild(pre);
            body.appendChild(det);
        }

        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'btn-close btn-close-white me-2 m-auto';
        closeBtn.setAttribute('data-bs-dismiss', 'toast');
        closeBtn.setAttribute('aria-label', 'Close');

        inner.appendChild(body);
        inner.appendChild(closeBtn);
        toast.appendChild(inner);
        wrap.appendChild(toast);
        document.body.appendChild(wrap);

        const toastBootstrap = new bootstrap.Toast(toast, { delay: 5000 });
        toast.addEventListener('hidden.bs.toast', function() {
            wrap.remove();
        });
        toastBootstrap.show();
    }

    // Make showNotification globally available
    window.showNotification = showNotification;

    // Process notifications from response data
    function processNotifications(data) {
        if (data && data.notifications && Array.isArray(data.notifications)) {
            data.notifications.forEach(function(notification) {
                showNotification(notification.type, notification.message, notification.title);
            });
        }

        // SPA: переход только при явном success, иначе не уходить со страницы при ошибке/неоднозначном ответе
        if (data && data.redirectUrl && data.success === true) {
            var redirectTarget = (typeof window.twNormalizeNavigationUrl === 'function')
                ? window.twNormalizeNavigationUrl(data.redirectUrl)
                : data.redirectUrl;
            setTimeout(function() {
                window.location.href = redirectTarget;
            }, 1000); // Small delay to allow notification to show
        }
    }

    // Make processNotifications globally available
    window.processNotifications = processNotifications;

    function twAjaxErrorUserContext() {
        const body = document.body;
        if (!body || !body.dataset) {
            return { isDev: false, isAdmin: false };
        }
        return {
            isDev: body.dataset.twEnvironment === 'Development',
            isAdmin: body.dataset.twAdmin === 'true'
        };
    }

    function twTruncateDetail(text, maxLen) {
        const s = text == null ? '' : String(text);
        if (s.length <= maxLen) return s;
        return s.slice(0, maxLen) + '\n…';
    }

    // Global AJAX error handler for handling errors
    $(document).ajaxError(function(event, xhr, settings) {
        // Skip if request was aborted
        if (xhr.statusText === 'abort') {
            return;
        }
        
        // Skip if this is a refresh token request to prevent infinite loops
        if (settings.url && settings.url.includes('/api/auth/refresh')) {
            return;
        }

        // 400 от отправки формы Create/Edit уже обрабатывается в forms.js — не дублировать уведомление
        if (xhr.status === 400 && settings.url && (settings.url.indexOf('/PointOfSales/Create') >= 0 || settings.url.indexOf('/PointOfSales/Edit') >= 0)) {
            return;
        }

        const { isDev, isAdmin } = twAjaxErrorUserContext();
        let errorMessage = 'Не удалось выполнить запрос. Попробуйте позже.';
        let errorTitle = 'Ошибка';
        let detail = null;

        if (xhr.status === 401) {
            // Don't show notification here - let makeAuthenticatedRequest handle it
            return;
        } else if (xhr.status === 403) {
            errorMessage = 'У вас нет прав доступа к этой функции.';
            errorTitle = 'Доступ запрещен';
        } else if (xhr.status >= 500) {
            errorMessage = 'Внутренняя ошибка сервера. Попробуйте позже.';
            errorTitle = 'Ошибка сервера';
        } else if (xhr.status === 0) {
            // status 0 usually means network error or request was aborted
            errorMessage = 'Ошибка сети. Проверьте подключение к интернету.';
            errorTitle = 'Ошибка сети';
        } else if (xhr.status === 404) {
            errorMessage = 'Запрашиваемые данные не найдены.';
            errorTitle = 'Не найдено';
        } else if (xhr.status === 408 || xhr.status === 504) {
            errorMessage = 'Превышено время ожидания ответа сервера.';
            errorTitle = 'Таймаут';
        } else {
            let rawDetail = '';
            try {
                const response = JSON.parse(xhr.responseText);
                rawDetail = response.message || response.title || response.detail || '';
                if (!rawDetail && typeof xhr.responseText === 'string') {
                    rawDetail = xhr.responseText.trim().slice(0, 4000);
                }
            } catch (e) {
                if (typeof xhr.responseText === 'string' && xhr.responseText.trim()) {
                    rawDetail = xhr.responseText.trim().slice(0, 4000);
                }
            }

            if (isDev) {
                errorMessage = rawDetail ? twTruncateDetail(rawDetail, 1200) : errorMessage;
                errorTitle = 'Ошибка запроса (Development)';
                if (xhr.status) {
                    errorTitle += ' (' + xhr.status + ')';
                }
            } else if (isAdmin && rawDetail) {
                detail = twTruncateDetail(rawDetail, 8000);
                errorMessage = 'Запрос не выполнен. Обратитесь в поддержку при необходимости.';
                errorTitle = 'Ошибка';
                if (xhr.status) {
                    errorTitle += ' (' + xhr.status + ')';
                }
            } else {
                errorTitle = 'Ошибка';
                if (xhr.status) {
                    errorTitle += ' (' + xhr.status + ')';
                }
            }
        }
        
        showNotification('error', errorMessage, errorTitle, detail);
    });

})();

(function () {
    'use strict';
    if (window.__twTelegramBindingModuleInit) return;
    window.__twTelegramBindingModuleInit = true;

    function twCopyViaExecCommand(value) {
        try {
            var ta = document.createElement('textarea');
            ta.value = value;
            ta.setAttribute('readonly', '');
            ta.style.cssText = 'position:fixed;top:0;left:0;width:2em;height:2em;margin:0;padding:0;border:0;opacity:0;';
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            ta.setSelectionRange(0, value.length);
            var ok = document.execCommand('copy');
            document.body.removeChild(ta);
            return ok;
        } catch (e) {
            return false;
        }
    }

    function twCopyTextToClipboard(text) {
        var value = text == null ? '' : String(text);
        if (!value) return Promise.resolve(false);

        if (typeof window.isSecureContext !== 'undefined' && window.isSecureContext
            && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            return navigator.clipboard.writeText(value)
                .then(function () { return true; })
                .catch(function () { return twCopyViaExecCommand(value); });
        }

        return Promise.resolve(twCopyViaExecCommand(value));
    }

    // Делегирование: блок привязки пересоздаётся при SPA-навигации.
    if (window.jQuery) {
        window.jQuery(document).on('click', '[data-tw-telegram-copy-code]', function () {
            var code = window.jQuery(this).attr('data-tw-telegram-copy-code') || '';
            twCopyTextToClipboard(code).then(function (ok) {
                if (ok && typeof window.showNotification === 'function') {
                    window.showNotification('success', 'Код скопирован в буфер обмена.');
                } else if (!ok && typeof window.showNotification === 'function') {
                    window.showNotification('warning', 'Не удалось скопировать код автоматически. Скопируйте вручную.');
                }
            });
        });
    }

    window.bootTelegramBindingPage = function () {
        // Копирование привязано к document; вызов оставлен для совместимости с navigation.js.
    };
})();

(function () {
    'use strict';
    if (window.__twThemesModuleInit) return;
    window.__twThemesModuleInit = true;

    const THEMES = ['gray', 'light', 'vivid'];
    const THEME_LABELS = {
        gray: 'Серая',
        light: 'Светлая',
        vivid: 'Яркая'
    };

    function applyTheme(name) {
        if (!THEMES.includes(name)) {
            name = 'gray';
        }
        const body = document.body;
        THEMES.forEach(function (t) {
            body.classList.remove('theme-' + t);
        });
        body.classList.add('theme-' + name);
        localStorage.setItem('tw_theme', name);

        const wrap = document.getElementById('navbarThemeDropdown');
        if (wrap) {
            wrap.querySelectorAll('.dropdown-item').forEach(function (el) {
                el.classList.remove('active');
            });
            const activeItem = wrap.querySelector('.dropdown-item[data-theme="' + name + '"]');
            if (activeItem) {
                activeItem.classList.add('active');
            }
            const toggle = wrap.querySelector('.dropdown-toggle');
            if (toggle) {
                const label = THEME_LABELS[name] || name;
                toggle.innerHTML = '<i class="fas fa-palette me-1"></i> ' + label;
            }
        }

        if (window.tempusDominus && document.querySelectorAll('.date-range-picker-dropdown').length > 0) {
            // CSS variables обновляются через класс theme-* на body
        }
    }

    const savedTheme = localStorage.getItem('tw_theme') || 'gray';
    applyTheme(savedTheme);

    // Только селектор темы в navbar: не перехватывать клики по .theme-dropdown на формах (POS, фильтры),
    // иначе конфликт с enhanced-dropdown / auto-enhanced-dropdown (Frontend Review 2-22).
    $(document).on('click', '#navbarThemeDropdown .dropdown-item', function (e) {
        e.preventDefault();
        const theme = $(this).attr('data-theme');
        if (theme) {
            applyTheme(theme);
        }
    });
})();


// Сайдбар: ручной toggle + resize, пересчёт #content через классы (margin+width в site.css)
(function () {
    'use strict';
    if (window.__twSidebarModuleInit) return;
    window.__twSidebarModuleInit = true;

    var DESKTOP_PREF_KEY = 'tw.sidebar.desktopCollapsed';

    function twIsMobileSidebarViewport() {
        return $(window).width() <= 991;
    }

    function twReadDesktopCollapsedPref() {
        try {
            return localStorage.getItem(DESKTOP_PREF_KEY) === '1';
        } catch (e) {
            return false;
        }
    }

    function twWriteDesktopCollapsedPref(collapsed) {
        try {
            localStorage.setItem(DESKTOP_PREF_KEY, collapsed ? '1' : '0');
        } catch (e) {
            /* private mode / denied */
        }
    }

    /**
     * Сайдбар fixed между header и низом вьюпорта.
     * Когда футер входит во вьюпорт — поднимаем bottom, чтобы не наезжать на него.
     * Когда футера не видно — bottom: 0 (до самого низа экрана).
     */
    function twSyncSidebarFooterClearance() {
        var sb = document.getElementById('sidebar');
        if (!sb) return;

        if (twIsMobileSidebarViewport()) {
            sb.style.bottom = '';
            return;
        }

        var footer = document.querySelector('footer.footer');
        if (!footer) {
            sb.style.bottom = '0px';
            return;
        }

        var rect = footer.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var clearance = 0;
        if (rect.top < vh) {
            clearance = Math.min(Math.max(vh - rect.top, 0), Math.max(rect.height, 0));
        }
        sb.style.bottom = clearance > 0 ? (clearance + 'px') : '0px';
    }

    function twSetDesktopCollapsed(collapsed) {
        $('#sidebar').toggleClass('collapsed', collapsed);
        $('#content').toggleClass('sidebar-collapsed', collapsed);
        // Снять устаревший inline margin от navigation.ensureLayout, чтобы сработал site.css
        $('#content').css('margin-left', '');
        if (typeof window.ensureLayout === 'function') {
            window.ensureLayout();
        }
        twSyncSidebarFooterClearance();
    }

    /** Согласует классы сайдбара/контента с viewport и сохранённым desktop-предпочтением. */
    function twApplySidebarLayout() {
        var $sb = $('#sidebar');
        var $ct = $('#content');
        if (!$sb.length) return;

        if (twIsMobileSidebarViewport()) {
            // Mobile: узкий по умолчанию; .active — временный оверлей. Desktop-классы снимаем.
            $sb.removeClass('collapsed');
            $ct.removeClass('sidebar-collapsed');
            $sb[0].style.bottom = '';
            return;
        }

        // Desktop: снять mobile overlay, восстановить pref
        $sb.removeClass('active');
        $ct.removeClass('active');
        twSetDesktopCollapsed(twReadDesktopCollapsedPref());
        twSyncSidebarFooterClearance();
    }

    function twToggleSidebar() {
        if (twIsMobileSidebarViewport()) {
            $('#sidebar').toggleClass('active');
            $('#content').toggleClass('active');
            return;
        }
        var nextCollapsed = !$('#sidebar').hasClass('collapsed');
        twSetDesktopCollapsed(nextCollapsed);
        twWriteDesktopCollapsedPref(nextCollapsed);
    }

    $('#sidebarCollapse').on('click', function () {
        twToggleSidebar();
    });

    $(document).on('click', function (e) {
        if (twIsMobileSidebarViewport() && !$(e.target).closest('#sidebar, #sidebarCollapse').length) {
            $('#sidebar').removeClass('active');
            $('#content').removeClass('active');
        }
    });

    var resizeTimer = null;
    $(window).on('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            twApplySidebarLayout();
        }, 100);
    });

    var scrollRaf = null;
    $(window).on('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = null;
            twSyncSidebarFooterClearance();
        });
    });

    twApplySidebarLayout();
    twSyncSidebarFooterClearance();

    // Initialize Bootstrap 5 tooltips
    document.addEventListener('DOMContentLoaded', function () {
        twSyncSidebarFooterClearance();
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (element) {
            if (!element.hasAttribute('data-bs-placement')) {
                element.setAttribute('data-bs-placement', 'right');
            }
            if (!element.hasAttribute('data-bs-trigger')) {
                element.setAttribute('data-bs-trigger', 'hover focus');
            }
            new bootstrap.Tooltip(element, {
                container: 'body',
                html: true
            });
        });

        if (typeof bootstrap !== 'undefined' && bootstrap.Popover) {
            document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (element) {
                if (!element.hasAttribute('data-bs-trigger')) {
                    element.setAttribute('data-bs-trigger', 'hover focus');
                }
                new bootstrap.Popover(element, {
                    container: 'body',
                    html: true,
                    sanitize: true
                });
            });
        }
    });

    // Автоскрытие только для явно помеченных алертов (см. Frontend Review 2-23)
    setTimeout(function () {
        $('.alert.alert-dismissible.auto-dismiss').fadeOut('slow');
    }, 5000);

    window.twApplySidebarLayout = twApplySidebarLayout;
    window.twSyncSidebarFooterClearance = twSyncSidebarFooterClearance;
})();

(function () {
    'use strict';
    if (window.__twModalsModuleInit) return;
    window.__twModalsModuleInit = true;

// Store the form to submit after confirmation
let deleteForm = null;

// Function to handle delete button clicks - using event delegation to work with dynamically loaded content
$(document).off('click', '.btn-delete').on('click', '.btn-delete', function (e) {
    e.preventDefault();

    // Форма может быть снаружи btn-group (атрибут form=…), чтобы сегменты группы склеивались
    var formAttr = this.getAttribute('form');
    if (formAttr) {
        deleteForm = $('#' + (typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(formAttr) : formAttr.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1')));
    } else {
        deleteForm = $(this).closest('form');
    }

    // Show additional info if available (e.g., entity name)
    const deleteInfo = $(this).data('delete-info');
    const delEl = document.getElementById('deleteAdditionalInfo');
    if (delEl) {
        delEl.textContent = '';
        if (deleteInfo !== undefined && deleteInfo !== null && String(deleteInfo).trim() !== '') {
            var p = document.createElement('p');
            var strong = document.createElement('strong');
            strong.textContent = 'Объект: ';
            p.appendChild(strong);
            p.appendChild(document.createTextNode(String(deleteInfo)));
            delEl.appendChild(p);
        }
    }

    // Show the modal
    $('#deleteConfirmationModal').modal('show');
});

// Handle the confirmation button click
$(document).off('click', '#confirmDeleteButton').on('click', '#confirmDeleteButton', function() {
    if (deleteForm) {
        // Submit the stored form via AJAX to handle SPA response properly
        const form = deleteForm[0];
        const formData = new FormData(form);
        
        // Make AJAX request to submit the form
        $.ajax({
            url: form.action,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function(response) {
                // Show notifications if any
                if (response.notifications && response.notifications.length > 0) {
                    response.notifications.forEach(function(notification) {
                        showNotification(notification.type || 'info', notification.message || '', notification.title || 'Уведомление');
                    });
                }
                
                // Always update table data instead of full page reload for delete operations
                if (typeof updateTableData === 'function') {
                    // Get current filter parameters from URL
                    const urlParams = new URLSearchParams(window.location.search);
                    const filterParams = {};
                    for (const [key, value] of urlParams.entries()) {
                        filterParams[key] = value;
                    }
                    
                    // Preserve current page and sorting
                    const currentPage = parseInt(urlParams.get('pageNumber')) || 1;
                    let sortBy = urlParams.get('sortBy') || '';
                    let sortAscending = urlParams.get('sortAscending') !== 'false';
                    
                    // If no sorting parameters in URL, try to get from DOM state
                    if (!sortBy && window.currentSortField && window.currentSortDirection !== undefined && window.currentSortDirection !== null) {
                        sortBy = window.currentSortField;
                        sortAscending = window.currentSortDirection === 'asc';
                    } else if (!sortBy) {
                        // Try to detect from DOM
                        const sortColumn = document.querySelector('.sortable-column .sort-icon');
                        if (sortColumn && (sortColumn.classList.contains('fa-sort-up') || sortColumn.classList.contains('fa-sort-down'))) {
                            const sortableColumn = sortColumn.closest('.sortable-column');
                            if (sortableColumn) {
                                sortBy = sortableColumn.getAttribute('data-sort-field');
                                sortAscending = sortColumn.classList.contains('fa-sort-up');
                            }
                        }
                    }
                    
                    if (!sortBy) {
                        sortBy = 'UpdatedDate';
                        sortAscending = false;
                    }
                    
                    // Ensure sorting parameters are included in filterParams
                    if (sortBy) {
                        filterParams.sortBy = sortBy;
                        filterParams.sortAscending = sortAscending;
                    }
                    filterParams.pageNumber = currentPage;
                    
                    // Derive controller/action from delete form URL, then override with pagination links if present
                    let controller = 'PointOfSales';
                    let action = 'GetPointOfSalesTableRows';
                    
                    try {
                        const formActionUrl = new URL(form.action);
                        const pathParts = formActionUrl.pathname.split('/');
                        if (pathParts.length > 1 && pathParts[1]) {
                            controller = pathParts[1];
                            action = 'Get' + controller + 'TableRows';
                        }
                    } catch (e) {
                        console.warn('Could not parse form action URL for controller detection', e);
                    }
                    
                    const firstPaginationLink = document.querySelector('.ajax-pagination');
                    if (firstPaginationLink) {
                        controller = firstPaginationLink.getAttribute('data-controller') || controller;
                        action = firstPaginationLink.getAttribute('data-action') || action;
                    }
                    
                    // Update table data with preserved sorting and correct controller/action
                    updateTableData(filterParams, controller, action, currentPage, window.getEffectivePageSize());
                } else {
                    // Fallback to page reload only if updateTableData is not available
                    if (response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    } else {
                        deleteForm.submit();
                    }
                }
            },
            error: function(xhr, status, error) {
                console.error('Delete operation failed:', error);
                showNotification('error', 'Не удалось удалить объект', 'Ошибка');
                
                // Fallback to regular form submission
                deleteForm.submit();
            }
        });
    }

    // Hide the modal
    $('#deleteConfirmationModal').modal('hide');
});

// Clear the stored form when the modal is hidden
$('#deleteConfirmationModal').off('hidden.bs.modal').on('hidden.bs.modal', function () {
    deleteForm = null;
    $('#deleteAdditionalInfo').empty();
});

function twAppendResetTerminalModal(terminalIdStr, resetUrl) {
    var terminalId = terminalIdStr == null ? '' : String(terminalIdStr).trim();
    var existing = document.getElementById('resetModal');
    if (existing) {
        existing.remove();
    }

    var wrap = document.createElement('div');
    wrap.className = 'modal fade';
    wrap.id = 'resetModal';
    wrap.tabIndex = -1;
    wrap.setAttribute('aria-labelledby', 'resetModalLabel');
    wrap.setAttribute('aria-hidden', 'true');

    var dialog = document.createElement('div');
    dialog.className = 'modal-dialog modal-dialog-centered';

    var content = document.createElement('div');
    content.className = 'modal-content';

    var header = document.createElement('div');
    header.className = 'modal-header';
    var title = document.createElement('h5');
    title.className = 'modal-title';
    title.id = 'resetModalLabel';
    title.textContent = 'Подтверждение';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'btn-close';
    closeBtn.setAttribute('data-bs-dismiss', 'modal');
    closeBtn.setAttribute('aria-label', 'Close');
    header.appendChild(title);
    header.appendChild(closeBtn);

    var body = document.createElement('div');
    body.className = 'modal-body';
    body.appendChild(document.createTextNode('Вы уверены что хотите перезагрузить терминал '));
    var idStrong = document.createElement('strong');
    idStrong.textContent = terminalId;
    body.appendChild(idStrong);
    body.appendChild(document.createTextNode('?'));

    var footer = document.createElement('div');
    footer.className = 'modal-footer';
    var btnNo = document.createElement('button');
    btnNo.type = 'button';
    btnNo.className = 'btn btn-secondary';
    btnNo.setAttribute('data-bs-dismiss', 'modal');
    btnNo.textContent = 'Нет';
    var btnYes = document.createElement('button');
    btnYes.type = 'button';
    btnYes.className = 'btn btn-primary tw-confirm-reset-terminal';
    btnYes.dataset.terminalId = terminalId;
    if (resetUrl) {
        btnYes.dataset.resetUrl = resetUrl;
    }
    btnYes.textContent = 'Да';
    footer.appendChild(btnNo);
    footer.appendChild(btnYes);

    content.appendChild(header);
    content.appendChild(body);
    content.appendChild(footer);
    dialog.appendChild(content);
    wrap.appendChild(dialog);
    document.body.appendChild(wrap);

    wrap.addEventListener('hidden.bs.modal', function onHidden() {
        wrap.removeEventListener('hidden.bs.modal', onHidden);
        wrap.remove();
    });

    var modal = new bootstrap.Modal(wrap);
    modal.show();
}

// Delegated confirm — без .off/.on на каждое открытие модалки
$(document).on('click', '.tw-confirm-reset-terminal', function (e) {
    var btn = e.currentTarget;
    var currentTerminalId = btn.dataset.terminalId;
    var url = btn.dataset.resetUrl;
    console.log('Terminal reset confirmed for ID: ' + currentTerminalId);
    if (url && typeof $ !== 'undefined' && $.post) {
        $.post(url, { id: currentTerminalId }).fail(function () {
            console.warn('Terminal reset request failed');
        });
    }
    var modalEl = btn.closest('.modal');
    if (modalEl) {
        var inst = bootstrap.Modal.getInstance(modalEl);
        if (inst) {
            inst.hide();
        }
    }
});

// Handler for reset button to open modal (.reset-btn + data-reset-url опционально)
$(document).on('click', '.reset-btn', function (e) {
    e.preventDefault();
    var $t = $(this);
    var terminalId = $t.data('terminal-terminalid') || $t.data('terminal-id') || $t.closest('tr').find('td:nth-child(2)').text().trim();
    var resetUrl = $t.data('reset-url') || $t.attr('data-reset-url') || '';
    twAppendResetTerminalModal(terminalId, resetUrl);
});

// Обработка Enter в полях модальных окон.
// Без этого форма с единственным текстовым полем выполняет неявную отправку (GET на текущий
// URL) и страница перезагружается, а кнопка действия (onclick) не срабатывает. Перехватываем
// Enter и нажимаем основную кнопку действия в подвале модалки.
function twTriggerModalPrimaryAction(inputEl) {
    if (!inputEl) return false;
    var modalEl = inputEl.closest ? inputEl.closest('.modal') : null;
    if (!modalEl) return false;
    var primary = modalEl.querySelector(
        '.modal-footer .btn-primary, .modal-footer .btn-warning, .modal-footer .btn-danger');
    if (!primary || primary.disabled || primary.offsetParent === null) return false;
    primary.click();
    return true;
}
window.twTriggerModalPrimaryAction = twTriggerModalPrimaryAction;

$(document).on('keydown',
    '.modal input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit])',
    function (e) {
        if (e.key !== 'Enter') return;
        // Не мешаем выбору из выпадающих списков (enhanced-dropdown) и текстовым областям.
        if ($(e.target).closest('.enhanced-dropdown').length) return;
        e.preventDefault();
        twTriggerModalPrimaryAction(e.target);
    });

})();

(function () {
    'use strict';
    if (window.__twPopoversModuleInit) return;
    window.__twPopoversModuleInit = true;

function twEscapeHtmlPopoverText(value) {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function twFormatDashboardPopoverDateTime(rawTime) {
    if (rawTime === null || rawTime === undefined || rawTime === '') {
        return '—';
    }
    try {
        const date = new Date(rawTime);
        if (Number.isNaN(date.getTime())) {
            return '—';
        }
        const today = new Date();
        if (date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()) {
            return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
        }
        const datePart = date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
        const timePart = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
        return datePart + ' ' + timePart;
    } catch (e) {
        return '—';
    }
}

// Function to initialize Bootstrap popovers
function initializePopovers() {
    // Remove existing popovers to avoid duplicates
    const existingPopovers = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    existingPopovers.forEach(function (popoverTriggerEl) {
        try {
            const popoverInstance = bootstrap.Popover.getInstance(popoverTriggerEl);
            if (popoverInstance) {
                popoverInstance.dispose();
            }
        } catch (e) {
            console.warn('Error disposing existing popover:', e);
        }
    });

    // Явная разметка [data-bs-toggle="popover"]; конвертация всех [title] отключена (перф + предсказуемость).

    // Initialize all popovers with data-bs-toggle="popover" attribute
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            html: true,
            sanitize: true,
            trigger: 'hover',
            placement: 'top'
        });
    });
}

// Function to convert title attributes to Bootstrap popovers
function convertTitlesToPopovers() {
    // Find all elements with title attribute but without data-bs-toggle="popover"
    const titleElements = document.querySelectorAll('[title]:not([data-bs-toggle="popover"])');
    
    titleElements.forEach(function(element) {
        const title = element.getAttribute('title');
        if (title && title.trim() !== '') {
            // Skip elements that already have popover attributes
            if (!element.hasAttribute('data-bs-content') && !element.hasAttribute('data-bs-toggle')) {
                // Convert title to Bootstrap popover attributes
                element.setAttribute('data-bs-toggle', 'popover');
                element.setAttribute('data-bs-content', title);
                element.setAttribute('data-bs-html', 'true');
                element.setAttribute('data-bs-placement', 'top');
                element.setAttribute('data-bs-trigger', 'hover');
                
                // Remove the original title attribute to prevent duplicate tooltips
                element.removeAttribute('title');
                
                console.log('[POPOVERS] Converted title to popover:', title);
            }
        }
    });
}

// Function to dispose of special popovers to prevent memory leaks
function disposeSpecialPopovers() {
    // Remove all existing popover elements from DOM
    const existingPopoverElements = document.querySelectorAll('.popover');
    existingPopoverElements.forEach(function(popoverElement) {
        if (popoverElement.parentNode) {
            popoverElement.parentNode.removeChild(popoverElement);
        }
    });
    
    // Find all sales, stock, and not-dispensing cells that might have temporary elements
    const salesCells = document.querySelectorAll('.sales-cell[data-sales]');
    const stockCells = document.querySelectorAll('.stock-cell[data-stock]');
    const notDispensingCells = document.querySelectorAll('.not-dispensing-cell[data-not-dispensing-items]');

    // Clean up temporary elements for sales cells
    salesCells.forEach(function(cell) {
        if (cell._popover) {
            cell._popover.dispose();
            cell._popover = null;
        }
        if (cell._tempElement && cell._tempElement.parentNode) {
            cell._tempElement.parentNode.removeChild(cell._tempElement);
            cell._tempElement = null;
        }
        // Remove aria-describedby attribute
        cell.removeAttribute('aria-describedby');
    });

    // Clean up temporary elements for stock cells
    stockCells.forEach(function(cell) {
        if (cell._popover) {
            cell._popover.dispose();
            cell._popover = null;
        }
        if (cell._tempElement && cell._tempElement.parentNode) {
            cell._tempElement.parentNode.removeChild(cell._tempElement);
            cell._tempElement = null;
        }
        // Remove aria-describedby attribute
        cell.removeAttribute('aria-describedby');
    });

    // Clean up not-dispensing cells
    notDispensingCells.forEach(function(cell) {
        if (cell._popover) {
            cell._popover.dispose();
            cell._popover = null;
        }
        if (cell._tempElement && cell._tempElement.parentNode) {
            cell._tempElement.parentNode.removeChild(cell._tempElement);
            cell._tempElement = null;
        }
        cell.removeAttribute('aria-describedby');
    });
}

// Function to initialize special popovers for sales and stock cells
function initializeSpecialPopovers() {
    // Dispose of any existing special popovers to prevent memory leaks
    disposeSpecialPopovers();

    // Initialize popovers on cells with data-sales attribute
    const salesCells = document.querySelectorAll('.sales-cell[data-sales]');
    salesCells.forEach(function(cell) {
        // Get sales data from the attribute
        let salesDataStr = cell.getAttribute('data-sales');

        // If the value is null or undefined, return early
        if (!salesDataStr) {
            return;
        }

        // Handle the case where the JSON might be double-encoded
        // Check if the string represents the literal word "null"
        if (salesDataStr === "null") {
            return; // No data to show
        }

        try {
            // Handle case where the JSON might be double-quoted (e.g., "[{\"prop\":\"val\"}]")
            // If the string starts and ends with quotes, parse it as a string first
            if (salesDataStr.startsWith('"') && salesDataStr.endsWith('"')) {
                // This means the JSON was stringified again, so we need to parse as string first
                salesDataStr = JSON.parse(salesDataStr);
            }

            const salesData = JSON.parse(salesDataStr);

            if (salesData && salesData.length > 0) {
                let content = '<div class="tw-sales-popover-grid text-start">';

                salesData.forEach(function(sale) {

                    // Add a separator except for the first item
                    content += '<hr class="tw-sales-popover-separator my-1">';
                    // Format date safely
                    const saleDate = new Date(sale.Time);
                    const today = new Date();
                    let formattedDate;
                    
                    try {
                        if (saleDate.getDate() === today.getDate() &&
                            saleDate.getMonth() === today.getMonth() &&
                            saleDate.getFullYear() === today.getFullYear()) {
                            // Same day - show only time (HH:MM)
                            formattedDate = saleDate.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
                        } else {
                            // Different day - show date and time (DD.MM HH:MM)
                            const datePart = saleDate.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
                            const timePart = saleDate.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
                            formattedDate = datePart + ' ' + timePart;
                        }
                    } catch (e) {
                        // Fallback if date formatting fails
                        formattedDate = sale.Time || 'Некорректная дата';
                    }
                    const formattedPrice = window.formatCurrency(sale.Sum);

                    // Escape HTML entities in formatted values to prevent issues
                    const escapedDate = (formattedDate || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                    const escapedPrice = (formattedPrice || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                    const escapedProductName = (sale.ProductName || "Продажа").replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

                    content += '<div class="tw-sales-popover-date">' + escapedDate + '</div>' +
                        '<div class="tw-sales-popover-price">' + escapedPrice + '</div>' +
                        '<div class="tw-sales-popover-name">' + escapedProductName + '</div>';
                });

                content += '</div>';

                // Set the content and title attributes for Bootstrap to use
                cell.setAttribute('data-bs-title', 'Продажи');
                cell.setAttribute('data-bs-content', content);
                cell.setAttribute('data-bs-html', 'true');
                cell.setAttribute('data-bs-placement', 'top');
                cell.setAttribute('data-bs-trigger', 'hover');

                // Enable the popover by adding the correct CSS classes and event listeners
                cell.classList.add('has-popover');

                // Remove any existing event listeners to avoid duplicates
                cell.removeEventListener('mouseenter', cell._salesPopoverMouseEnterHandler);
                cell.removeEventListener('mouseleave', cell._salesPopoverMouseLeaveHandler);

                // Create new event handlers
                cell._salesPopoverMouseEnterHandler = function() {
                    // Complete cleanup of any existing popover
                    const existingSalesPopover = bootstrap.Popover.getInstance(this);
                    if (existingSalesPopover) {
                        existingSalesPopover.dispose();
                    }
                    
                    // Remove any existing popover attributes that might interfere
                    this.removeAttribute('aria-describedby');
                    
                    // Verify all required attributes are present before creating popover
                    const title = this.getAttribute('data-bs-title');
                    const content = this.getAttribute('data-bs-content');
                    
                    if (!title || !content) {
                        console.warn('Missing required attributes for sales popover');
                        return;
                    }
                    
                    // Create a new instance and show it
                    try {
                        const newSalesPopover = new bootstrap.Popover(this, {
                            html: true,
                            sanitize: true,
                            placement: 'top',
                            trigger: 'hover',
                            customClass: 'tw-sales-popover'
                        });
                        newSalesPopover.show();
                    } catch (e) {
                        console.error('Error creating/showing sales popover:', e);
                    }
                };

                cell._salesPopoverMouseLeaveHandler = function() {
                    const salesPopoverInstance = bootstrap.Popover.getInstance(this);
                    if (salesPopoverInstance) {
                        setTimeout(() => {
                            salesPopoverInstance.hide();
                        }, 100); // Small delay to allow moving to the popover
                    }
                };

                // Add the new event listeners
                cell.addEventListener('mouseenter', cell._salesPopoverMouseEnterHandler);
                cell.addEventListener('mouseleave', cell._salesPopoverMouseLeaveHandler);
            }
        } catch (e) {
            console.error('Error parsing sales data JSON:', e, 'Data string was:', salesDataStr);
        }
    });

    // Initialize popovers on cells with data-stock attribute
    const stockCells = document.querySelectorAll('.stock-cell[data-stock]');
    stockCells.forEach(function(cell) {
        // Get stock data from the attribute
        let stockDataStr = cell.getAttribute('data-stock');

        // If the value is null or undefined, return early
        if (!stockDataStr) {
            return;
        }

        // Handle the case where the JSON might be double-encoded
        // Check if the string represents the literal word "null"
        if (stockDataStr === "null") {
            return; // No data to show
        }

        try {
            // Handle case where the JSON might be double-quoted (e.g., "[{\"prop\":\"val\"}]")
            // If the string starts and ends with quotes, parse it as a string first
            if (stockDataStr.startsWith('"') && stockDataStr.endsWith('"')) {
                // This means the JSON was stringified again, so we need to parse as string first
                stockDataStr = JSON.parse(stockDataStr);
            }

            const stockData = JSON.parse(stockDataStr);

            if (stockData && stockData.length > 0) {
                // Sort by SlotNum to ensure consistent order
                stockData.sort((a, b) => (a.SlotNum || 0) - (b.SlotNum || 0));

                let content = '<div class="text-start">';

                stockData.forEach(function(item, itemIndex) {

                    // Add a separator except for the first item
                    if (itemIndex > 0) {
                        content += '<hr class="my-1">';
                    }
                    const escStockName = twEscapeHtmlPopoverText(item.Product?.Name || item.ProductName || 'Нет товара');
                    const escSlotNum = twEscapeHtmlPopoverText(item.SlotNum != null ? item.SlotNum : '');
                    const escLoad = twEscapeHtmlPopoverText(item.CurrentLoad != null ? item.CurrentLoad : '');
                    content += '<div class="d-flex">' +
                        '<div class="tw-dashboard-popover-slot me-2">' + escSlotNum + '</div>' +
                        '<div class="me-3 flex-grow-1">' + escStockName + '</div>' +
                        '<div>' + escLoad + '</div>' +
                        '</div>';
                });

                content += '</div>';

                // Set the content and title attributes for Bootstrap to use
                cell.setAttribute('data-bs-title', 'Остатки');
                cell.setAttribute('data-bs-content', content);
                cell.setAttribute('data-bs-html', 'true');
                cell.setAttribute('data-bs-placement', 'top');
                cell.setAttribute('data-bs-trigger', 'hover');

                // Enable the popover by adding the correct CSS classes and event listeners
                cell.classList.add('has-popover');

                // Remove any existing event listeners to avoid duplicates
                cell.removeEventListener('mouseenter', cell._stockPopoverMouseEnterHandler);
                cell.removeEventListener('mouseleave', cell._stockPopoverMouseLeaveHandler);

                // Create new event handlers
                cell._stockPopoverMouseEnterHandler = function() {
                    // Check if a popover instance already exists and dispose it
                    const existingStockPopover = bootstrap.Popover.getInstance(this);
                    if (existingStockPopover) {
                        existingStockPopover.dispose();
                    }
                    // Verify all required attributes are present before creating popover
                    const title = this.getAttribute('data-bs-title');
                    const content = this.getAttribute('data-bs-content');
                    
                    if (!title || !content) {
                        console.warn('Missing required attributes for stock popover');
                        return;
                    }
                    
                    // Create a new instance and show it
                    const newStockPopover = new bootstrap.Popover(this, {
                        html: true,
                        sanitize: true,
                        placement: 'top',
                        trigger: 'hover'
                    });
                    newStockPopover.show();
                };

                cell._stockPopoverMouseLeaveHandler = function() {
                    const stockPopoverInstance = bootstrap.Popover.getInstance(this);
                    if (stockPopoverInstance) {
                        setTimeout(() => {
                            stockPopoverInstance.hide();
                        }, 100); // Small delay to allow moving to the popover
                    }
                };

                // Add the new event listeners
                cell.addEventListener('mouseenter', cell._stockPopoverMouseEnterHandler);
                cell.addEventListener('mouseleave', cell._stockPopoverMouseLeaveHandler);
            }
        } catch (e) {
            console.error('Error parsing stock data JSON:', e, 'Data string was:', stockDataStr);
        }
    });

    // Initialize popovers on cells with not-dispensing product list (dashboard "Не выдает" column)
    const notDispensingPopoverCells = document.querySelectorAll('.not-dispensing-cell[data-not-dispensing-items]');
    notDispensingPopoverCells.forEach(function(cell) {
        let itemsDataStr = cell.getAttribute('data-not-dispensing-items');

        if (!itemsDataStr || itemsDataStr === 'null') {
            return;
        }

        try {
            if (itemsDataStr.startsWith('"') && itemsDataStr.endsWith('"')) {
                itemsDataStr = JSON.parse(itemsDataStr);
            }

            const itemsData = JSON.parse(itemsDataStr);

            if (itemsData && itemsData.length > 0) {
                itemsData.sort(function(a, b) {
                    return (a.SlotNum || 0) - (b.SlotNum || 0);
                });

                let content = '<div class="tw-not-dispensing-popover-grid text-start">';

                itemsData.forEach(function(item, itemIndex) {
                    if (itemIndex > 0) {
                        content += '<hr class="tw-not-dispensing-popover-separator my-1">';
                    }
                    const rawName = item.ProductName || item.productName || 'Нет товара';
                    const escapedName = twEscapeHtmlPopoverText(rawName);
                    const slotNum = item.SlotNum != null ? item.SlotNum : (item.slotNum != null ? item.slotNum : '');
                    const rawStartTime = item.StartTime != null ? item.StartTime : item.startTime;
                    const formattedStartTime = twFormatDashboardPopoverDateTime(rawStartTime);
                    const escapedStartTime = twEscapeHtmlPopoverText(formattedStartTime);
                    content += '<div class="tw-not-dispensing-popover-slot">' + slotNum + '</div>' +
                        '<div class="tw-not-dispensing-popover-time">' + escapedStartTime + '</div>' +
                        '<div class="tw-not-dispensing-popover-name">' + escapedName + '</div>';
                });

                content += '</div>';

                cell.setAttribute('data-bs-title', 'Не выдает');
                cell.setAttribute('data-bs-content', content);
                cell.setAttribute('data-bs-html', 'true');
                cell.setAttribute('data-bs-placement', 'top');
                cell.setAttribute('data-bs-trigger', 'hover');

                cell.classList.add('has-popover');

                cell.removeEventListener('mouseenter', cell._notDispensingPopoverMouseEnterHandler);
                cell.removeEventListener('mouseleave', cell._notDispensingPopoverMouseLeaveHandler);

                cell._notDispensingPopoverMouseEnterHandler = function() {
                    const existing = bootstrap.Popover.getInstance(this);
                    if (existing) {
                        existing.dispose();
                    }
                    const title = this.getAttribute('data-bs-title');
                    const popoverContent = this.getAttribute('data-bs-content');

                    if (!title || !popoverContent) {
                        console.warn('Missing required attributes for not-dispensing popover');
                        return;
                    }

                    const newPopover = new bootstrap.Popover(this, {
                        html: true,
                        sanitize: true,
                        placement: 'top',
                        trigger: 'hover',
                        customClass: 'tw-not-dispensing-popover'
                    });
                    newPopover.show();
                };

                cell._notDispensingPopoverMouseLeaveHandler = function() {
                    const inst = bootstrap.Popover.getInstance(this);
                    if (inst) {
                        setTimeout(function() {
                            inst.hide();
                        }, 100);
                    }
                };

                cell.addEventListener('mouseenter', cell._notDispensingPopoverMouseEnterHandler);
                cell.addEventListener('mouseleave', cell._notDispensingPopoverMouseLeaveHandler);
            }
        } catch (e) {
            console.error('Error parsing not-dispensing items JSON:', e, 'Data string was:', itemsDataStr);
        }
    });

    // Initialize popovers for cells with GSM operator and quality information (Connection column)
    const connectionCells = document.querySelectorAll('.col-last-online[data-gsm-operator][data-gsm-quality]');

    connectionCells.forEach(function(cell) {
        // Get GSM operator and quality from the attributes
        let gsmOperator = cell.getAttribute('data-gsm-operator');
        let gsmQuality = cell.getAttribute('data-gsm-quality');
        
        // Decode HTML entities if present
        if (gsmOperator && gsmOperator.includes('&quot;')) {
            gsmOperator = gsmOperator.replace(/&quot;/g, '"');
        }
        if (gsmQuality && gsmQuality.includes('&quot;')) {
            gsmQuality = gsmQuality.replace(/&quot;/g, '"');
        }
        
        const escGsmOp = twEscapeHtmlPopoverText(gsmOperator || 'Неизвестно');
        const escGsmQ = twEscapeHtmlPopoverText(gsmQuality || 'Неизвестно');
        let content = '<div class="text-start">';
        content += '<div class="d-flex"><div class="me-3" style="width: 120px;">Сотовый оператор:</div><div>' + escGsmOp + '</div></div>';
        content += '<div class="d-flex"><div class="me-3" style="width: 120px;">Качество сигнала:</div><div>' + escGsmQ + '</div></div>';
        content += '</div>';

        // Set the content and title attributes for Bootstrap to use
        cell.setAttribute('data-bs-title', 'Связь');
        cell.setAttribute('data-bs-content', content);
        cell.setAttribute('data-bs-html', 'true');
        cell.setAttribute('data-bs-placement', 'top');
        cell.setAttribute('data-bs-trigger', 'hover');

        // Enable the popover by adding the correct CSS classes and event listeners
        cell.classList.add('has-popover');

        // Remove any existing event listeners to avoid duplicates
        cell.removeEventListener('mouseenter', cell._connectionPopoverMouseEnterHandler);
        cell.removeEventListener('mouseleave', cell._connectionPopoverMouseLeaveHandler);

        // Create new event handlers
        cell._connectionPopoverMouseEnterHandler = function() {
            // Check if a popover instance already exists and dispose it
            const existingConnectionPopover = bootstrap.Popover.getInstance(this);
            if (existingConnectionPopover) {
                existingConnectionPopover.dispose();
            }
            
            // Verify all required attributes are present before creating popover
            const title = this.getAttribute('data-bs-title');
            const content = this.getAttribute('data-bs-content');
            
            if (!title || !content) {
                console.warn('Missing required attributes for connection popover');
                return;
            }
            
            // Create a new instance and show it
            const newConnectionPopover = new bootstrap.Popover(this, {
                html: true,
                sanitize: true,
                placement: 'top',
                trigger: 'hover'
            });
            newConnectionPopover.show();
        };

        cell._connectionPopoverMouseLeaveHandler = function() {
            const connectionPopoverInstance = bootstrap.Popover.getInstance(this);
            if (connectionPopoverInstance) {
                setTimeout(() => {
                    connectionPopoverInstance.hide();
                }, 100); // Small delay to allow moving to the popover
            }
        };

        // Add the new event listeners
        cell.addEventListener('mouseenter', cell._connectionPopoverMouseEnterHandler);
        cell.addEventListener('mouseleave', cell._connectionPopoverMouseLeaveHandler);
    });

}

// Initialize popovers on initial page load
$(document).ready(function() {
    initializePopovers();
    initializeSpecialPopovers();
});

// Cleanup popovers when leaving the page to prevent memory leaks
window.addEventListener('beforeunload', function() {
    disposeSpecialPopovers();
});

// Also make these functions available globally so other modules can call them
window.initializeSpecialPopovers = initializeSpecialPopovers;
window.disposeSpecialPopovers = disposeSpecialPopovers;
window.convertTitlesToPopovers = convertTitlesToPopovers;
window.initializePopovers = initializePopovers;

})();
(function () {
    'use strict';
    if (window.__twFormsModuleInit) return;
    window.__twFormsModuleInit = true;

function twSanitizeAjaxMain(html) {
    if (typeof html !== 'string' || !window.extractMainContentFromAjaxHtml) return html;
    return window.extractMainContentFromAjaxHtml(html);
}

/** Verbose form diagnostics (URLs, serialized bodies, full responses) — only when explicitly enabled. */
function twFormsDebug() {
    if (typeof window !== 'undefined' && window.__TW_DEBUG_FORMS__ && console.log) {
        console.log.apply(console, arguments);
    }
}

function twFormsReparseUnobtrusiveMain() {
    if (typeof window.twParseUnobtrusiveMainContent === 'function') {
        try {
            window.twParseUnobtrusiveMainContent();
        } catch (reparseErr) {
            /* navigation.js may load after forms.js */
        }
    }
}

/** После SPA-редиректа — тот же chrome, что у ajax-навигации (stock/sales popovers и т.п.). */
function twFormsInitAfterSpaContentReplace() {
    if (typeof window.twSpaInitChromeWidgets === 'function') {
        try {
            window.twSpaInitChromeWidgets();
        } catch (e) { /* ignore */ }
    } else {
        if (typeof initializePopovers === 'function') {
            initializePopovers();
        }
        if (typeof initializeSpecialPopovers === 'function') {
            initializeSpecialPopovers();
        }
    }
    if (typeof window.twBootSpaTableChrome === 'function') {
        try {
            window.twBootSpaTableChrome();
        } catch (e) { /* ignore */ }
    }
    if (typeof window.bootDashboardCards === 'function') {
        try {
            window.bootDashboardCards();
        } catch (e) { /* ignore */ }
    }
}

// General handler for non-AJAX forms - only for forms that explicitly have data-spa="false"
$('form[data-spa="false"]').on('submit', function (e) {
    twFormsDebug('=== NON-AJAX FORM SUBMIT (data-spa="false") ===');
    
    const $form = $(this);
    const submitter = e.originalEvent && e.originalEvent.submitter ? e.originalEvent.submitter : null;
    const $submitBtn = submitter ? $(submitter) : $form.find('button[type="submit"]').first();
    if ($form[0].checkValidity()) {
        $submitBtn.prop('disabled', true);
        // Проверяем, это форма логина или нет
        const nonAjaxAction = ($form.attr('action') || '').toLowerCase();
        if (nonAjaxAction.includes('login')) {
            $submitBtn.html('<span class="spinner-border spinner-border-sm me-2" role="status"></span>Вход...');
        } else {
            $submitBtn.html('<span class="spinner-border spinner-border-sm me-2" role="status"></span>Сохранение...');
        }
    }
});

// Note: token management is handled server-side (TelemetryWeb). JS should not read/set auth cookies.

$(document).ready(function() {
    twFormsDebug('=== FORMS DEBUG: Page Load ===', $('form').length, 'form(s)');
});

// Handle form submissions for SPA
// Variable to track if a request is currently in progress
let requestInProgress = false;
// Variable to track current AJAX request for menu navigation
let currentMenuRequest = null;

$(document).on('submit', 'form[data-spa="true"], form:not([data-spa="false"])', function (e) {
    twFormsDebug('=== FORM SUBMIT DETECTED ===', 'inMainContent:', $(this).closest('#main-content').length > 0);
    
    const $form = $(this);
    const submitter = e.originalEvent && e.originalEvent.submitter ? e.originalEvent.submitter : null;
    const $clickedSubmitBtn = submitter ? $(submitter) : $form.find('button[type="submit"]').first();
    const rawAction = $clickedSubmitBtn.attr('formaction') || $form.attr('action');
    const action = (rawAction != null && String(rawAction).trim() !== '')
        ? String(rawAction).trim()
        : (window.location.pathname + window.location.search);
    const method = $clickedSubmitBtn.attr('formmethod') || $form.attr('method') || 'GET';
    // Mark that this form will be handled by AJAX to prevent the general handler from running
    $form.data('ajax-submit', true);
    // Only handle forms that are on the main content area
    if ($form.closest('#main-content').length) {
        // For login forms, we need to handle the authentication state change.
        // Критерий должен быть строгим, чтобы формы восстановления/сброса не попадали в login-AJAX ветку.
        const authFormType = ($form.attr('data-auth-form') || '').toLowerCase();
        const normalizedAction = action.toLowerCase();
        const isLoginAction = /\/account\/login(?:[/?#]|$)/.test(normalizedAction);
        const isLoginAuthForm = authFormType === 'login' || isLoginAction;
        if (isLoginAuthForm) {
            e.preventDefault();
            // Prevent multiple submissions
            if (requestInProgress) {
                return false;
            }
            requestInProgress = true;
            // Disable submit button to prevent double submission
            const $submitBtn = $clickedSubmitBtn.length ? $clickedSubmitBtn : $form.find('button[type="submit"]');
            const originalBtnText = $submitBtn.html();
            $submitBtn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-2" role="status"></span>Вход...');
            twFormsDebug('=== LOGIN FORM SUBMIT ===', 'path:', (action || '').split('?')[0]);
            $.ajax({
                url: action,
                type: method,
                data: $form.serialize(),
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                xhrFields: { withCredentials: true },
                beforeSend: function(xhr, settings) {
                    // Authorization handled server-side via cookies; no client-side header.
                },
                success: function (response) {
                    twFormsDebug('=== LOGIN FORM SUCCESS ===', typeof response);
                    
                    // Check if it's a JSON response (successful login) or HTML (validation errors)
                    // JSON responses will be objects, HTML responses will be strings
                    if (typeof response === 'object' && response !== null && response.success) {
                        twFormsDebug('SUCCESSFUL LOGIN DETECTED');
                        // Полная перезагрузка целевой страницы: cookie уходит надёжно, нет XHR к Home
                        // (IsApiRequest → 401) и нет зависания оверлея из-за ошибок в SPA-цепочке.
                        const redirectAfterLogin = response.redirectUrl || '/';
                        $('.login-container').hide();
                        $('body').append(`
                        <div class="loading-overlay">
                            <div class="spinner-border" role="status">
                            <span class="visually-hidden">Загрузка...</span>
                            </div>
                        </div>
                        `);
                        window.location.assign(redirectAfterLogin);
                    } else {
                        // Validation errors or HTML response - update main content with the login form showing errors
                        twFormsDebug('VALIDATION ERRORS OR HTML RESPONSE DETECTED', typeof response);
                        
                        // Check if the response is JSON (indicating notification messages)
                        if (typeof response === 'object' && response !== null) {
                            // Process any notifications
                            processNotifications(response);

                            // If we have HTML content in the response data, use it
                            if (response.data) {
                                // Update main content with the new content
                                $('#main-content').html(twSanitizeAjaxMain(response.data));
                                if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                                    window.twExecuteInlineScriptsInContainer($('#main-content'));
                                }
                                twFormsReparseUnobtrusiveMain();
                                // Hide the sidebar if it was added
                                $('#sidebar').hide();
                                // Also remove it from DOM to reset to original state
                                $('#sidebar').remove();
                                // Reset the content margin
                                $('#content').css('margin-left', '0');
                            }
                        } else {
                            // Regular HTML response - this is likely validation errors from server
                            twFormsDebug('HTML RESPONSE DETECTED - LIKELY VALIDATION ERRORS');
                            // Update main content with the new content
                            $('#main-content').html(twSanitizeAjaxMain(response));
                            if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                                window.twExecuteInlineScriptsInContainer($('#main-content'));
                            }
                            twFormsReparseUnobtrusiveMain();
                            // Hide the sidebar if it was added
                            $('#sidebar').hide();
                            // Also remove it from DOM to reset to original state
                            $('#sidebar').remove();
                            // Reset the content margin
                            $('#content').css('margin-left', '0');
                        }

                        // Check if the response contains validation errors for login forms
                        // If it does, the submit button needs to be re-enabled
                        const validationErrors = $('#main-content').find('.text-danger, .alert.alert-danger, .field-validation-error, .validation-summary-errors');
                        twFormsDebug('Validation error markers count:', validationErrors.length);
                        
                        if (validationErrors.length > 0) {
                            twFormsDebug('REGULAR VALIDATION ERRORS FOUND - RE-ENABLING BUTTON');
                            // Re-enable the submit button and restore original text
                            $submitBtn.prop('disabled', false).html(originalBtnText);
                            requestInProgress = false;
                        }
                    }
                },
                error: function (xhr, status, error) {
                twFormsDebug('=== LOGIN AJAX ERROR ===', xhr.status, status, error);
                if (xhr.status >= 400) {
                    console.error('FORM SUBMISSION ERROR:', xhr.status, (action || '').split('?')[0]);
                }
                
                if (xhr.status === 401) {
                    // Token refresh should be handled server-side automatically.
                    // If we still get 401, it means refresh token has also expired.
                    // Show notification and redirect to login after a short delay
                    if (typeof showNotification === 'function') {
                        showNotification('error', 'Сессия истекла. Пожалуйста, войдите снова.');
                    } else {
                        // Fallback if showNotification is not available
                        alert('Сессия истекла. Пожалуйста, войдите снова.');
                    }
                    setTimeout(() => {
                        window.location.href = '/Account/Login';
                    }, 1000);
                } else if (xhr.status === 0 || xhr.status === 502 || xhr.status === 503 || xhr.status === 504) {
                    // Сервер недоступен или ошибка шлюза
                    const serverErrorMessage = `
                        <div class="alert alert-warning" role="alert">
                            <h5><i class="fas fa-exclamation-triangle me-2"></i>Сервер недоступен</h5>
                            <p>Не удалось подключиться к серверу. Пожалуйста, проверьте подключение к интернету и попробуйте снова позже.</p>
                            <div class="mt-3">
                                <button type="button" class="btn btn-primary me-2" onclick="location.reload()">Обновить страницу</button>
                                <button type="button" class="btn btn-secondary" onclick="history.back()">Вернуться назад</button>
                            </div>
                        </div>
                    `;
                    $('#main-content').html(serverErrorMessage);
                } else if (xhr.status === 400) {
                    // Ошибка валидации или бизнес-логика - это может быть дубликат email, неверные данные и т.д.
                    // Показываем стандартную страницу с ошибками валидации
                    // Позволяем серверу вернуть HTML с ошибками валидации
                    twFormsDebug('VALIDATION ERROR DETECTED - Status 400');
                    
                    // Проверяем, является ли ответ HTML (содержит теги формы)
                    const isHtmlResponse = xhr.responseText && xhr.responseText.includes('<form');
                    
                    if (isHtmlResponse) {
                        // HTML ответ - отображаем как есть (с формой и ошибками)
                        twFormsDebug('HTML response detected - updating content with form');
                        $('#main-content').html(twSanitizeAjaxMain(xhr.responseText));
                        if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                            window.twExecuteInlineScriptsInContainer($('#main-content'));
                        }
                        twFormsReparseUnobtrusiveMain();
                        // Повторно инициализируем dropdowns и скрипты
                        initializePopovers();
                        initializeEnhancedDropdowns();
                        
                        // Проверяем наличие ошибок валидации и разблокируем кнопку
                        const validationErrors = $('#main-content').find('.text-danger, .alert.alert-danger, .field-validation-error, .validation-summary-errors');
                        twFormsDebug('Found validation errors:', validationErrors.length);
                        
                        if (validationErrors.length > 0) {
                            twFormsDebug('VALIDATION ERRORS FOUND - RE-ENABLING BUTTON');
                            $submitBtn.prop('disabled', false).html(originalBtnText);
                            requestInProgress = false;
                        } else {
                            twFormsDebug('NO VALIDATION ERRORS FOUND - CHECKING FOR OTHER ERROR INDICATORS');
                            // Ищем другие индикаторы ошибок
                            const errorIndicators = $('#main-content').find('.alert, .error, .text-danger');
                            if (errorIndicators.length > 0) {
                                $submitBtn.prop('disabled', false).html(originalBtnText);
                                requestInProgress = false;
                            }
                        }
                    } else {
                        // JSON ответ - возможно ошибка API
                        twFormsDebug('JSON response detected - showing generic error');
                        const validationErrorMessage = `
                            <div class="alert alert-info" role="alert">
                                <h5><i class="fas fa-info-circle me-2"></i>Ошибка валидации</h5>
                                <p>Проверьте правильность введенных данных и попробуйте снова.</p>
                                <div class="mt-3">
                                    <button type="button" class="btn btn-primary me-2" onclick="location.reload()">Обновить страницу</button>
                                    <button type="button" class="btn btn-secondary" onclick="history.back()">Вернуться назад</button>
                                </div>
                            </div>
                        `;
                        $('#main-content').html(validationErrorMessage);
                        $submitBtn.prop('disabled', false).html(originalBtnText);
                        requestInProgress = false;
                    }
                } else {
                    // Другие ошибки сервера (5xx, исключая обработанные выше)
                    const generalErrorMessage = `
                        <div class="alert alert-danger" role="alert">
                            <h5><i class="fas fa-exclamation-triangle me-2"></i>Произошла ошибка сервера</h5>
                            <p>Произошла ошибка при обработке запроса. Код ошибки: ${xhr.status || 'неизвестен'}</p>
                            <div class="mt-3">
                                <button type="button" class="btn btn-primary me-2" onclick="location.reload()">Обновить страницу</button>
                                <button type="button" class="btn btn-secondary" onclick="history.back()">Вернуться назад</button>
                            </div>
                        </div>
                    `;
                    $('#main-content').html(generalErrorMessage);
                    $submitBtn.prop('disabled', false).html(originalBtnText);
                    requestInProgress = false;
                }   
                },
                complete: function() {
                    $('#main-content').find('.form-submit-loading-overlay').remove();
                    $submitBtn.prop('disabled', false).html(originalBtnText);
                    requestInProgress = false;
                }
            });
            return; // Exit early for login forms
        }
        twFormsDebug('=== PROCESSING NON-LOGIN FORM ===');
        // Клиентская валидация (unobtrusive) до preventDefault: иначе отправка «отменена», а подготовка формы уже могла бы выполниться в других слушателях
        if ($.fn.validate && typeof $form.valid === 'function') {
            try {
                if (!$form.valid()) {
                    twFormsDebug('=== CLIENT VALIDATION FAILED — AJAX submit skipped ===');
                    return false;
                }
            } catch (validationErr) {
                console.warn('Form validation check:', validationErr);
            }
        }
        twFormsDebug('Preventing default submission');
        e.preventDefault();
        // Prevent multiple submissions for non-login forms too
        if (requestInProgress) {
            twFormsDebug('Request already in progress, ignoring');
            return false;
        }
        requestInProgress = true;
        twFormsDebug('Starting AJAX request path:', (action || '').split('?')[0]);
        // Disable submit button to prevent double submission
        const $submitBtn = $clickedSubmitBtn.length ? $clickedSubmitBtn : $form.find('button[type="submit"]');
        const originalBtnText = $submitBtn.html();
        $submitBtn.prop('disabled', true);
        // Show loading state after the form (not replacing it)
        $('#main-content').append('<div class="form-submit-loading-overlay text-center py-5"><div class="spinner-border" role="status"><span class="visually-hidden">Загрузка...</span></div></div>');
        twFormsDebug('Sending AJAX request...');
        if (typeof window.twPreparePointOfSaleFormForSubmit === 'function') {
            try {
                window.twPreparePointOfSaleFormForSubmit($form[0]);
            } catch (prepErr) {
                console.warn('twPreparePointOfSaleFormForSubmit:', prepErr);
            }
        }
        $.ajax({
            url: action,
            type: method,
            data: $form.serialize(),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            xhrFields: { withCredentials: true },
            beforeSend: function(xhr, settings) {
                // Authorization handled server-side via cookies; no client-side header.
            },
            success: function (data) {
                $('#main-content').find('.form-submit-loading-overlay').remove();
                twFormsDebug('=== AJAX SUCCESS ===', typeof data, data && typeof data === 'object' ? Object.keys(data) : '');
                // Check if the response is JSON (indicating notification messages)
                if (typeof data === 'object' && data !== null) {
                    // Показать уведомления без автоперехода из notifications.js:
                    // здесь редирект обрабатывается отдельно в forms.js.
                    const notificationPayload = (data && data.redirectUrl)
                        ? Object.assign({}, data, { redirectUrl: null })
                        : data;
                    processNotifications(notificationPayload);

                    // Check for direct table update (htmlRows) - no page reload needed
                    if (data.htmlRows !== undefined) {
                        const tableBody = document.getElementById('tableBody');
                        if (tableBody) {
                            if (!data.htmlRows || data.htmlRows.trim() === '') {
                                const table = tableBody.closest('table');
                                const colspan = table ? table.querySelectorAll('th').length : 9;
                                tableBody.innerHTML = `<tr><td colspan="${colspan}" class="text-center">Нет данных для отображения</td></tr>`;
                            } else {
                                tableBody.innerHTML = data.htmlRows;
                            }
                            // Update pagination if provided
                            if (data.totalCount !== undefined) {
                                const paginationInfo = document.getElementById('paginationInfo');
                                if (paginationInfo) {
                                    const totalPages = data.totalPages || 1;
                                    paginationInfo.innerHTML = `<small class="text-muted">Страница ${data.pageNumber || 1} из ${totalPages} (Всего записей: ${data.totalCount})</small>`;
                                }
                            }
                            // Reinitialize popovers
                            if (window.initializeSpecialPopovers) {
                                setTimeout(() => { try { window.initializeSpecialPopovers(); } catch (e) {} }, 300);
                            }
                        }
                        return; // Don't redirect, table is already updated
                    }

                    // Переход только при явном успехе (иначе возможен «тихий» уход в список при неоднозначном JSON)
                    if (data.redirectUrl && data.success === true) {
                        twFormsDebug('Redirecting after save');
                        var targetUrl = (typeof window.twNormalizeNavigationUrl === 'function')
                            ? window.twNormalizeNavigationUrl(data.redirectUrl)
                            : data.redirectUrl;
                        // Используем AJAX навигацию вместо прямого перенаправления для предотвращения зависания
                        $.get(targetUrl, function(responseData) {
                            // Check if the response is JSON (indicating notification messages)
                            if (typeof responseData === 'object' && responseData !== null) {
                                // Process any notifications
                                processNotifications(responseData);

                                // If we have HTML content in the response data, use it
                                if (responseData.data) {
                                    // Update main content with the new content
                                    var twFragRedirect = twSanitizeAjaxMain(responseData.data);
                                    $('#main-content').html(twFragRedirect);
                                    if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                                        window.twExecuteInlineScriptsInContainer($('#main-content'));
                                    }
                                    if (typeof window.updatePageTitleFromContent === 'function') {
                                        window.updatePageTitleFromContent(twFragRedirect);
                                    }
                                    twFormsReparseUnobtrusiveMain();

                                    // Reinitialize chrome (generic + special popovers) after content is loaded
                                    twFormsInitAfterSpaContentReplace();
                                }
                            } else {
                                // Regular HTML response
                                // Update main content with the new content
                                var twFragRedirectHtml = twSanitizeAjaxMain(responseData);
                                $('#main-content').html(twFragRedirectHtml);
                                if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                                    window.twExecuteInlineScriptsInContainer($('#main-content'));
                                }
                                if (typeof window.updatePageTitleFromContent === 'function') {
                                    window.updatePageTitleFromContent(twFragRedirectHtml);
                                }
                                twFormsReparseUnobtrusiveMain();

                                // Reinitialize chrome after content is loaded
                                twFormsInitAfterSpaContentReplace();
                            }
                            
                            history.pushState({
                                url: targetUrl,
                                previousUrl: window.location.pathname + window.location.search
                            }, '', targetUrl);
                            
                            // Update active menu item
                            updateActiveMenuItem(targetUrl);
                            
                            // Ensure special popovers (остаток) after history update
                            twFormsInitAfterSpaContentReplace();
                        }).fail(function() {
                            twFormsDebug('AJAX navigation failed, falling back to full redirect');
                            window.location.href = targetUrl;
                        });
                        return;
                    }

                    // Если есть HTML формы (при ошибке сервер возвращает форму) — подставляем; пустой data не подменяем, чтобы не очищать страницу
                    if (data.data && typeof data.data === 'string' && data.data.trim().length > 0) {
                        var twFragFormData = twSanitizeAjaxMain(data.data);
                        $('#main-content').html(twFragFormData);
                        if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                            window.twExecuteInlineScriptsInContainer($('#main-content'));
                        }
                        if (typeof window.updatePageTitleFromContent === 'function') {
                            window.updatePageTitleFromContent(twFragFormData);
                        }
                        twFormsReparseUnobtrusiveMain();
                        // Update active menu item based on the current route
                        updateActiveMenuItem(window.location.pathname + window.location.search);

                        // Reinitialize popovers after content is loaded
                        initializePopovers();
                    }
                } else {
                    // Regular HTML response — не подменять контент полной страницей (<!DOCTYPE/html), иначе форма теряется
                    var htmlStr = typeof data === 'string' ? data : '';
                    var isFullDocument = /^\s*<!DOCTYPE\s/i.test(htmlStr) || /^\s*<html\s/i.test(htmlStr);
                    if (isFullDocument) {
                        // Сервер вернул полную страницу вместо JSON (запрос не распознан как AJAX) — форму не трогаем, показываем ошибку
                        if (typeof window.showNotification === 'function') {
                            window.showNotification('error', 'Ошибка при сохранении. Ответ сервера в неожиданном формате. Проверьте данные и повторите попытку.', 'Ошибка');
                        }
                    }
                    if (!isFullDocument && htmlStr.length > 0) {
                        var twFragHtmlResp = twSanitizeAjaxMain(data);
                        $('#main-content').html(twFragHtmlResp);
                        // Remove login page attribute if present (to reset default layout behavior)
                        if (document.body.getAttribute('data-page') === 'login') {
                            document.body.removeAttribute('data-page');
                        }
                        if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                            window.twExecuteInlineScriptsInContainer($('#main-content'));
                        }
                        if (typeof window.updatePageTitleFromContent === 'function') {
                            window.updatePageTitleFromContent(twFragHtmlResp);
                        }
                        twFormsReparseUnobtrusiveMain();
                        updateActiveMenuItem(window.location.pathname + window.location.search);
                        ensureLayout();
                        initializePopovers();
                    }
                }

                // Check if the response contains validation errors
                // If it does, the submit button needs to be re-enabled
                if ($('#main-content').find('.text-danger, .alert.alert-danger, .field-validation-error, .validation-summary-errors').length > 0) {
                    // Re-enable the submit button and restore original text
                    $submitBtn.prop('disabled', false).html(originalBtnText);
                    requestInProgress = false;
                }
            },
            error: function (xhr, status, error) {
                twFormsDebug('=== AJAX ERROR ===', xhr.status, status, error);
                if (xhr.status === 401) {
                    // Token refresh should be handled server-side automatically.
                    // If we still get 401, it means refresh token has also expired.
                    // Show notification and redirect to login after a short delay
                    if (typeof showNotification === 'function') {
                        showNotification('error', 'Сессия истекла. Пожалуйста, войдите снова.');
                    } else {
                        // Fallback if showNotification is not available
                        alert('Сессия истекла. Пожалуйста, войдите снова.');
                    }
                    setTimeout(() => {
                        window.location.href = '/Account/Login';
                    }, 1000);
                } else {
                    // Не заменяем форму: только уведомление и снятие индикатора загрузки. Данные пользователя остаются на месте.
                    $('#main-content').find('.form-submit-loading-overlay').remove();
                    var msg = 'Ошибка при сохранении.';
                    if (xhr.responseText) {
                        try {
                            const parsed = JSON.parse(xhr.responseText);
                            if (parsed.notifications && parsed.notifications.length > 0) {
                                var n = parsed.notifications.find(function (x) { return x.type === 'error'; }) || parsed.notifications[0];
                                msg = n.message || msg;
                                if (typeof window.showNotification === 'function') {
                                    window.showNotification('error', msg, n.title || 'Ошибка');
                                } else { alert(msg); }
                                return;
                            }
                            if (parsed.detail) msg += ' ' + parsed.detail;
                            else if (parsed.message) msg += ' ' + parsed.message;
                            else if (parsed.error) msg += ' ' + parsed.error;
                        } catch (e) {
                            var text = xhr.responseText.trim();
                            if (text.length > 0 && text.length < 500 && !/^<[a-z]/i.test(text))
                                msg += ' ' + text;
                        }
                    }
                    msg = msg.replace(/</g, '&lt;').substring(0, 500);
                    if (typeof window.showNotification === 'function') {
                        window.showNotification('error', msg, 'Ошибка');
                    } else {
                        alert(msg);
                    }
                }
            },
            complete: function() {
                $('#main-content').find('.form-submit-loading-overlay').remove();
                $submitBtn.prop('disabled', false).html(originalBtnText);
                requestInProgress = false;
            }
        });
    }
});

})();
/**
 * Нормализация пути для сопоставления с пунктами меню (SPA / updateActiveMenuItem).
 * Загружается до navigation.js.
 */
(function () {
    'use strict';
    if (typeof window.twNormalizePathForMenu === 'function') {
        return;
    }
    window.twNormalizePathForMenu = function (path) {
        if (!path) {
            return '';
        }
        var p = path.toLowerCase().split('?')[0].split('#')[0];
        if (p.length > 1 && p.endsWith('/')) {
            p = p.slice(0, -1);
        }
        return p;
    };
})();

/**
 * Канонические URL списочных страниц vs AJAX-endpoints *TableRows.
 * Синхронизировать с ListPageUrlHelper.cs при изменении маппинга.
 */
(function () {
    'use strict';
    if (window.__twListPageUrlModuleInit) {
        return;
    }
    window.__twListPageUrlModuleInit = true;

    /** @type {Record<string, Record<string, string>>} */
    var TABLE_ACTION_TO_LIST_PATH = {
        home: {
            getdashboardtablerows: '/',
            getpointsofsalewithterminalsfortable: '/'
        },
        pointofsales: {
            getpointofsalestablerows: '/PointOfSales'
        },
        terminals: {
            getterminalstablerows: '/Terminals'
        },
        products: {
            getproductstablerows: '/Products'
        },
        machinemodels: {
            getmachinemodelstablerows: '/MachineModels'
        },
        groups: {
            getgroupstablerows: '/Groups'
        },
        groupitems: {
            getgroupitemstablerows: '/GroupItems'
        },
        machinestatus: {
            getmachinestatustablerows: '/MachineStatus'
        },
        events: {
            geteventstablerows: '/Events'
        },
        vendistatransactions: {
            getvendistatransactionstablerows: '/VendistaTransactions'
        },
        machines: {
            getmachinestablerows: '/Machines'
        },
        users: {
            getuserstablerows: '/Users'
        },
        owners: {
            getownerstablerows: '/Owners'
        },
        sales: {
            gettablerows: '/Sales',
            getpointofsalereporttablerows: '/Sales/PointOfSaleReport',
            getproductreporttablerows: '/Sales/ProductReport'
        },
        servicehistory: {
            getservicehistorytablerows: '/ServiceHistory/Index'
        },
        terminalposhistory: {
            gettablerows: '/TerminalPosHistory',
            getterminalposhistorytablerows: '/TerminalPosHistory'
        },
        shipmentplanning: {
            getshipmentplanningtablerows: '/ShipmentPlanning'
        },
        plannedshipments: {
            getplannedshipmentstablerows: '/PlannedShipments'
        },
        capsulesizes: {
            getcapsulesizestablerows: '/CapsuleSizes'
        },
        digitalkassas: {
            getdigitalkassastablerows: '/DigitalKassas'
        },
        fiscalreceipts: {
            getfiscalreceiptstablerows: '/FiscalReceipts'
        },
        repairtypes: {
            getrepairtypestablerows: '/RepairTypes'
        },
        backgroundtasks: {
            gettablerows: '/BackgroundTasks'
        }
    };

    var TABLE_ROWS_ACTION_RE = /^get[a-z0-9]*tablerows$/i;

    function normalizeKey(s) {
        return (s || '').toString().trim().toLowerCase();
    }

    function parsePathAndQuery(url) {
        var raw = (url || '').toString().trim();
        if (!raw) {
            return { pathname: '', search: '' };
        }
        var pathPart = raw;
        var search = '';
        var q = raw.indexOf('?');
        if (q >= 0) {
            pathPart = raw.substring(0, q);
            search = raw.substring(q);
        }
        var hash = pathPart.indexOf('#');
        if (hash >= 0) {
            pathPart = pathPart.substring(0, hash);
        }
        if (pathPart.indexOf('://') >= 0) {
            try {
                var u = new URL(pathPart + search, window.location.origin);
                return { pathname: u.pathname || '', search: u.search || '' };
            } catch (e) {
                return { pathname: pathPart, search: search };
            }
        }
        if (pathPart.charAt(0) !== '/') {
            pathPart = '/' + pathPart;
        }
        return { pathname: pathPart, search: search };
    }

    function pathSegments(pathname) {
        return (pathname || '').split('/').filter(function (p) {
            return p !== '';
        });
    }

    /**
     * Второй сегмент — action вида Get*TableRows (AJAX-данные таблицы, не страница списка).
     */
    window.twIsTableDataApiPath = function (pathname) {
        var parts = pathSegments(pathname);
        if (parts.length < 2) {
            return false;
        }
        var action = parts[1];
        return TABLE_ROWS_ACTION_RE.test(action) || normalizeKey(action) === 'gettablerows';
    };

    window.twMapTableActionToListPath = function (controller, action) {
        var c = normalizeKey(controller);
        var a = normalizeKey(action);
        if (!c || !a) {
            return null;
        }
        var byController = TABLE_ACTION_TO_LIST_PATH[c];
        if (!byController) {
            return null;
        }
        return byController[a] || null;
    };

    function listPathFromPathname(pathname) {
        var parts = pathSegments(pathname);
        if (parts.length < 2) {
            return null;
        }
        return window.twMapTableActionToListPath(parts[0], parts[1]);
    }

    window.twBuildListPageUrl = function (controller, action, queryString) {
        var base = window.twMapTableActionToListPath(controller, action);
        if (!base) {
            var parsed = parsePathAndQuery(window.location.pathname + (window.location.search || ''));
            if (window.twIsTableDataApiPath(parsed.pathname)) {
                base = listPathFromPathname(parsed.pathname);
            }
            if (!base) {
                base = parsed.pathname || '/';
            }
        }
        var q = (queryString || '').toString().trim();
        if (q && q.charAt(0) === '?') {
            return base + q;
        }
        if (q) {
            return base + '?' + q;
        }
        return base;
    };

    window.twNormalizeNavigationUrl = function (url) {
        var parsed = parsePathAndQuery(url);
        if (!parsed.pathname) {
            return url || '/';
        }
        if (!window.twIsTableDataApiPath(parsed.pathname)) {
            return parsed.pathname + (parsed.search || '');
        }
        var listPath = listPathFromPathname(parsed.pathname);
        if (!listPath) {
            return parsed.pathname + (parsed.search || '');
        }
        return listPath + (parsed.search || '');
    };

    window.twIsDashboardListPagePath = function (pathname) {
        var p = (pathname || '').toLowerCase().split('?')[0].split('#')[0];
        if (p.length > 1 && p.endsWith('/')) {
            p = p.slice(0, -1);
        }
        if (window.twIsTableDataApiPath(p)) {
            return false;
        }
        return p === '/' || p === '/home' || p === '/home/index';
    };

    function normalizeCardGroupFilterValue(raw) {
        var v = (raw || '').toString().trim();
        if (!v || v === '0') {
            return null;
        }
        if (v.indexOf('eq:') === 0 || v.indexOf('in:') === 0) {
            return v;
        }
        return 'eq:' + v;
    }

    function readPersistedCardGroupItem1() {
        if (typeof window.twPersistCardGroupItem1 === 'function') {
            return window.twPersistCardGroupItem1();
        }
        return window.__twPersistedCardGroupItem1 || null;
    }

    /**
     * In-memory источник filter.CardGroupItem1 между операциями таблицы и карточек.
     * @param {string|null|undefined} [raw] — без аргумента: чтение; null/'' — сброс; иначе запись.
     * @returns {string|null}
     */
    window.twPersistCardGroupItem1 = function (raw) {
        if (arguments.length === 0) {
            return window.__twPersistedCardGroupItem1 || null;
        }
        if (raw === null || raw === undefined || raw === '') {
            window.__twPersistedCardGroupItem1 = null;
            return null;
        }
        var normalized = normalizeCardGroupFilterValue(raw);
        window.__twPersistedCardGroupItem1 = normalized;
        return normalized;
    };

    /** Читает filter.CardGroupItem1 только из data-selected-value (SSR pin или выбор в dashboard-cards.js). */
    window.twReadCardGroupItem1FromDom = function () {
        var el = document.getElementById('topGroupDropdownContainer');
        if (!el) {
            return null;
        }
        var dataVal = (el.getAttribute('data-selected-value') || '').trim();
        return normalizeCardGroupFilterValue(dataVal);
    };

    /**
     * Текущее значение filter.CardGroupItem1: URL, затем in-memory persist (явный выбор пользователя).
     * @returns {string|null} например "eq:45"
     */
    window.twGetCardGroupItem1FilterParam = function () {
        try {
            var fromUrl = new URLSearchParams(window.location.search || '').get('filter.CardGroupItem1');
            if (fromUrl) {
                return normalizeCardGroupFilterValue(fromUrl);
            }
        } catch (e) {
            /* ignore */
        }
        return readPersistedCardGroupItem1();
    };

    /**
     * Добавляет/удаляет filter.CardGroupItem1 в каноническом URL списка (главная).
     */
    window.twMergeCardGroupItem1IntoListPageUrl = function (pathWithQuery) {
        if (!pathWithQuery) {
            return pathWithQuery;
        }
        var parsed = parsePathAndQuery(pathWithQuery);
        var pathname = parsed.pathname || '/';
        var onDashboard = window.twIsDashboardListPagePath(pathname);
        if (!onDashboard && !document.getElementById('topGroupDropdownContainer')) {
            return pathWithQuery;
        }
        try {
            var queryPart = parsed.search && parsed.search.charAt(0) === '?'
                ? parsed.search.substring(1)
                : (parsed.search || '');
            var next = new URLSearchParams(queryPart);
            var incomingExplicit = next.has('filter.CardGroupItem1');
            var incoming = incomingExplicit
                ? normalizeCardGroupFilterValue(next.get('filter.CardGroupItem1'))
                : null;
            var persisted = readPersistedCardGroupItem1();
            var cardValue = incoming || persisted;
            if (cardValue) {
                next.set('filter.CardGroupItem1', cardValue);
            } else if (document.getElementById('topGroupDropdownContainer')) {
                next.delete('filter.CardGroupItem1');
            }
            var nextQuery = next.toString();
            return nextQuery ? pathname + '?' + nextQuery : pathname;
        } catch (e) {
            console.warn('twMergeCardGroupItem1IntoListPageUrl skipped', e);
            return pathWithQuery;
        }
    };

    /**
     * Синхронизирует __twPersistedCardGroupItem1 с query (только URL; без DOM).
     */
    window.twInitPersistedCardGroupItem1FromPage = function () {
        try {
            var fromUrl = new URLSearchParams(window.location.search || '').get('filter.CardGroupItem1');
            if (fromUrl) {
                window.twPersistCardGroupItem1(fromUrl);
                return;
            }
        } catch (e) {
            /* ignore */
        }
        window.twPersistCardGroupItem1(null);
    };
})();

(function () {
    'use strict';
    if (window.__twNavigationModuleInit) return;
    window.__twNavigationModuleInit = true;

function sanitizeAjaxMainHtml(html) {
    if (typeof html !== 'string' || !window.extractMainContentFromAjaxHtml) return html;
    return window.extractMainContentFromAjaxHtml(html);
}

/** После SPA-подмены #main-content — клиентская валидация на новых формах (jQuery unobtrusive). */
function twParseUnobtrusiveMainContent() {
    try {
        if (!window.jQuery || !window.jQuery.validator || !window.jQuery.validator.unobtrusive ||
            typeof window.jQuery.validator.unobtrusive.parse !== 'function') {
            return;
        }
        var $main = window.jQuery('#main-content');
        if (!$main.length) {
            return;
        }
        $main.find('form').each(function () {
            var $f = window.jQuery(this);
            $f.removeData('validator');
            $f.removeData('unobtrusiveValidation');
        });
        window.jQuery.validator.unobtrusive.parse('#main-content');
    } catch (e) {
        console.warn('twParseUnobtrusiveMainContent:', e);
    }
}

/**
 * После twLoadPosFormClientCatalog: общая часть Create/Edit (слоты, цены, подсветка) + специфика Edit.
 * Полная загрузка Edit вызывает это из Razor; SPA — через runPosFormDependentInitializers после опционального Create-refill.
 */
function runPosEditPageClientBootAfterCatalog() {
    if (typeof window.initializePointOfSaleCreateEditFragment === 'function') {
        try {
            window.initializePointOfSaleCreateEditFragment();
        } catch (e) {
            console.error('initializePointOfSaleCreateEditFragment failed', e);
        }
    }
    if (typeof window.bootPointOfSaleEditCorrectionAndPrices === 'function') {
        window.bootPointOfSaleEditCorrectionAndPrices();
    } else if (typeof window.initializePointOfSaleEditCorrectionAndPrices === 'function') {
        window.initializePointOfSaleEditCorrectionAndPrices();
    }
    if (typeof window.initializePricesOnLoad === 'function') {
        try {
            window.initializePricesOnLoad();
        } catch (e) {
            console.warn('initializePricesOnLoad:', e);
        }
    }
}

window.twRunPosEditPageClientBootAfterCatalog = runPosEditPageClientBootAfterCatalog;

function runPosFormDependentInitializers() {
    if (typeof window.bootPointOfSalesCreateRefill === 'function') {
        window.bootPointOfSalesCreateRefill();
    }
    runPosEditPageClientBootAfterCatalog();
}

/** Cache-busting query (?v=…) как у layout-скриптов с asp-append-version. */
function twJsModuleScriptQuerySuffix() {
    var nodes = document.getElementsByTagName('script');
    for (var i = 0; i < nodes.length; i++) {
        var src = nodes[i].getAttribute('src');
        if (!src) {
            continue;
        }
        var m = src.match(/\/js\/modules\/[^?]+\.js(\?[^#]*)?$/i);
        if (m && m[1]) {
            return m[1];
        }
    }
    return '';
}

function twJsModulesUrl(relativeFileName) {
    return '/js/modules/' + relativeFileName + twJsModuleScriptQuerySuffix();
}

var __twPosFormScriptsQueue = [];
var __twPosFormScriptsLoading = false;

function twDrainPosFormScriptWaiters() {
    var q = __twPosFormScriptsQueue.splice(0);
    for (var i = 0; i < q.length; i++) {
        try {
            q[i]();
        } catch (e) {
            console.warn('twEnsurePosFormScripts waiter', e);
        }
    }
}

/**
 * SPA: pointofsale-common / form-handler больше не в _Layout — подгружаем при форме ТТ в #main-content.
 * Полная загрузка страницы: скрипты в @section Scripts Create/Edit.
 */
function twEnsurePosFormScripts(done) {
    var cb = typeof done === 'function' ? done : function () {};
    if (!document.querySelector('#main-content form[action*="/PointOfSales/"]')) {
        cb();
        return;
    }
    if (window.__twPointOfSaleCommonModuleInit && window.__twPointOfSaleFormHandlerModuleInit && window.__twPointOfSalesEditModuleInit && window.__twServiceDateValidationModuleInit) {
        cb();
        return;
    }
    __twPosFormScriptsQueue.push(cb);
    if (__twPosFormScriptsLoading) {
        return;
    }
    __twPosFormScriptsLoading = true;

    var commonUrl = twJsModulesUrl('pointofsale-common.js');
    var formUrl = twJsModulesUrl('pointofsale-form-handler.js');
    // pointofsales-edit.js содержит делегированный обработчик замочка остатка (.toggle-load-edit).
    // Без подгрузки на SPA замочек оживал только после F5 (скрипт был лишь в @section Scripts).
    var editUrl = twJsModulesUrl('pointofsales-edit.js');
    var serviceDateUrl = twJsModulesUrl('service-date-validation.js');

    function logFail(name) {
        return function () {
            console.error('twEnsurePosFormScripts: failed to load', name);
        };
    }

    $.getScript(commonUrl).fail(logFail('pointofsale-common.js')).always(function () {
        $.getScript(formUrl).fail(logFail('pointofsale-form-handler.js')).always(function () {
            $.getScript(editUrl).fail(logFail('pointofsales-edit.js')).always(function () {
                $.getScript(serviceDateUrl).fail(logFail('service-date-validation.js')).always(function () {
                    __twPosFormScriptsLoading = false;
                    twDrainPosFormScriptWaiters();
                });
            });
        });
    });
}

window.twEnsurePosFormScripts = twEnsurePosFormScripts;

function maybeRunPosFormInitializersWithCatalog() {
    if (!document.querySelector('#main-content form[action*="/PointOfSales/"]')) {
        return;
    }
    twEnsurePosFormScripts(function () {
        if (typeof window.twLoadPosFormClientCatalog === 'function') {
            window.twLoadPosFormClientCatalog(runPosFormDependentInitializers);
        } else {
            runPosFormDependentInitializers();
        }
    });
}

// Store previous page URL for back navigation
let previousPageUrl = null;
let currentMenuRequest = null;

var twNavSpinnerHtml = '<div class="text-center py-5"><div class="spinner-border" role="status"><span class="visually-hidden">Загрузка...</span></div></div>';

/** Повторные лёгкие инициализаторы после SPA (см. tryRunPostAjaxInitializers). Экспоненциальная задержка между попытками. */
var TwSpaPostInitRetry = { maxAttempts: 6, initialDelayMs: 120, maxDelayMs: 1800 };

function loadExternalScriptOnce(src) {
    if (!src) return;
    if (!window.__twLoadedExternalScripts) {
        window.__twLoadedExternalScripts = {};
    }
    if (window.__twLoadedExternalScripts[src]) {
        return;
    }

    // If script is already present in the main layout, treat it as loaded.
    var alreadyLoadedInLayout = document.querySelector('head script[src="' + src + '"], body > script[src="' + src + '"]');
    if (alreadyLoadedInLayout) {
        window.__twLoadedExternalScripts[src] = true;
        return;
    }

    $.getScript(src)
        .done(function() {
            window.__twLoadedExternalScripts[src] = true;
        })
        .fail(function() {
            console.error('Failed to load external script:', src);
        });
}

/** После подстановки #main-content: списочные страницы + главная (таблица дашборда). Скрипты страниц не перезагружаются — конфиг из URL и обработчики заново. */
function twBootSpaTableChrome() {
    if (typeof window.bootListPagesFromCurrentLocation === 'function') {
        window.bootListPagesFromCurrentLocation();
    }
    var p = (window.location.pathname || '').toLowerCase();
    var dashboardLike = (typeof window.twIsDashboardListPagePath === 'function')
        ? window.twIsDashboardListPagePath(p)
        : (p === '/' || p === '/home' || p.endsWith('/home/index') || /^\/home\/?$/.test(p));
    if (dashboardLike && typeof window.bootDashboardTableFromLocation === 'function') {
        window.bootDashboardTableFromLocation();
    }
    if (typeof window.twInitPersistedCardGroupItem1FromPage === 'function') {
        window.twInitPersistedCardGroupItem1FromPage();
    }
    if (typeof window.twReinitializeSortStateFromUrl === 'function') {
        window.twReinitializeSortStateFromUrl();
    }
}

function twSpaInitChromeWidgets() {
    if (typeof initializePopovers === 'function') {
        initializePopovers();
    }
    if (typeof initializeSpecialPopovers === 'function') {
        initializeSpecialPopovers();
    }
    if (typeof initializeFilters === 'function') {
        initializeFilters();
    }
}

function applyAjaxNavigationSuccess(data, url) {
    if (typeof data === 'object' && data !== null) {
        processNotifications(data);
        if (data.data) {
            var navFragmentFromJson = sanitizeAjaxMainHtml(data.data);
            $('#main-content').html(navFragmentFromJson);
            executeScriptsFromContent($('#main-content'));
            twParseUnobtrusiveMainContent();
            updatePageTitleFromContent(navFragmentFromJson);
            twSpaInitChromeWidgets();
            twBootSpaTableChrome();
        }
    } else {
        var navFragmentHtml = sanitizeAjaxMainHtml(data);
        $('#main-content').html(navFragmentHtml);
        if (document.body.getAttribute('data-page') === 'login') {
            document.body.removeAttribute('data-page');
        }
        executeScriptsFromContent($('#main-content'));
        twParseUnobtrusiveMainContent();
        updatePageTitleFromContent(navFragmentHtml);
        twSpaInitChromeWidgets();
        twBootSpaTableChrome();
    }

    // SPA race guard: scripts from injected partials may load slightly later than the first tick.
    // Retry lightweight initializers a few times to avoid "works only after F5".
    function tryRunPostAjaxInitializers(attempt) {
        twBootSpaTableChrome();
        if (typeof window.bootShipmentPlanning === 'function') {
            window.bootShipmentPlanning();
        } else if (typeof window.applyShipmentPlanningMinThresholdHighlight === 'function') {
            window.applyShipmentPlanningMinThresholdHighlight();
        }
        if (typeof window.bootMachineStatus === 'function') {
            window.bootMachineStatus();
        }
        if (typeof window.bootPointOfSaleReport === 'function') {
            window.bootPointOfSaleReport();
        }
        if (typeof window.bootProductReport === 'function') {
            window.bootProductReport();
        }
        if (typeof window.bootDashboardCards === 'function') {
            window.bootDashboardCards();
        }
        if (typeof window.bootTelegramBindingPage === 'function') {
            window.bootTelegramBindingPage();
        }
        maybeRunPosFormInitializersWithCatalog();
        if (typeof window.initializeServiceHistoryPointOfSalePage === 'function') {
            window.initializeServiceHistoryPointOfSalePage();
        }

        if (attempt >= TwSpaPostInitRetry.maxAttempts) {
            return;
        }

        var posFormExists = !!document.querySelector('#main-content form[action*="/PointOfSales/"]');
        var posInitMissing = posFormExists && (
            typeof window.initializePointOfSaleCreateEditFragment !== 'function'
            || (document.getElementById('editPointOfSaleForm') && typeof window.bootPointOfSaleEditCorrectionAndPrices !== 'function' && typeof window.initializePointOfSaleEditCorrectionAndPrices !== 'function')
        );
        var reportBootMissing = !!document.querySelector('#main-content .sales-report-table')
            && (
                (document.getElementById('breakdownCheckbox') && typeof window.bootPointOfSaleReport !== 'function')
                || (document.getElementById('groupByPriceCheckbox') && typeof window.bootProductReport !== 'function')
            );
        var serviceHistoryVisitHoverMissing = !!document.querySelector('#main-content tr[data-visit-block-key]')
            && typeof window.initServiceHistoryVisitBlockHover !== 'function';
        if (posInitMissing || reportBootMissing || serviceHistoryVisitHoverMissing) {
            var nextDelay = Math.min(
                TwSpaPostInitRetry.maxDelayMs,
                TwSpaPostInitRetry.initialDelayMs * Math.pow(2, attempt)
            );
            setTimeout(function () { tryRunPostAjaxInitializers(attempt + 1); }, nextDelay);
        }
    }
    setTimeout(function () { tryRunPostAjaxInitializers(0); }, TwSpaPostInitRetry.initialDelayMs);

    updateActiveMenuItem(url);
    ensureLayout();
    if (typeof window.twSyncSidebarFooterClearance === 'function') {
        window.twSyncSidebarFooterClearance();
        requestAnimationFrame(function () {
            window.twSyncSidebarFooterClearance();
        });
    }
}

function ajaxNavigation401Retry(url) {
    if (typeof refreshToken === 'function') {
        refreshToken().then(refreshSuccess => {
            if (refreshSuccess) {
                $.ajax({
                    url: url,
                    type: 'GET',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    xhrFields: { withCredentials: true },
                    success: function (data) {
                        var retryFrag = '';
                        if (typeof data === 'object' && data !== null) {
                            processNotifications(data);
                            if (data.data) {
                                retryFrag = sanitizeAjaxMainHtml(data.data);
                                $('#main-content').html(retryFrag);
                                executeScriptsFromContent($('#main-content'));
                                initializeComponentsAfterLoad();
                            }
                        } else {
                            retryFrag = sanitizeAjaxMainHtml(data);
                            $('#main-content').html(retryFrag);
                            if (document.body.getAttribute('data-page') === 'login') {
                                document.body.removeAttribute('data-page');
                            }
                            executeScriptsFromContent($('#main-content'));
                            initializeComponentsAfterLoad();
                        }
                        if (retryFrag) {
                            updatePageTitleFromContent(retryFrag);
                        }
                        updateActiveMenuItem(url);
                        ensureLayout();
                    },
                    error: function () {
                        if (typeof showNotification === 'function') {
                            showNotification('error', 'Сессия истекла. Пожалуйста, войдите снова.');
                        } else {
                            alert('Сессия истекла. Пожалуйста, войдите снова.');
                        }
                        setTimeout(() => { window.location.href = '/Account/Login'; }, 1000);
                    }
                });
            } else {
                if (typeof showNotification === 'function') {
                    showNotification('error', 'Сессия истекла. Пожалуйста, войдите снова.');
                } else {
                    alert('Сессия истекла. Пожалуйста, войдите снова.');
                }
                setTimeout(() => { window.location.href = '/Account/Login'; }, 1000);
            }
        }).catch(function () {
            if (typeof showNotification === 'function') {
                showNotification('error', 'Сессия истекла. Пожалуйста, войдите снова.');
            } else {
                alert('Сессия истекла. Пожалуйста, войдите снова.');
            }
            setTimeout(() => { window.location.href = '/Account/Login'; }, 1000);
        });
    } else {
        if (typeof showNotification === 'function') {
            showNotification('error', 'Сессия истекла. Пожалуйста, войдите снова.');
        } else {
            alert('Сессия истекла. Пожалуйста, войдите снова.');
        }
        setTimeout(() => { window.location.href = '/Account/Login'; }, 1000);
    }
}

/** SPA: load #main-content via GET. pushState when options.pushState; optional spinner. */
function ajaxLoadMainContent(url, options) {
    options = options || {};
    var doPush = options.pushState === true;
    var showSpinner = options.showSpinner !== false;

    if (currentMenuRequest && currentMenuRequest.readyState !== 4) {
        currentMenuRequest.abort();
    }

    if (doPush) {
        previousPageUrl = window.location.pathname + window.location.search;
        history.pushState({ url: url, previousUrl: previousPageUrl }, '', url);
    }

    if (showSpinner) {
        $('#main-content').html(twNavSpinnerHtml);
    }

    currentMenuRequest = $.ajax({
        url: url,
        type: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        xhrFields: { withCredentials: true },
        success: function (data) {
            applyAjaxNavigationSuccess(data, url);
        },
        error: function (xhr) {
            if (xhr.statusText !== 'abort') {
                if (xhr.status === 401) {
                    ajaxNavigation401Retry(url);
                } else {
                    $('#main-content').html('<div class="alert alert-danger" role="alert">Ошибка загрузки страницы. Пожалуйста, попробуйте снова.</div>');
                }
            }
        }
    });
}

window.navigateAjax = function (url, options) {
    ajaxLoadMainContent(url, Object.assign({ pushState: true, showSpinner: true }, options || {}));
};

/** replaceState: sync list/dashboard URL with filters (preserve history.previousUrl when present). */
window.twReplaceHistoryForListPage = function (pathWithQuery) {
    try {
        if (!pathWithQuery || pathWithQuery.charAt(0) !== '/') {
            return;
        }
        var canonical = pathWithQuery;
        if (typeof window.twMergeCardGroupItem1IntoListPageUrl === 'function') {
            canonical = window.twMergeCardGroupItem1IntoListPageUrl(pathWithQuery);
        }
        var st = history.state || {};
        var prev = st.previousUrl;
        history.replaceState({
            url: canonical,
            previousUrl: prev !== undefined && prev !== null ? prev : (window.location.pathname + window.location.search)
        }, '', canonical);
    } catch (e) {
        console.warn('twReplaceHistoryForListPage', e);
    }
};

// Sidebar, #main-content, modals: same-origin SPA navigation
$(document).on('click', 'a.ajax-navigation', function (e) {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) {
        return;
    }
    const $this = $(this);
    if ($this.hasClass('dropdown-toggle')) {
        return;
    }
    const url = $this.attr('href');
    if (!url || url.charAt(0) !== '/') {
        return;
    }
    e.preventDefault();

    if ($this.closest('.components').length) {
        $('.components li').removeClass('active');
        $this.closest('li').addClass('active');
    }

    ajaxLoadMainContent(url, { pushState: true, showSpinner: true });
});

// Helper function to execute scripts from loaded content (без eval)
function executeScriptsFromContent(container) {
    if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
        window.twExecuteInlineScriptsInContainer(container);
    }
}

// Helper function to initialize components after content is loaded
function initializeComponentsAfterLoad() {
    twParseUnobtrusiveMainContent();
    twSpaInitChromeWidgets();
    twBootSpaTableChrome();
    if (typeof window.initEnhancedDropdowns === 'function') {
        window.initEnhancedDropdowns();
    }
    maybeRunPosFormInitializersWithCatalog();
    if (typeof window.initializeServiceHistoryPointOfSalePage === 'function') {
        window.initializeServiceHistoryPointOfSalePage();
    }
    if (typeof window.bootDashboardCards === 'function') {
        window.bootDashboardCards();
    }
    if (typeof window.bootTelegramBindingPage === 'function') {
        window.bootTelegramBindingPage();
    }
    // План отгрузки: подсветка строк по порогу без перезагрузки данных
    if (typeof window.bootShipmentPlanning === 'function') {
        window.bootShipmentPlanning();
    } else if (typeof window.applyShipmentPlanningMinThresholdHighlight === 'function') {
        window.applyShipmentPlanningMinThresholdHighlight();
    }
    if (typeof window.bootPointOfSaleReport === 'function') {
        window.bootPointOfSaleReport();
    }
    if (typeof window.bootProductReport === 'function') {
        window.bootProductReport();
    }
    if (typeof window.twSyncSidebarFooterClearance === 'function') {
        window.twSyncSidebarFooterClearance();
        requestAnimationFrame(function () {
            window.twSyncSidebarFooterClearance();
        });
    }
}

// Helper function to extract and update page title from loaded content
function updatePageTitleFromContent(content) {
    try {
        if (typeof content !== 'string' || content.trim() === '') {
            return;
        }
        var tempDiv = $('<div>').html(content);

        // 1) Explicit SPA page title from partial (see _TwPageTitleMeta.cshtml)
        var twMeta = tempDiv.find('meta[name="tw-page-title"]').attr('content');
        if (twMeta && String(twMeta).trim() !== '') {
            document.title = String(twMeta).trim() + ' - TelemetryWeb';
            return;
        }

        // 2) Full <title> inside fragment (rare for partials)
        var newTitle = tempDiv.find('title').text();
        if (newTitle && newTitle.trim() !== '') {
            document.title = newTitle.trim();
            return;
        }

        // 3) Legacy meta[name="title"]
        var metaTitle = tempDiv.find('meta[name="title"]').attr('content');
        if (metaTitle && String(metaTitle).trim() !== '') {
            document.title = String(metaTitle).trim() + ' - TelemetryWeb';
            return;
        }

        // 4) First heading outside <table> and outside modals (Excel export modal title must not win)
        var heading = tempDiv.find('h1, h2, h3, h4, h5, h6').filter(function () {
            var $t = $(this);
            if ($t.closest('table').length > 0) return false;
            if ($t.closest('.modal, [role="dialog"]').length > 0) return false;
            return true;
        }).first();
        var pageTitle = heading.length > 0 ? heading.text().trim() : '';

        if (pageTitle) {
            document.title = pageTitle + ' - TelemetryWeb';
        }
        // If nothing matched, keep existing document.title (e.g. small AJAX table fragment)
    } catch (e) {
        console.error('Error updating page title:', e);
        document.title = 'TelemetryWeb';
    }
}

window.updatePageTitleFromContent = updatePageTitleFromContent;

// Handle dropdown toggle clicks to prevent them from becoming active
$(document).on('click', '.components a.dropdown-toggle', function (e) {
    // Let Bootstrap handle the collapse/expand
    // Don't prevent default so Bootstrap can do its thing
    return;
});

function normalizePathForMenu(path) {
    if (typeof window.twNormalizePathForMenu === 'function') {
        return window.twNormalizePathForMenu(path);
    }
    if (!path) {
        return '';
    }
    var p = path.toLowerCase().split('?')[0].split('#')[0];
    if (p.length > 1 && p.endsWith('/')) {
        p = p.slice(0, -1);
    }
    return p;
}

function twMenuHrefMatchesController(hrefNorm, controllerName) {
    var controllerWithActionPattern = '/' + controllerName + '/';
    var ctrlBase = '/' + controllerName;
    return hrefNorm === ctrlBase ||
        hrefNorm.indexOf(ctrlBase + '/') === 0 ||
        hrefNorm.indexOf(controllerWithActionPattern) >= 0;
}

function twMenuTryExactControllerAction(controllerName, actionName, norm) {
    if (!controllerName || !actionName) {
        return null;
    }
    var exactTarget = norm('/' + controllerName + '/' + actionName);
    var found = null;
    $('.components a').each(function () {
        var rawHref = $(this).attr('href');
        if (!rawHref || rawHref.indexOf('#') === 0) {
            return;
        }
        if (norm(rawHref) === exactTarget) {
            found = $(this).closest('li');
            return false;
        }
    });
    return found;
}

function twMenuTryControllerHeuristic(controllerName, actionName, norm) {
    var found = null;
    $('.components a').each(function () {
        var rawHref = $(this).attr('href');
        if (!rawHref || rawHref.indexOf('#') === 0) {
            return;
        }
        var hrefNorm = norm(rawHref);
        if (!twMenuHrefMatchesController(hrefNorm, controllerName)) {
            return;
        }
        if (controllerName === 'sales') {
            if ((actionName === 'pointofsalereport' && hrefNorm.indexOf('pointofsalereport') >= 0) ||
                (actionName === 'productreport' && hrefNorm.indexOf('productreport') >= 0)) {
                found = $(this).closest('li');
                return false;
            }
            if (actionName !== 'pointofsalereport' && actionName !== 'productreport' &&
                hrefNorm.indexOf('pointofsalereport') < 0 && hrefNorm.indexOf('productreport') < 0) {
                found = $(this).closest('li');
                return false;
            }
        } else if (controllerName === 'shipmentplanning') {
            if (hrefNorm.indexOf('shipmentplanning') >= 0) {
                found = $(this).closest('li');
                return false;
            }
        } else {
            found = $(this).closest('li');
            return false;
        }
    });
    return found;
}

function twMenuTryHomeRoot(normalizedPath) {
    if (!(normalizedPath === '/' || normalizedPath === '/home' || normalizedPath === '/home/index')) {
        return null;
    }
    var $activeElement = null;
    $('.components a').each(function () {
        var href = ($(this).attr('href') || '').toLowerCase();
        if (href === '/home' || href === '/home/index') {
            $activeElement = $(this).closest('li');
            return false;
        }
    });
    if (!$activeElement || !$activeElement.length) {
        $('.components a:contains("Мониторинг"), .components a:contains("мониторинг")').each(function () {
            $activeElement = $(this).closest('li');
            return false;
        });
    }
    if (!$activeElement || !$activeElement.length) {
        $('.components a').each(function () {
            var href = $(this).attr('href');
            if (href) {
                var h = href.toLowerCase();
                if (h.indexOf('/home') >= 0 && h.indexOf('/home/') < 0) {
                    $activeElement = $(this).closest('li');
                    return false;
                }
            }
        });
    }
    return $activeElement;
}

function twMenuTryTerminalPosHistory(controllerName) {
    if (controllerName !== 'terminalposhistory') {
        return null;
    }
    var found = null;
    $('.components a').each(function () {
        var href = ($(this).attr('href') || '').toLowerCase();
        if (href && href.indexOf('/terminals') >= 0) {
            found = $(this).closest('li');
            return false;
        }
    });
    return found;
}

function twMenuApplyActiveAndExpand($activeElement) {
    if (!$activeElement || !$activeElement.length) {
        return;
    }
    $('.components li').removeClass('active');
    $activeElement.addClass('active');
    var $parentCollapse = $activeElement.closest('.collapse');
    if ($parentCollapse.length > 0) {
        $parentCollapse.addClass('show');
        var targetId = $parentCollapse.attr('id');
        if (targetId) {
            var $dropdownToggle = $('.dropdown-toggle[href="#' + targetId + '"]');
            if ($dropdownToggle.length === 0) {
                $dropdownToggle = $('.dropdown-toggle[data-bs-target="#' + targetId + '"]');
            }
            if ($dropdownToggle.length > 0) {
                $dropdownToggle.attr('aria-expanded', 'true');
            }
        }
    }
}

function updateActiveMenuItem(path) {
    var norm = normalizePathForMenu;
    var normalizedPath = norm(path);
    var pathParts = normalizedPath.split('/');
    var controllerName = pathParts.length > 1 ? pathParts[1] : '';
    var actionName = pathParts.length > 2 ? pathParts[2] : '';

    var $activeElement = twMenuTryExactControllerAction(controllerName, actionName, norm);
    var exactMatchFound = !!($activeElement && $activeElement.length);

    if (!exactMatchFound && controllerName) {
        $activeElement = twMenuTryControllerHeuristic(controllerName, actionName, norm);
        exactMatchFound = !!($activeElement && $activeElement.length);
    }

    if (!exactMatchFound) {
        $activeElement = twMenuTryHomeRoot(normalizedPath);
        exactMatchFound = !!($activeElement && $activeElement.length);
    }

    if (!exactMatchFound) {
        $activeElement = twMenuTryTerminalPosHistory(controllerName);
    }

    twMenuApplyActiveAndExpand($activeElement);
}

window.updateActiveMenuItem = updateActiveMenuItem;

// Function to ensure proper layout
function ensureLayout() {
    // margin/width задаёт site.css (#sidebar.collapsed + #content / #content.sidebar-collapsed).
    // Inline margin-left от прежнего ensureLayout «замораживал» 250px и ломал collapse.
    if ($('#sidebar').length > 0) {
        $('#content').css('margin-left', '');
    }
    if (typeof window.twSyncSidebarFooterClearance === 'function') {
        window.twSyncSidebarFooterClearance();
    }
}

window.ensureLayout = ensureLayout;

function isPublicAuthPagePath(path) {
    var normalizedPath = (path || '').toLowerCase();
    return normalizedPath === '/account/login'
        || normalizedPath === '/account/logout'
        || normalizedPath === '/account/forgotpassword'
        || normalizedPath === '/account/requestcodelogin'
        || normalizedPath === '/account/resetpassword'
        || normalizedPath === '/account/verifycodelogin';
}

// Update active menu item and ensure layout on initial page load
$(document).ready(function() {
    updateActiveMenuItem(window.location.pathname + window.location.search);
    ensureLayout();
});

// Handle browser back/forward buttons
window.addEventListener('popstate', function (event) {
    var targetUrl = window.location.pathname + (window.location.search || '');
    if (!targetUrl || targetUrl === '/') {
        targetUrl = '/Home';
    }

    if (event.state && event.state.url) {
        targetUrl = event.state.url;
        if (event.state.previousUrl) {
            previousPageUrl = event.state.previousUrl;
        }
    }

    if (typeof window.twNormalizeNavigationUrl === 'function') {
        targetUrl = window.twNormalizeNavigationUrl(targetUrl);
    }

    if (currentMenuRequest && currentMenuRequest.readyState !== 4) {
        currentMenuRequest.abort();
    }

    currentMenuRequest = $.ajax({
        url: targetUrl,
        type: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
        xhrFields: { withCredentials: true },
        success: function (data) {
            applyAjaxNavigationSuccess(data, targetUrl);
        },
        error: function (xhr, status, error) {
            if (xhr.status === 401) {
                // Show notification and redirect to login after a short delay
                if (typeof showNotification === 'function') {
                    showNotification('error', 'Сессия истекла. Пожалуйста, войдите снова.');
                } else {
                    // Fallback if showNotification is not available
                    alert('Сессия истекла. Пожалуйста, войдите снова.');
                }
                setTimeout(() => {
                    window.location.href = '/Account/Login';
                }, 1000);
            } else {
                // Fallback to full page load if AJAX fails
                window.location.href = targetUrl;
            }
        }
    });
});

// Handle initial page load for unauthorized access (без лишнего GET фрагмента главной при уже валидном SSR)
$(document).ready(function() {
    var path = window.location.pathname || '';
    if (isPublicAuthPagePath(path)) {
        return;
    }
    if ($('.navbar-brand').length === 0) {
        return;
    }
    var authAttr = document.body && document.body.getAttribute('data-tw-authenticated');
    if (authAttr === 'true') {
        updateActiveMenuItem(window.location.pathname + window.location.search);
        return;
    }
    $.ajax({
        url: '/Home/PingAuth',
        type: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
        success: function () {
            updateActiveMenuItem(window.location.pathname + window.location.search);
        },
        error: function (xhr) {
            if (xhr.status === 401) {
                window.location.href = '/Account/Login';
            }
        }
    });
});

window.twParseUnobtrusiveMainContent = twParseUnobtrusiveMainContent;
window.twSpaInitChromeWidgets = twSpaInitChromeWidgets;
window.twBootSpaTableChrome = twBootSpaTableChrome;

})();
(function () {
    'use strict';
    if (window.__twPaginationModuleInit) return;
    window.__twPaginationModuleInit = true;

function twSanitizeAjaxMainPagination(html) {
    if (typeof html !== 'string' || !window.extractMainContentFromAjaxHtml) return html;
    return window.extractMainContentFromAjaxHtml(html);
}

// Handle AJAX pagination clicks
$(document).on('click', '.ajax-pagination', function (e) {
    e.preventDefault();

    const $link = $(this);
    let controller = $link.data('controller');
    let action = $link.data('action');
    const pageNumber = $link.data('page-number');
    const pageSize = $link.data('page-size');

    // Groups/Edit page uses its own loadGroupItemsPage; skip here to avoid duplicate request
    if (controller === 'Groups' && action === 'GetGroupItemsPage') {
        return;
    }

    // Special handling for dashboard table pagination to avoid full page reloads
    if (controller === 'Home' && (action === 'GetPointsOfSaleWithTerminalsForTable' || action === 'GetDashboardTableRows')) {
        // Use the dashboard table's own update mechanism to just refresh the table content
        const tableFilters = window.collectDashboardFilters ? window.collectDashboardFilters() : (window.collectFilters ? window.collectFilters() : {});
        // Don't manually set page info here - let the updateTableData function handle it
        if (window.updateDashboardTableData) {
            window.updateDashboardTableData(tableFilters, pageNumber, pageSize);
        } else if (window.updateTableData) {
            // Fallback to general function if dashboard-specific is not available
            window.updateTableData(tableFilters, controller, action, pageNumber, pageSize);
        }
        return; // Exit early to prevent the general pagination logic
    }

    // For other controllers, collect filters and update table
    if (window.updateTableData && typeof window.updateTableData === 'function') {
        let tableFilters;
        tableFilters = window.collectListPagesFilters ? window.collectListPagesFilters() :
            window.collectDashboardFilters ? window.collectDashboardFilters() :
            window.collectFilters ? window.collectFilters() : {};
        if (window.currentSortField && window.currentSortDirection) {
            tableFilters.sortBy = window.currentSortField;
            tableFilters.sortAscending = window.currentSortDirection === 'asc' ? 'true' : 'false';
        }

        // Update table with new page number - use the controller and action from the link
        window.updateTableData(tableFilters, controller, action, pageNumber, pageSize);

        return; // Exit to prevent general pagination logic
    }

    // For pages that don't use the common modules but have controller/action in their URL structure
    // Determine controller and action from the current URL if not available in the link data
    if (!controller) {
        const pathParts = window.location.pathname.split('/').filter(part => part !== '');
        if (pathParts.length > 0) {
            controller = pathParts[0];  // First part after root is usually controller

            // Set default action based on controller for AJAX table updates
            switch(controller.toLowerCase()) {
                case 'pointofsales':
                    action = 'GetPointOfSalesTableRows';
                    break;
                case 'terminals':
                    action = 'GetTerminalsTableRows';
                    break;
                case 'products':
                    action = 'GetProductsTableRows';
                    break;
                case 'machinemodels':
                    action = 'GetMachineModelsTableRows';
                    break;
                case 'groups':
                    action = 'GetGroupsTableRows';
                    break;
                case 'machinestatus':
                    action = 'GetMachineStatusTableRows'; // Use the correct action for MachineStatus
                    break;
                case 'events':
                    action = 'GetEventsTableRows';
                    break;
                case 'vendistatransactions':
                    action = 'GetVendistaTransactionsTableRows';
                    break;
                case 'machines':
                    action = 'GetMachinesTableRows';
                    break;
                case 'users':
                    action = 'GetUsersTableRows'; // Use the correct action for Users
                    break;
                case 'owners':
                    action = 'GetOwnersTableRows';
                    break;
                case 'sales':
                    // Check if we're on specific sales report pages
                    if (window.location.pathname.toLowerCase().includes('pointofsalereport')) {
                        action = 'GetPointOfSaleReportTableRows';
                    } else if (window.location.pathname.toLowerCase().includes('productreport')) {
                        action = 'GetProductReportTableRows';
                    } else {
                        action = 'GetTableRows';
                    }
                    break;
                default:
                    // If we're still in the fallback section, try to determine based on URL pattern
                    action = 'Index'; // Default fallback
                    break;
            }
        }
    }

    // If we now have controller and action, use the common table update mechanism
    if (controller && action && window.updateTableData && typeof window.updateTableData === 'function') {
        // Collect filters which will include sort state
        const tableFilters = window.collectFilters ? window.collectFilters() : {};

        // Update table with new page number using the proper controller and action
        window.updateTableData(tableFilters, controller, action, pageNumber, pageSize);

        return; // Exit to prevent general pagination logic
    }

    // For pages that don't use the common modules, fall back to the general logic
    // Get the current URL parameters to preserve other filters and sort state
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);

    // Update page number and size in the parameters
    params.set('pageNumber', pageNumber);
    params.set('pageSize', pageSize);

    // Preserve sorting parameters from current state if they exist
    // For pages that use list-pages-search.js or dashboard-table.js, we need to get the current sort state
    let sortBy = params.get('sortBy') || '';
    let sortAscending = params.get('sortAscending') !== 'false';
    
    // First try to get from global state if available
    if (window.currentSortField && window.currentSortDirection !== undefined && window.currentSortDirection !== null) {
        sortBy = window.currentSortField;
        sortAscending = window.currentSortDirection === 'asc';
    } else {
        // Check if sort parameters are already in the URL
        const currentSortBy = params.get('sortBy');
        const currentSortAsc = params.get('sortAscending');

        if (currentSortBy !== null && currentSortAsc !== null) {
            // Sort parameters are already in the URL, so we don't need to detect them from DOM
            sortBy = currentSortBy;
            sortAscending = currentSortAsc !== 'false';
        } else {
            // Attempt to get from page context - especially important for list pages
            const sortColumn = document.querySelector('.sortable-column .sort-icon');
            if (sortColumn && (sortColumn.classList.contains('fa-sort-up') || sortColumn.classList.contains('fa-sort-down'))) {
                // Find the parent sortable column to get the data-sort-field
                const sortableColumn = sortColumn.closest('.sortable-column');
                if (sortableColumn) {
                    const sortField = sortableColumn.getAttribute('data-sort-field');
                    if (sortField) {
                        sortBy = sortField;
                        sortAscending = sortColumn.classList.contains('fa-sort-up');
                    }
                }
            }
        }
    }
    
    // Always include sorting parameters if they exist
    if (sortBy) {
        params.set('sortBy', sortBy);
        params.set('sortAscending', sortAscending);
    }

    // Канонический URL страницы списка в адресной строке; данные — с API action
    const apiDataUrl = `/${controller}/${action}?${params.toString()}`;
    const listPageUrl = (typeof window.twBuildListPageUrl === 'function')
        ? window.twBuildListPageUrl(controller, action, params.toString())
        : apiDataUrl;

    // Show loading state in the table area specifically
    const $tableContainer = $link.closest('.card, .table-responsive, #main-content');
    if ($tableContainer.length > 0) {
        $tableContainer.html('<div class="text-center py-5"><div class="spinner-border" role="status"><span class="visually-hidden">Загрузка...</span></div></div>');
    } else {
        $('#main-content').html('<div class="text-center py-5"><div class="spinner-border" role="status"><span class="visually-hidden">Загрузка...</span></div></div>');
    }

    const previousListUrl = window.location.pathname + window.location.search;
    var canonicalListUrl = listPageUrl;
    if (typeof window.twMergeCardGroupItem1IntoListPageUrl === 'function') {
        canonicalListUrl = window.twMergeCardGroupItem1IntoListPageUrl(listPageUrl);
    }
    if (typeof window.twReplaceHistoryForListPage === 'function') {
        window.twReplaceHistoryForListPage(canonicalListUrl);
    } else {
        history.pushState({ url: canonicalListUrl, previousUrl: previousListUrl }, '', canonicalListUrl);
    }

    // Make AJAX request to get the updated content
    $.ajax({
        url: apiDataUrl,
        type: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
        success: function (data) {
            // Check if the response is JSON (indicating notification messages)
            if (typeof data === 'object' && data !== null) {
                // Process any notifications
                processNotifications(data);

                // If we have HTML content in the response data, use it
                if (data.data) {
                    // Update the table/container with the new content
                    var pagFragment = twSanitizeAjaxMainPagination(data.data);
                    if ($tableContainer.length > 0) {
                        $tableContainer.html(pagFragment);
                    } else {
                        $('#main-content').html(pagFragment);
                    }

                    var pagScriptRoot = $tableContainer.length > 0 ? $tableContainer : $('#main-content');
                    if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                        window.twExecuteInlineScriptsInContainer(pagScriptRoot);
                    }

                    if (typeof window.updatePageTitleFromContent === 'function') {
                        window.updatePageTitleFromContent(pagFragment);
                    }

                    twPaginationReinitUiAfterPartialLoad();
                }
            } else {
                // Regular HTML response
                // Update the table/container with the new content
                var pagHtml = twSanitizeAjaxMainPagination(data);
                if ($tableContainer.length > 0) {
                    $tableContainer.html(pagHtml);
                } else {
                        $('#main-content').html(pagHtml);
                }

                var pagHtmlScriptRoot = $tableContainer.length > 0 ? $tableContainer : $('#main-content');
                if (typeof window.twExecuteInlineScriptsInContainer === 'function') {
                    window.twExecuteInlineScriptsInContainer(pagHtmlScriptRoot);
                }

                if (typeof window.updatePageTitleFromContent === 'function') {
                    window.updatePageTitleFromContent(pagHtml);
                }

                twPaginationReinitUiAfterPartialLoad();
            }
        },
        error: function (xhr, status, error) {
            if (xhr.status === 401) {
                // If unauthorized, redirect to login
                window.location.href = '/Account/Login';
            } else {
                // Show error message in the table/container area
                if ($tableContainer.length > 0) {
                    $tableContainer.html('<div class="alert alert-danger" role="alert">Ошибка загрузки данных. Пожалуйста, попробуйте снова.</div>');
                } else {
                    $('#main-content').html('<div class="alert alert-danger" role="alert">Ошибка загрузки данных. Пожалуйста, попробуйте снова.</div>');
                }
            }
        }
    });
});

/** Один путь переинициализации UI после подстановки HTML пагинации (table-operations при наличии). */
function twPaginationReinitUiAfterPartialLoad() {
    if (typeof window.reinitializeBootstrapComponents === 'function') {
        window.reinitializeBootstrapComponents();
        return;
    }
    if (typeof window.initializePopovers === 'function') {
        window.initializePopovers();
    }
}

})();
/**
 * Enhanced Dropdown Combined Module
 * Комбинированный модуль enhanced dropdown со всеми компонентами
 */

// Конфигурация по умолчанию
window.DEFAULT_CONFIG = window.DEFAULT_CONFIG || {
    searchEnabled: true,
    maxVisibleItems: 10,
    pageSize: 10,
    initialLoadCount: 100,
    endpoint: null,
    type: null,
    searchField: 'Name',
    idField: 'Id',
    nameField: 'Name',
    sortBy: 'Name',
    sortAscending: true,
    delay: 300,
    minSearchLength: 1
};

/** Текст пункта dropdown без символа ✓ (selection только через .active). */
function twDropdownItemLabel(element) {
    if (!element) return '';
    const clone = element.cloneNode(true);
    clone.querySelectorAll('.dropdown-check').forEach(function(n) { n.remove(); });
    return clone.textContent.replace(/\u2713/g, '').replace(/\s+/g, ' ').trim();
}

// Ожидаем доступности jQuery перед инициализацией
(function() {
    'use strict';
    if (window.__twEnhancedDropdownCombinedModuleInit) return;
    window.__twEnhancedDropdownCombinedModuleInit = true;

    // Проверяем доступность jQuery, если недоступен - ждем
    function waitForJQuery() {
        if (typeof $ !== 'undefined') {
            console.log('Enhanced dropdown: jQuery now available, initializing...');
            initEnhancedDropdowns();
        } else {
            setTimeout(waitForJQuery, 50);
        }
    }
    
    function initEnhancedDropdownModule() {
        /** Удаляет только пробел U+0020 — паритет с Domain.SearchTextNormalization на бэкенде */
        function stripAsciiSpaces(str) {
            if (str == null || str === '') return '';
            return String(str).replace(/ /g, '');
        }

        // Кэш для данных dropdown для улучшения производительности
        window.dropdownCache = new Map();
        window.CACHE_DURATION = 15 * 60 * 1000; // 15 минут кэша для лучшей производительности

        /** Стабильная часть endpoint для кэша: type и filters.* без page/search/selected/sort. */
        window.normalizeDropdownEndpointForCache = function(endpoint) {
            if (!endpoint) return '';
            try {
                const url = new URL(endpoint, 'https://localhost');
                const volatile = new Set([
                    'pagenumber', 'pagesize', 'search', 'selected',
                    'sortby', 'sortascending', 'searchthreshold'
                ]);
                const stableEntries = [];
                url.searchParams.forEach((value, key) => {
                    const k = key.toLowerCase();
                    if (volatile.has(k)) return;
                    if (k === 'type' || k.startsWith('filters.') || k.startsWith('filter.')) {
                        stableEntries.push([key, value]);
                    }
                });
                stableEntries.sort((a, b) => a[0].localeCompare(b[0], undefined, { sensitivity: 'base' }));
                const stable = new URLSearchParams();
                stableEntries.forEach(([key, value]) => stable.append(key, value));
                const qs = stable.toString();
                return url.pathname + (qs ? `?${qs}` : '');
            } catch {
                return endpoint.split('?')[0];
            }
        };

        window.buildDropdownCacheParams = function(dropdown, effectivePageSize) {
            const params = {
                search: dropdown.searchTerm || '',
                pageNumber: String(dropdown.currentPage + 1),
                pageSize: String(effectivePageSize),
                sortBy: dropdown.config.sortBy || '',
                sortAscending: String(dropdown.config.sortAscending !== false)
            };
            if (dropdown.isMultiselect && dropdown.selectedValues && dropdown.selectedValues.size > 0) {
                params.selected = Array.from(dropdown.selectedValues).sort().join(',');
            } else {
                const initialValue = dropdown.initialValue != null ? String(dropdown.initialValue).trim() : '';
                if (initialValue && initialValue !== '0') {
                    params.selected = initialValue;
                }
            }
            return params;
        };

        // Вспомогательная функция для генерации ключа кэша
        window.generateCacheKey = function(normalizedBase, params) {
            const paramStr = new URLSearchParams(params).toString();
            if (!paramStr) return normalizedBase;
            const sep = normalizedBase.includes('?') ? '&' : '?';
            return `${normalizedBase}${sep}${paramStr}`;
        };

        // Функция получения кэшированных данных
        window.getCachedData = function(key) {
            const cached = window.dropdownCache.get(key);
            if (cached && (Date.now() - cached.timestamp) < window.CACHE_DURATION) {
                console.log('Enhanced dropdown: Returning cached data for', key);
                return cached.data;
            } else {
                if (cached) {
                    console.log('Enhanced dropdown: Cache expired for', key);
                    window.dropdownCache.delete(key);
                }
                return null;
            }
        };

        // Функция установки кэшированных данных
        window.setCachedData = function(key, data) {
            window.dropdownCache.set(key, {
                data: data,
                timestamp: Date.now()
            });
            console.log('Enhanced dropdown: Cached data for', key);
        };

        // Класс рендерера Enhanced Dropdown
        class EnhancedDropdownRenderer {
            constructor(dropdown) {
                this.dropdown = dropdown;
            }

            removeLoadMoreIndicators() {
                if (!this.dropdown.listContainer) return;
                this.dropdown.listContainer.querySelectorAll('li.load-more-row').forEach((li) => {
                    li.remove();
                });
            }

            renderItems(itemsToShow, appendMode = false, appendItemsOnly = null) {
                if (!this.dropdown.listContainer) return;
                const items = this.dropdown.allItems;
                const domItems = appendMode && appendItemsOnly && appendItemsOnly.length > 0
                    ? appendItemsOnly
                    : itemsToShow;
                // Удаляем пустые li элементы
                this.dropdown.listContainer.querySelectorAll('li:empty').forEach(li => {
                    console.log('Enhanced dropdown renderItems - removing empty li');
                    li.remove();
                });

                // Удаляем дубликаты по data-value только в appendMode (пагинация)
                if (appendMode) {
                    const seen = new Set();
                    this.dropdown.listContainer.querySelectorAll('li[data-value]').forEach(li => {
                        const value = li.getAttribute('data-value');
                        if (seen.has(value)) {
                            console.log('Enhanced dropdown renderItems - removing duplicate li with value:', value);
                            li.remove();
                        } else {
                            seen.add(value);
                        }
                    });
                }
                const currentFocus = document.activeElement;
                const isSearchInputFocused = currentFocus === this.dropdown.searchInput;

                // Сохраняем позицию курсора если поле поиска в фокусе
                let cursorPosition = null;
                if (isSearchInputFocused) {
                    cursorPosition = {
                        start: this.dropdown.searchInput.selectionStart,
                        end: this.dropdown.searchInput.selectionEnd,
                        direction: this.dropdown.searchInput.selectionDirection
                    };
                    console.log('Enhanced dropdown renderItems: Preserving cursor position:', cursorPosition);
                }

                // Всегда возвращаем фокус на поле поиска если он был в фокусе перед рендерингом
                if (isSearchInputFocused) {
                    requestAnimationFrame(() => {
                        this.dropdown.searchInput.focus();
                        // Немедленно восстанавливаем позицию курсора
                        if (cursorPosition && cursorPosition.start !== null && cursorPosition.end !== null) {
                            try {
                                this.dropdown.searchInput.setSelectionRange(cursorPosition.start, cursorPosition.end, cursorPosition.direction);
                                console.log('Enhanced dropdown renderItems: Cursor position restored successfully');
                            } catch (e) {
                                console.log('Enhanced dropdown renderItems: Failed to restore cursor position:', e);
                            }
                        }
                    });
                }

                // В режиме appendMode (пагинация), не очищаем существующие элементы, просто добавляем новые
                if (!appendMode) {
                    if (typeof this.dropdown.resetScrollForListReplace === 'function') {
                        this.dropdown.resetScrollForListReplace();
                    }
                    // Очищаем существующие элементы (кроме опции сброса)
                    const toRemove = this.dropdown.listContainer.querySelectorAll('li:not(.reset-option)');
                    toRemove.forEach(item => item.remove());
                }

                if (this.dropdown.isMultiselect) {
                    // MULTISELECT: render selected items FIRST (pinned with .active)
                    const selectedItems = Array.from(this.dropdown.selectedItemsMap.values());
                    selectedItems.forEach(item => {
                        const li = document.createElement('li');
                        const a = document.createElement('a');
                        a.className = 'dropdown-item active';
                        a.href = '#';
                        a.setAttribute('data-value', item.value);
                        a.setAttribute('data-enhanced-item', 'true');
                        a.textContent = item.text;
                        li.appendChild(a);
                        const resetOption = this.dropdown.listContainer.querySelector('.reset-option');
                        if (resetOption) {
                            this.dropdown.listContainer.insertBefore(li, resetOption.nextSibling);
                        } else {
                            this.dropdown.listContainer.insertBefore(li, this.dropdown.listContainer.firstChild);
                        }
                    });

                    // Render other items (excluding selected ones)
                    const otherItems = domItems.filter(item => {
                        const itemId = (item[this.dropdown.config.idField] || item.id || item.value)?.toString();
                        return itemId && !this.dropdown.selectedValues.has(itemId);
                    });

                    otherItems.forEach(item => {
                        const itemValue = item[this.dropdown.config.idField] || item.id || item.value;
                        const itemText = item[this.dropdown.config.nameField] || item.name || item.text || item.value || '';
                        if (itemValue !== undefined && itemValue !== null && itemText) {
                            const existingItem = this.dropdown.listContainer.querySelector(`[data-value="${itemValue}"]`);
                            if (!existingItem) {
                                const li = document.createElement('li');
                                const a = document.createElement('a');
                                a.className = 'dropdown-item';
                                a.href = '#';
                                a.setAttribute('data-value', itemValue);
                                a.setAttribute('data-enhanced-item', 'true');
                                a.textContent = itemText;
                                li.appendChild(a);

                                console.log('Enhanced dropdown renderItems - adding other li > a:', a.getAttribute('data-value'), a.textContent);

                                this.dropdown.listContainer.appendChild(li);
                            } else {
                                // Update .active class on existing item based on current selection state
                                const isSelected = this.dropdown.selectedValues.has(itemValue.toString());
                                if (isSelected) {
                                    existingItem.classList.add('active');
                                } else {
                                    existingItem.classList.remove('active');
                                }
                                console.log('Enhanced dropdown renderItems - updated existing item:', itemValue, 'active:', isSelected);
                            }
                        }
                    });
            } else if (this.dropdown.searchTerm && this.dropdown.searchTerm.length >= this.dropdown.config.minSearchLength && !appendMode && itemsToShow.length === 0) {
                // Показываем сообщение "Ничего не найдено" только если действительно нет результатов поиска
                const li = document.createElement('li');
                const a = document.createElement('a');
                a.className = 'dropdown-item text-muted disabled';
                a.href = '#';
                a.innerHTML = '<i class="bi bi-search"></i> Ничего не найдено';
                li.appendChild(a);
                
                console.log('Enhanced dropdown renderItems - adding no results li > a');
                
                this.dropdown.listContainer.appendChild(li);
            } else {
                    // NON-MULTISELECT: render all items normally
                    domItems.forEach(item => {
                        const itemValue = item[this.dropdown.config.idField] || item.id || item.value;
                        const itemText = item[this.dropdown.config.nameField] || item.name || item.text || item.value || '';
                        if (itemValue !== undefined && itemValue !== null && itemText) {
                            const existingItem = this.dropdown.listContainer.querySelector(`[data-value="${itemValue}"]`);
                            if (!existingItem) {
                                const li = document.createElement('li');
                                const a = document.createElement('a');
                                a.className = 'dropdown-item';
                                a.href = '#';
                                a.setAttribute('data-value', itemValue);
                                a.setAttribute('data-enhanced-item', 'true');
                                a.textContent = itemText;
                                li.appendChild(a);
                                this.dropdown.listContainer.appendChild(li);
                            }
                        }
                    });
            }

            // Всегда убираем устаревший индикатор (appendMode оставляет предыдущий в середине списка)
            this.removeLoadMoreIndicators();

            if (typeof this.dropdown.reconnectLoadMoreIfNeeded === 'function') {
                this.dropdown.reconnectLoadMoreIfNeeded();
            }
        }

        renderError(message) {
            // Очищаем существующие элементы
            const existingItems = this.dropdown.listContainer.querySelectorAll('.dropdown-item:not(.reset-option)');
            existingItems.forEach(item => item.remove());

            // Добавляем сообщение об ошибке
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.className = 'dropdown-item text-danger disabled';
            a.href = '#';
            a.innerHTML = `<i class="bi bi-exclamation-triangle"></i> ${message}`;
            li.appendChild(a);
            this.dropdown.listContainer.appendChild(li);
        }

        setLoading(isLoading) {
            if (!this.dropdown.loadingIndicator) return;
            
            if (isLoading) {
                this.dropdown.loadingIndicator.classList.remove('d-none');
                // Отключаем поле поиска во время загрузки только для статических dropdown
                // Для API dropdown, оставляем ввод включенным для предотвращения потери фокуса
                if (this.dropdown.searchInput && !this.dropdown.config.endpoint) {
                    this.dropdown.searchInput.disabled = true;
                }
            } else {
                this.dropdown.loadingIndicator.classList.add('d-none');
                // Включаем поле поиска после загрузки
                if (this.dropdown.searchInput) {
                    this.dropdown.searchInput.disabled = false;
                }
            }
        }
    }

    // Класс Enhanced Dropdown
    class EnhancedDropdown {
        static instances = new Map();

        constructor(element, config = {}) {
            this.dropdownElement = element;
            this.config = { ...DEFAULT_CONFIG, ...config };

            // Multiselect support
            this.isMultiselect = element.getAttribute('data-multiselect') === 'true';
            this.selectedValues = new Set();
            this.selectedItemsMap = new Map(); // id -> item object

            // Переменные состояния
            this.allItems = [];
            this.filteredItems = [];
            this.currentPage = 0;
            this.hasMoreData = false;
            this.isLoading = false;
            this._loadMoreInFlight = null;
            this._loadMoreObserver = null;
            this._loadDataAbortController = null;
            this.searchTerm = '';
            this.currentValue = '';
            this.currentText = '';
            this.previousAllItemsCount = 0;
            this.totalCount = 0;
            this.isSearching = false;

            // Ссылки на DOM элементы
            this.dropdownButton = null;
            this.dropdownMenu = null;
            this.listContainer = null;
            this.searchInput = null;
            this.loadingIndicator = null;
            this.renderer = null;

            // Инициализация
            this.init();
        }

        init() {
            this.setupDOM();
            this.bindEvents();
            
            // Помечаем этот dropdown как инициализированный
            this.dropdownElement.classList.add('enhanced-dropdown-initialized');
            
            // Инициализируем рендерер только если setupDOM прошел успешно
            if (this.dropdownButton && this.dropdownMenu) {
                this.renderer = new EnhancedDropdownRenderer(this);
                this.loadInitialData();
            } else {
                console.error('Enhanced dropdown: Невозможно инициализировать - необходимые DOM элементы не найдены');
            }
        }

        setupDOM() {
            // Находим ключевые DOM элементы
            this.dropdownButton = this.dropdownElement.querySelector('.dropdown-toggle');
            this.dropdownMenu = this.dropdownElement.querySelector('.dropdown-menu');
            
            console.log('Enhanced dropdown setupDOM - element:', this.dropdownElement);
            console.log('Enhanced dropdown setupDOM - dropdownButton:', this.dropdownButton);
            console.log('Enhanced dropdown setupDOM - dropdownMenu:', this.dropdownMenu);
            
            if (!this.dropdownButton || !this.dropdownMenu) {
                console.error('Enhanced dropdown: Необходимые элементы не найдены');
                console.error('Enhanced dropdown: dropdownButton существует:', !!this.dropdownButton);
                console.error('Enhanced dropdown: dropdownMenu существует:', !!this.dropdownMenu);
                return;
            }

            // Сохраняем оригинальный текст кнопки
            this.originalButtonText = this.dropdownButton.textContent.trim();
            
            // Check for pre-selected value from hidden input, data-selected-value attribute, or config
            const hiddenInput = this.dropdownElement.querySelector('input[type="hidden"]');
            const dataSelectedValue = this.dropdownElement.getAttribute('data-selected-value');

            if (this.isMultiselect) {
                // Parse comma-separated selected values for multiselect
                const selectedStr = hiddenInput && hiddenInput.value ? hiddenInput.value : (dataSelectedValue || '');
                if (selectedStr) {
                    selectedStr.split(',').map(s => s.trim()).filter(s => s.length > 0).forEach(v => {
                        this.selectedValues.add(v);
                    });
                }
            } else if (hiddenInput && hiddenInput.value) {
                this.initialValue = hiddenInput.value;
                console.log('Enhanced dropdown: Found initial value from hidden input:', this.initialValue);
            } else if (dataSelectedValue) {
                this.initialValue = dataSelectedValue;
                console.log('Enhanced dropdown: Found initial value from data-selected-value attribute:', this.initialValue);
            } else if (this.config.selectedValue) {
                this.initialValue = this.config.selectedValue;
                console.log('Enhanced dropdown: Found initial value from config:', this.initialValue);
            }

            // Создаем контейнер списка если он не существует
            this.listContainer = this.dropdownMenu.querySelector('.enhanced-dropdown-list-container') ||
                               this.dropdownMenu.querySelector('.enhanced-dropdown-list');
            
            if (!this.listContainer) {
                this.listContainer = document.createElement('div');
                this.listContainer.className = 'enhanced-dropdown-list-container';
                this.listContainer.style.maxHeight = '300px';
                this.listContainer.style.overflowY = 'auto';
                this.listContainer.style.overflowX = 'hidden';
                
                // Перемещаем существующие элементы dropdown в новый контейнер
                const existingItems = this.dropdownMenu.querySelectorAll('li');
                Array.from(existingItems).forEach(item => this.listContainer.appendChild(item));
                
                this.dropdownMenu.appendChild(this.listContainer);
            }

            // Add reset/placeholder option at the beginning
            this.addResetOption();

            if (this.isMultiselect) {
                this.applyMultiselectAutoClose();
            }

            // Setup search input if enabled
            this.setupSearchInput();
            
            // Setup loading indicator
            this.setupLoadingIndicator();
        }

        setupSearchInput() {
            // Always create search container for API dropdowns
            // Visibility will be controlled by updateSearchVisibility()
            if (!this.config.endpoint && !this.config.searchEnabled) return;

            // Check if search input already exists
            this.searchInput = this.dropdownMenu.querySelector('.enhanced-dropdown-search');
            
            if (!this.searchInput) {
                // Create search container
                this.searchContainer = document.createElement('div');
                this.searchContainer.className = 'enhanced-dropdown-search-container';
                this.searchContainer.style.cssText = `
                    padding: 8px;
                    border-bottom: 1px solid #dee2e6;
                    background: white;
                    position: relative;
                    z-index: 10;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                `;
                
                // Create search input
                this.searchInput = document.createElement('input');
                this.searchInput.type = 'text';
                this.searchInput.className = 'form-control form-control-sm enhanced-dropdown-search';
                this.searchInput.placeholder = 'Поиск...';
                
                this.searchContainer.appendChild(this.searchInput);
                
                // Insert at the beginning of dropdown menu
                this.dropdownMenu.insertBefore(this.searchContainer, this.dropdownMenu.firstChild);
            } else {
                this.searchContainer = this.searchInput.closest('.enhanced-dropdown-search-container');
            }
            
            // Add debounced search handler to prevent multiple API calls
            let searchTimeout;
            
            this.searchInput.addEventListener('input', (e) => {
                const searchTerm = e.target.value.trim();
                console.log('Enhanced dropdown: Search input changed:', searchTerm);
                
                // Store cursor position immediately when input changes
                const cursorPosition = {
                    start: e.target.selectionStart,
                    end: e.target.selectionEnd,
                    direction: e.target.selectionDirection
                };
                
                // Store the current search term to compare later
                const previousSearchTerm = this.searchTerm;
                this.searchTerm = searchTerm;
                
                // Only trigger search if term meets minimum length or is empty
                if (searchTerm.length >= this.config.minSearchLength || searchTerm === '') {
                    // Use a flag to prevent cursor position loss during search
                    this.isSearching = true;
                    
                    // Clear previous timeout and set new one
                    clearTimeout(searchTimeout);
                    searchTimeout = setTimeout(async () => {
                        try {
                            await this.handleSearch(searchTerm);
                        } catch (error) {
                            console.error('Enhanced dropdown: Search error:', error);
                        } finally {
                            this.isSearching = false;
                            // Restore cursor position after search completes using multiple attempts for reliability
                            if (document.activeElement === this.searchInput) {
                                // Use requestAnimationFrame for better timing
                                requestAnimationFrame(() => {
                                    this.searchInput.focus();
                                    // Try to restore cursor position multiple times in case DOM is still updating
                                    let attempts = 0;
                                    const restoreCursor = () => {
                                        attempts++;
                                        try {
                                            this.searchInput.setSelectionRange(cursorPosition.start, cursorPosition.end, cursorPosition.direction);
                                            // Verify the cursor position was set correctly
                                            if (this.searchInput.selectionStart !== cursorPosition.start || 
                                                this.searchInput.selectionEnd !== cursorPosition.end) {
                                                console.log('Enhanced dropdown: Cursor position not correctly restored, current:', 
                                                    { start: this.searchInput.selectionStart, end: this.searchInput.selectionEnd }, 
                                                    'expected:', cursorPosition);
                                                if (attempts < 5) { // Try up to 5 times
                                                    setTimeout(restoreCursor, 10);
                                                }
                                            } else {
                                                console.log('Enhanced dropdown: Cursor position successfully restored on attempt', attempts);
                                            }
                                        } catch (e) {
                                            console.warn('Enhanced dropdown: Could not restore cursor position, attempt', attempts, e);
                                            if (attempts < 5) {
                                                setTimeout(restoreCursor, 10);
                                            }
                                        }
                                    };
                                    restoreCursor();
                                });
                            }
                        }
                    }, this.config.delay);
                } else {
                    console.log('Enhanced dropdown: Search term too short, ignoring:', searchTerm);
                }
            });
            
            // Prevent form submission on Enter key
            this.searchInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            });
        }

        addResetOption() {
            // Check if reset option already exists
            const existingReset = this.listContainer.querySelector('.reset-option');
            if (existingReset) return;
            
            // Check if there's already a placeholder element with data-value="" (for static HTML placeholders)
            const existingPlaceholder = this.listContainer.querySelector('li[data-value=""]');
            if (existingPlaceholder) {
                console.log('Enhanced dropdown: Found existing placeholder element, skipping reset option addition');
                return;
            }
            
            // Get field label for placeholder text
            const fieldLabel = this.dropdownElement.getAttribute('data-field-label') || 
                              this.dropdownElement.getAttribute('data-original-text') || 
                              this.originalButtonText || 
                              'Не выбрано';
            
            // Create reset/placeholder option
            const resetLi = document.createElement('li');
            resetLi.className = 'reset-option';
            
            const resetA = document.createElement('a');
            resetA.className = 'dropdown-item text-muted reset-option';
            resetA.href = '#';
            resetA.setAttribute('data-value', '');
            resetA.innerHTML = '<i class="bi bi-x-circle"></i> ' + fieldLabel;
            
            resetA.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.resetValue();
            });
            
            resetLi.appendChild(resetA);
            
            // Insert at the beginning of list
            if (this.listContainer.firstChild) {
                this.listContainer.insertBefore(resetLi, this.listContainer.firstChild);
            } else {
                this.listContainer.appendChild(resetLi);
            }
        }

        resetValue() {
            console.log('Enhanced dropdown: resetValue() called');

            if (this.isMultiselect) {
                this.selectedValues.clear();
                this.selectedItemsMap.clear();
                const fieldLabel = this.dropdownElement.getAttribute('data-field-label') ||
                                  this.originalButtonText || 'Не выбрано';
                this.updateHiddenInputFieldMultiselect();
                if (this.dropdownButton) {
                    this.dropdownButton.innerHTML = `${fieldLabel} <span class="caret"></span>`;
                }
                // Clear active class from all items
                if (this.listContainer) {
                    this.listContainer.querySelectorAll('.dropdown-item.active').forEach(item => item.classList.remove('active'));
                }
                // Dispatch event
                const event = new CustomEvent('enhancedDropdownChange', {
                    detail: {
                        dropdownId: this.dropdownElement.id || this.dropdownElement.dataset.fieldLabel || '',
                        dropdownElement: this.dropdownElement,
                        values: [],
                        texts: [],
                        isMultiselect: true,
                        isReset: true
                    }
                });
                document.dispatchEvent(event);
                return;
            }

            // Get field label for placeholder text
            const fieldLabel = this.dropdownElement.getAttribute('data-field-label') ||
                              this.dropdownElement.getAttribute('data-original-text') ||
                              this.originalButtonText ||
                              'Не выбрано';

            this.setValue('', fieldLabel);
            this.updateHiddenInputField('');
            
            // Close dropdown
            if (this.dropdownButton && window.bootstrap) {
                try {
                    // Get or create Bootstrap dropdown instance
                    let dropdown = window.bootstrap.Dropdown.getInstance(this.dropdownButton);
                    if (!dropdown) {
                        dropdown = new window.bootstrap.Dropdown(this.dropdownButton);
                    }
                    
                    if (dropdown) {
                        dropdown.hide();
                    } else {
                        // Fallback: manually close dropdown
                        const dropdownMenu = this.dropdownButton.nextElementSibling;
                        if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                            dropdownMenu.classList.remove('show');
                        }
                        this.dropdownButton.classList.remove('show');
                        this.dropdownButton.setAttribute('aria-expanded', 'false');
                    }
                } catch (error) {
                    console.warn('Enhanced dropdown: Ошибка закрытия выпадающего списка в resetValue:', error);
                    // Fallback: manually close dropdown
                    const dropdownMenu = this.dropdownButton.nextElementSibling;
                    if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                        dropdownMenu.classList.remove('show');
                    }
                    this.dropdownButton.classList.remove('show');
                    this.dropdownButton.setAttribute('aria-expanded', 'false');
                }
            }
            
            // Dispatch custom event
            const event = new CustomEvent('enhancedDropdownChange', {
                detail: {
                    dropdownId: this.dropdownElement.id || this.dropdownElement.dataset.fieldLabel || '',
                    dropdownElement: this.dropdownElement,
                    value: '',
                    text: fieldLabel,
                    item: null,
                    isReset: true
                }
            });
            document.dispatchEvent(event);
        }

        setupLoadingIndicator() {
            // Check if loading indicator already exists
            this.loadingIndicator = this.dropdownMenu.querySelector('.enhanced-dropdown-loading');
            
            if (!this.loadingIndicator) {
                this.loadingIndicator = document.createElement('div');
                this.loadingIndicator.className = 'enhanced-dropdown-loading text-center p-2 d-none';
                this.loadingIndicator.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"></div>';
                
                this.dropdownMenu.appendChild(this.loadingIndicator);
            }
        }

        bindEvents() {
            // Dropdown item click handling
            this.dropdownMenu.addEventListener('click', (e) => {
                const item = e.target.closest('.dropdown-item:not(.reset-option)');
                const resetItem = e.target.closest('.reset-option');
                if (resetItem) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.resetValue();
                } else if (item) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.isMultiselect) {
                        this.toggleItem(item);
                    } else {
                        this.selectItem(item);
                    }
                }
            });

            // Handle dropdown positioning
            this.setupPositioning();
        }

        /** Мультиселект: не закрывать при клике по пунктам, закрывать при клике снаружи (Bootstrap outside). */
        applyMultiselectAutoClose() {
            if (!this.isMultiselect || !this.dropdownButton) {
                return;
            }
            this.dropdownButton.setAttribute('data-bs-auto-close', 'outside');
            if (window.bootstrap && window.bootstrap.Dropdown) {
                const instance = window.bootstrap.Dropdown.getInstance(this.dropdownButton);
                if (instance && instance._config) {
                    instance._config.autoClose = 'outside';
                }
            }
        }

        setupPositioning() {
            try {
                // Temporarily disable moveDropdownToBody to fix dropdown opening issue
                this.dropdownButton.addEventListener('show.bs.dropdown', () => {
                    console.log('Enhanced dropdown: Bootstrap dropdown showing');
                    if (this.isMultiselect) {
                        this.applyMultiselectAutoClose();
                    }
                });

                this.dropdownButton.addEventListener('shown.bs.dropdown', () => {
                    if (this.config.endpoint) {
                        // Layout/search input: дождаться размеров listContainer, иначе IO не видит sentinel (SSR без предшествующего search).
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                this.reconnectLoadMoreIfNeeded();
                            });
                        });
                    }

                    // Force correct positioning for enhanced dropdowns
                    if (this.dropdownMenu && this.config.endpoint) {
                        setTimeout(() => {
                            try {
                                // Reset Bootstrap positioning
                                this.dropdownMenu.style.top = '100%';
                                this.dropdownMenu.style.left = '0';
                                this.dropdownMenu.style.right = '0';
                                this.dropdownMenu.style.transform = 'translateY(0)';
                                this.dropdownMenu.style.marginTop = '2px';
                                this.dropdownMenu.style.position = 'absolute';
                                
                                console.log('Enhanced dropdown: Forced positioning applied');
                            } catch (e) {
                                console.warn('Enhanced dropdown: Could not apply forced positioning', e);
                            }
                        }, 10);
                    }
                    
                    // Focus search input when dropdown is shown
                    if (this.searchInput && this.config.endpoint) {
                        setTimeout(() => {
                            try {
                                this.searchInput.focus();
                                // Move cursor to end of text
                                this.searchInput.setSelectionRange(this.searchInput.value.length, this.searchInput.value.length);
                            } catch (e) {
                                console.warn('Enhanced dropdown: Could not focus search input', e);
                            }
                        }, 50);
                    }
                });

                this.dropdownButton.addEventListener('hide.bs.dropdown', () => {
                    console.log('Enhanced dropdown: Bootstrap dropdown hiding');
                });

                this.dropdownButton.addEventListener('hidden.bs.dropdown', () => {
                    console.log('Enhanced dropdown: Bootstrap dropdown hidden');
                    this._loadMoreInFlight = null;
                    this.teardownLoadMoreObserver();
                    // Очистка поискового ввода при сворачивании (все dropdown, все страницы):
                    // ни текст, ни отфильтрованный список не должны сохраняться до следующего открытия.
                    const hadSearchText = (this.searchInput && this.searchInput.value !== '')
                        || (this.searchTerm && this.searchTerm !== '');
                    if (this.searchInput) {
                        this.searchInput.value = '';
                    }
                    if (hadSearchText) {
                        this.searchTerm = '';
                        if (typeof this.handleSearch === 'function') {
                            this.handleSearch('');
                        }
                    }
                });

            } catch (error) {
                console.warn('Enhanced dropdown: Ошибка настройки позиционирования:', error);
            }
        }

        setLoading(isLoading) {
            if (!this.renderer) return;
            this.renderer.setLoading(isLoading);
        }

        setValue(value, text = '') {
            this.currentValue = value;
            this.currentText = text;
            
            // Update button text with fallback to field label if text is empty
            if (this.dropdownButton) {
                const displayText = text || this.dropdownElement.getAttribute('data-field-label') || this.originalButtonText || 'Выберите значение';
                this.dropdownButton.innerHTML = `${displayText} <span class="caret"></span>`;
            }
            
            // Update hidden input
            this.updateHiddenInputField(value);

            // Persist for SSR/deep-link collectors
            if (this.isMultiselect) {
                const csv = Array.from(this.selectedValues).join(',');
                this.dropdownElement.setAttribute('data-selected-value', csv);
            } else if (value && value !== '' && value !== '0') {
                this.dropdownElement.setAttribute('data-selected-value', String(value));
            } else {
                this.dropdownElement.setAttribute('data-selected-value', '');
            }
            
            // Update active state
            this.updateActiveState();
        }

        updateHiddenInputField(value) {
            // Find hidden input: inside dropdown, then next siblings, then by name in form (e.g. TerminalId)
            let hiddenInput = this.dropdownElement.querySelector('input[type="hidden"]');
            if (!hiddenInput) {
                let next = this.dropdownElement.nextElementSibling;
                for (let i = 0; i < 5 && next; i++) {
                    if (next.matches && next.matches('input[type="hidden"]')) {
                        hiddenInput = next;
                        break;
                    }
                    next = next.nextElementSibling;
                }
            }
            if (!hiddenInput) {
                const nameField = this.dropdownElement.getAttribute('data-name-field');
                if (nameField) {
                    const form = this.dropdownElement.closest('form');
                    if (form) {
                        const byName = form.querySelector(`input[type="hidden"][name="${nameField}"]`);
                        if (byName) hiddenInput = byName;
                    }
                }
            }
            // Machine row: find hidden by name pattern in same row (ProductId / ModelId)
            if (!hiddenInput && this.dropdownElement.closest('tr')) {
                const row = this.dropdownElement.closest('tr');
                const entityType = this.dropdownElement.getAttribute('data-entity-type');
                if (entityType === 'products') hiddenInput = row.querySelector('input[type="hidden"][name*=".ProductId"]');
                else if (entityType === 'machinemodels') hiddenInput = row.querySelector('input[type="hidden"][name*=".ModelId"]');
            }
            if (hiddenInput) {
                hiddenInput.value = value || '';
            }
        }

        updateActiveState() {
            // Remove active class from all items
            const items = this.listContainer.querySelectorAll('.dropdown-item:not(.reset-option)');
            items.forEach(item => item.classList.remove('active'));

            // Add active class to selected item
            if (this.currentValue) {
                const selectedItem = this.listContainer.querySelector(`[data-value="${this.currentValue}"]`);
                if (selectedItem) {
                    selectedItem.classList.add('active');
                }
            }
        }

        selectItem(item) {
            if (!item) return;

            // item is a DOM element (.dropdown-item), get value from data-value attribute
            const value = item.getAttribute('data-value') || 
                          item[this.config.idField] || 
                          item.id || 
                          item.value;
            const text = item.textContent?.trim() || 
                         item[this.config.nameField] || 
                         item.name || 
                         item.text || 
                         item.value;

            console.log('Enhanced dropdown: selecting item', value, text);

            this.setValue(value, text);

            // Dispatch custom event
            const event = new CustomEvent('enhancedDropdownChange', {
                detail: {
                    dropdownId: this.dropdownElement.id || this.dropdownElement.dataset.fieldLabel || '',
                    dropdownElement: this.dropdownElement,
                    value: value,
                    text: text,
                    item: item,
                    isReset: false
                }
            });
            document.dispatchEvent(event);

            // Свернуть выпадающий список после выбора элемента
            if (this.dropdownButton && window.bootstrap && window.bootstrap.Dropdown) {
                try {
                    // Get or create Bootstrap dropdown instance
                    let dropdown = window.bootstrap.Dropdown.getInstance(this.dropdownButton);
                    if (!dropdown) {
                        dropdown = new window.bootstrap.Dropdown(this.dropdownButton);
                    }
                    
                    if (dropdown) {
                        dropdown.hide();
                    } else {
                        // Fallback: manually close dropdown
                        const dropdownMenu = this.dropdownButton.nextElementSibling;
                        if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                            dropdownMenu.classList.remove('show');
                        }
                        this.dropdownButton.classList.remove('show');
                        this.dropdownButton.setAttribute('aria-expanded', 'false');
                    }
                } catch (error) {
                    console.warn('Enhanced dropdown: Ошибка закрытия выпадающего списка в selectItem:', error);
                    // Fallback: manually close dropdown
                    const dropdownMenu = this.dropdownButton.nextElementSibling;
                    if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                        dropdownMenu.classList.remove('show');
                    }
                    this.dropdownButton.classList.remove('show');
                    this.dropdownButton.setAttribute('aria-expanded', 'false');
                }
            }
        }

        /**
         * Multiselect: toggle item selection (add/remove from Set).
         * Does NOT close the dropdown.
         */
        toggleItem(item) {
            if (!item) return;

            const value = item.getAttribute('data-value');
            if (!value) return; // guard against missing data-value

            const text = item.textContent?.trim() || '';

            if (this.selectedValues.has(value)) {
                // Deselect
                this.selectedValues.delete(value);
                this.selectedItemsMap.delete(value);
            } else {
                // Select
                this.selectedValues.add(value);
                this.selectedItemsMap.set(value, { value, text });
            }

            // Синхронизируем .active на ВСЕХ элементах dropdown (не только на кликнутом)
            // Это важно для серверных элементов, которые не были перерисованы через renderItems
            this.syncActiveOnExistingItems();

            this.updateHiddenInputFieldMultiselect();
            this.updateButtonText();

            // Dispatch custom event
            const event = new CustomEvent('enhancedDropdownChange', {
                detail: {
                    dropdownId: this.dropdownElement.id || this.dropdownElement.dataset.fieldLabel || '',
                    dropdownElement: this.dropdownElement,
                    values: Array.from(this.selectedValues),
                    texts: Array.from(this.selectedItemsMap.values()).map(i => i.text),
                    isMultiselect: true
                }
            });
            document.dispatchEvent(event);

            if (this.config.endpoint) {
                this.invalidateEndpointCache();
            }
        }

        updateHiddenInputFieldMultiselect() {
            const value = Array.from(this.selectedValues).join(',');
            let hiddenInput = this.dropdownElement.querySelector('input[type="hidden"]');
            if (!hiddenInput) {
                let next = this.dropdownElement.nextElementSibling;
                for (let i = 0; i < 5 && next; i++) {
                    if (next.matches && next.matches('input[type="hidden"]')) {
                        hiddenInput = next;
                        break;
                    }
                    next = next.nextElementSibling;
                }
            }
            if (!hiddenInput) {
                const nameField = this.dropdownElement.getAttribute('data-name-field');
                if (nameField) {
                    const form = this.dropdownElement.closest('form');
                    if (form) {
                        const byName = form.querySelector(`input[type="hidden"][name="${nameField}"]`);
                        if (byName) hiddenInput = byName;
                    }
                }
            }
            if (!hiddenInput) {
                // Create hidden input if it doesn't exist
                hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                const fieldLabel = this.dropdownElement.getAttribute('data-field-label') || '';
                hiddenInput.name = `hidden_${fieldLabel}`;
                this.dropdownElement.appendChild(hiddenInput);
            }
            if (hiddenInput) {
                hiddenInput.value = value;
            }
            this.dropdownElement.setAttribute('data-selected-value', value || '');
        }

        updateButtonText() {
            if (!this.dropdownButton) return;
            const fieldLabel = this.dropdownElement.getAttribute('data-field-label') || this.originalButtonText || 'Выберите значение';
            let displayText;
            if (this.selectedValues.size === 0) {
                displayText = fieldLabel;
            } else if (this.selectedValues.size === 1) {
                const firstItem = Array.from(this.selectedItemsMap.values())[0];
                displayText = firstItem ? firstItem.text : fieldLabel;
            } else {
                displayText = `Выбрано: ${this.selectedValues.size}`;
            }
            this.dropdownButton.innerHTML = `${displayText} <span class="caret"></span>`;
        }

        resetSelection() {
            this.setValue('', '');
            
            // Dispatch custom event
            const event = new CustomEvent('enhancedDropdownChange', {
                detail: {
                    dropdownId: this.dropdownElement.id || this.dropdownElement.dataset.fieldLabel || '',
                    dropdownElement: this.dropdownElement,
                    value: '',
                    text: '',
                    item: null,
                    isReset: true
                }
            });
            document.dispatchEvent(event);

            // Свернуть выпадающий список после сброса
            if (this.dropdownButton && window.bootstrap && window.bootstrap.Dropdown) {
                try {
                    // Get or create Bootstrap dropdown instance
                    let dropdown = window.bootstrap.Dropdown.getInstance(this.dropdownButton);
                    if (!dropdown) {
                        dropdown = new window.bootstrap.Dropdown(this.dropdownButton);
                    }
                    
                    if (dropdown) {
                        dropdown.hide();
                    } else {
                        // Fallback: manually close dropdown
                        const dropdownMenu = this.dropdownButton.nextElementSibling;
                        if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                            dropdownMenu.classList.remove('show');
                        }
                        this.dropdownButton.classList.remove('show');
                        this.dropdownButton.setAttribute('aria-expanded', 'false');
                    }
                } catch (error) {
                    console.warn('Enhanced dropdown: Ошибка закрытия выпадающего списка в resetSelection:', error);
                    // Fallback: manually close dropdown
                    const dropdownMenu = this.dropdownButton.nextElementSibling;
                    if (dropdownMenu && dropdownMenu.classList.contains('show')) {
                        dropdownMenu.classList.remove('show');
                    }
                    this.dropdownButton.classList.remove('show');
                    this.dropdownButton.setAttribute('aria-expanded', 'false');
                }
            }
        }

        invalidateEndpointCache() {
            if (!this.config.endpoint || !window.dropdownCache) return;
            const normalizedBase = window.normalizeDropdownEndpointForCache(this.config.endpoint);
            for (const key of [...window.dropdownCache.keys()]) {
                const keyNormalized = window.normalizeDropdownEndpointForCache(key);
                if (keyNormalized === normalizedBase) {
                    window.dropdownCache.delete(key);
                }
            }
        }

        isDropdownMenuOpen() {
            return !!(this.dropdownMenu && this.dropdownMenu.classList.contains('show'));
        }

        /** SSR catalog total при пустом поиске — не занижать totalCount размером первой страницы. */
        applyCatalogTotalCountHint() {
            const catalog = this.config.catalogTotalCount;
            const noSearch = !this.searchTerm || this.searchTerm.trim() === '';
            if (noSearch && typeof catalog === 'number' && catalog > 0) {
                this.totalCount = Math.max(this.totalCount || 0, catalog);
            }
        }

        resetPaginationAfterSearch(isClearSearch) {
            this.currentPage = 0;
            this._loadMoreInFlight = null;
            this.teardownLoadMoreObserver();
            if (isClearSearch && typeof this.config.catalogTotalCount === 'number' && this.config.catalogTotalCount > 0) {
                this.totalCount = this.config.catalogTotalCount;
                this.hasMoreData = this.allItems.length < this.totalCount;
            } else if (isClearSearch) {
                this.totalCount = 0;
                this.hasMoreData = this.allItems.length >= this.config.initialLoadCount;
            } else {
                this.totalCount = 0;
                this.hasMoreData = false;
            }
        }

        resetScrollForListReplace() {
            if (this.listContainer) {
                this.listContainer.scrollTop = 0;
            }
        }

        isSentinelNearVisible() {
            const container = this.listContainer;
            if (!container) {
                return false;
            }
            const sentinel = container.querySelector('li.load-more-sentinel');
            if (!sentinel) {
                return false;
            }
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;
            if (scrollHeight <= 0 || clientHeight <= 0) {
                return false;
            }
            if (scrollHeight <= clientHeight + 40) {
                return true;
            }
            return scrollTop + clientHeight >= scrollHeight - 40;
        }

        maybeTriggerLoadMoreFromSentinel() {
            if (!this.hasMoreData || !this.config.endpoint || this.isLoading || this._loadMoreInFlight) {
                return;
            }
            if (!this.isDropdownMenuOpen()) {
                return;
            }
            const runCheck = () => {
                if (!this.isSentinelNearVisible()) {
                    return;
                }
                this.teardownLoadMoreObserver();
                this.loadMore();
            };
            const container = this.listContainer;
            if (container && (container.scrollHeight <= 0 || container.clientHeight <= 0)) {
                requestAnimationFrame(() => {
                    requestAnimationFrame(runCheck);
                });
                return;
            }
            runCheck();
        }

        reconnectLoadMoreIfNeeded() {
            if (!this.hasMoreData || !this.config.endpoint) {
                this.teardownLoadMoreObserver();
                return;
            }
            this.ensureLoadMoreSentinel();
            if (this.isDropdownMenuOpen()) {
                this.setupLoadMoreObserver();
            }
        }

        handleSearch(searchTerm) {
            if (this.isLoading) {
                console.log('Enhanced dropdown: already loading, skipping search');
                return Promise.resolve();
            }

            if (!this.config.endpoint) {
                // For static dropdowns, filter the existing items
                this.applyFilter();
                if (this.renderer) {
                    this.renderer.renderItems(this.filteredItems, false);
                }
                return Promise.resolve();
            }

            const normalized = (searchTerm ?? '').toString().trim();
            this.searchTerm = normalized;

            const isClearSearch = normalized === '';
            if (isClearSearch) {
                this.invalidateEndpointCache();
            }

            this.resetPaginationAfterSearch(isClearSearch);
            this.resetScrollForListReplace();
            this.isLoading = true;
            // Контракт DropdownPagination: page 1 = initialLoadCount, page 2+ skip от него (как SSR и clear search).
            const pageSizeForLoad = this.config.initialLoadCount;
            return this.loadData(true, pageSizeForLoad).catch(error => {
                console.error('Ошибка поиска данных выпадающего списка:', error);
                if (this.renderer) {
                    this.renderer.renderError('Ошибка поиска: ' + error.message);
                }
            }).finally(() => {
                this.setLoading(false);
                this.isLoading = false;
            });
        }

        applyFilter() {
            if (!this.searchTerm || this.searchTerm.length < this.config.minSearchLength) {
                this.filteredItems = [...this.allItems];
            } else {
                const searchKey = stripAsciiSpaces(this.searchTerm).toLowerCase();
                this.filteredItems = this.allItems.filter(item => {
                    const name = stripAsciiSpaces((item[this.config.searchField] || item.name || item.text || '').toString()).toLowerCase();
                    return name.includes(searchKey);
                });
            }
        }

        updateSearchVisibility() {
            if (!this.searchInput) return;
            
            // Простая проверка - вся логика перенесена в контроллер
            const shouldShowSearch = this.config.searchEnabled;
            
            console.log(`[ENHANCED DROPDOWN] updateSearchVisibility - shouldShowSearch: ${shouldShowSearch}, searchEnabled: ${this.config.searchEnabled}`);
            
            const searchContainer = this.searchInput.closest('.enhanced-dropdown-search-container');
            if (searchContainer) {
                searchContainer.style.display = shouldShowSearch ? 'block' : 'none';
            }
        }

        getValue() {
            // Return current value
            if (this.currentValue === '' || this.currentValue === null) {
                return null;
            }
            return {
                value: this.currentValue,
                text: this.currentText || ''
            };
        }

        /**
         * Определяет, есть ли ещё данные для подгрузки (контракт API: totalCount; fallback — размер страницы).
         * @param {number} pageItemCount — число элементов в последнем ответе API (после дедупликации)
         * @param {number} pageSize — запрошенный pageSize
         */
        updateHasMoreData(pageItemCount, pageSize) {
            this.applyCatalogTotalCountHint();
            if (typeof this.totalCount === 'number' && this.totalCount > 0) {
                this.hasMoreData = this.allItems.length < this.totalCount;
            } else {
                this.hasMoreData = pageItemCount >= pageSize;
            }
            if (this.currentPage > 0 && pageItemCount === 0) {
                this.hasMoreData = false;
            }
            console.log('Enhanced dropdown: hasMoreData =', this.hasMoreData,
                '(allItems:', this.allItems.length, 'totalCount:', this.totalCount,
                'pageItems:', pageItemCount, 'pageSize:', pageSize, ')');
        }

        teardownLoadMoreObserver() {
            if (this._loadMoreObserver) {
                this._loadMoreObserver.disconnect();
                this._loadMoreObserver = null;
            }
        }

        /** Невидимый sentinel в конце списка для IntersectionObserver (без кнопки «Загрузить ещё»). */
        ensureLoadMoreSentinel() {
            if (!this.listContainer || !this.hasMoreData || !this.config.endpoint) {
                return null;
            }
            this.renderer?.removeLoadMoreIndicators();
            let sentinel = this.listContainer.querySelector('li.load-more-sentinel');
            const useClickFallback = typeof IntersectionObserver === 'undefined';
            if (!sentinel) {
                sentinel = document.createElement('li');
                sentinel.className = 'load-more-row load-more-sentinel';
                if (useClickFallback) {
                    const a = document.createElement('a');
                    a.className = 'dropdown-item text-muted load-more';
                    a.href = '#';
                    a.innerHTML = '<i class="bi bi-arrow-down-circle"></i> Загрузить ещё...';
                    a.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.loadMore();
                    });
                    sentinel.appendChild(a);
                } else {
                    sentinel.setAttribute('aria-hidden', 'true');
                    sentinel.style.cssText = 'height:1px;min-height:1px;padding:0;margin:0;border:0;overflow:hidden;list-style:none;';
                }
                this.listContainer.appendChild(sentinel);
            } else if (sentinel.parentElement === this.listContainer && sentinel !== this.listContainer.lastElementChild) {
                this.listContainer.appendChild(sentinel);
            }
            return sentinel;
        }

        captureScrollAnchor() {
            const container = this.listContainer;
            if (!container) {
                return { scrollTop: 0, nearBottom: false };
            }
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;
            const nearBottom = scrollHeight > 0 && scrollTop + clientHeight >= scrollHeight - 40;
            const containerTop = container.getBoundingClientRect().top;
            let anchorValue = null;
            let anchorOffset = 0;
            const links = container.querySelectorAll('a.dropdown-item:not(.reset-option):not(.load-more)');
            for (const link of links) {
                const value = link.getAttribute('data-value');
                if (!value || value === '') continue;
                const rect = link.getBoundingClientRect();
                if (rect.bottom > containerTop + 1) {
                    anchorValue = value;
                    anchorOffset = rect.top - containerTop;
                    break;
                }
            }
            return { scrollTop, nearBottom, anchorValue, anchorOffset, scrollHeight, clientHeight };
        }

        restoreScrollAnchor(anchor) {
            const container = this.listContainer;
            if (!container || !anchor) return;

            const apply = () => {
                if (anchor.nearBottom) {
                    container.scrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
                    return;
                }
                if (anchor.anchorValue) {
                    const links = container.querySelectorAll('a.dropdown-item[data-value]');
                    const link = Array.from(links).find(a => a.getAttribute('data-value') === anchor.anchorValue);
                    if (link) {
                        const containerTop = container.getBoundingClientRect().top;
                        const rect = link.getBoundingClientRect();
                        container.scrollTop = Math.max(0, container.scrollTop + (rect.top - containerTop) - anchor.anchorOffset);
                        return;
                    }
                }
                container.scrollTop = anchor.scrollTop;
            };

            requestAnimationFrame(() => {
                apply();
                requestAnimationFrame(apply);
            });
        }

        setupLoadMoreObserver() {
            this.teardownLoadMoreObserver();
            if (!this.listContainer || !this.hasMoreData || !this.config.endpoint) {
                return;
            }
            if (typeof IntersectionObserver === 'undefined') {
                return;
            }
            const sentinel = this.ensureLoadMoreSentinel();
            if (!sentinel) {
                return;
            }
            this._loadMoreObserver = new IntersectionObserver((entries) => {
                const entry = entries[0];
                if (!entry || !entry.isIntersecting) {
                    return;
                }
                if (!this.isDropdownMenuOpen() || !this.hasMoreData || this.isLoading || this._loadMoreInFlight) {
                    return;
                }
                console.log('Enhanced dropdown: load-more sentinel visible — calling loadMore');
                this.teardownLoadMoreObserver();
                this.loadMore();
            }, {
                root: this.listContainer,
                rootMargin: '120px',
                threshold: 0
            });
            this._loadMoreObserver.observe(sentinel);
            this.maybeTriggerLoadMoreFromSentinel();
        }

        async loadData(isSearch = false, pageSizeParam = null) {
            if (!this.config.endpoint) {
                console.log('Enhanced dropdown: No endpoint configured, skipping data load');
                return;
            }

            const currentValue = this.getValue()?.value;
            const currentText = this.getValue()?.text;

            const effectivePageSize = pageSizeParam || this.config.pageSize;
            const cacheBase = window.normalizeDropdownEndpointForCache(this.config.endpoint);
            const cacheParams = window.buildDropdownCacheParams(this, effectivePageSize);
            const cacheKey = window.generateCacheKey(cacheBase, cacheParams);
            const skipCacheForSelected = (this.isMultiselect && this.selectedValues.size > 0)
                || (!this.isMultiselect && this.initialValue && String(this.initialValue).trim() !== '' && String(this.initialValue).trim() !== '0');
            
            // Check cache first (but skip cache for pagination loads to ensure fresh data)
            const cachedData = window.getCachedData(cacheKey);
            const skipCacheForPagination = this.currentPage > 0;
            if (cachedData && !isSearch && !skipCacheForPagination && !skipCacheForSelected) {
                console.log('Enhanced dropdown: Using cached data for', cacheKey);
                this.allItems = cachedData;
                this.filteredItems = [...cachedData];
                this.applyCatalogTotalCountHint();
                this.updateHasMoreData(cachedData.length, effectivePageSize);
                if (this.renderer) {
                    this.renderer.renderItems(this.filteredItems, false);
                }
                if (currentValue) {
                    this.setValue(currentValue, currentText);
                } else {
                    this.setInitialValue();
                }
                return;
            }

            if (this._loadDataAbortController) {
                this._loadDataAbortController.abort();
            }
            this._loadDataAbortController = new AbortController();
            const fetchSignal = this._loadDataAbortController.signal;
            // Snapshot the controller reference so the finally block can detect if
            // a newer loadData call has already superseded this one.
            const myController = this._loadDataAbortController;

            this.setLoading(true);
            this.currentPage = isSearch ? 0 : this.currentPage;

            try {
                const params = new URLSearchParams();
                params.append('pageNumber', (this.currentPage + 1).toString());
                params.append('pageSize', effectivePageSize.toString());
                
                if (this.searchTerm && this.searchTerm.trim() !== '') {
                    params.append('search', this.searchTerm);
                }

                if (this.config.sortBy) {
                    params.append('sortBy', this.config.sortBy);
                }
                params.append('sortAscending', this.config.sortAscending ? 'true' : 'false');

                // Pass selected values to API (multiselect or single-select deep-link pin)
                if (this.isMultiselect && this.selectedValues.size > 0) {
                    params.append('selected', Array.from(this.selectedValues).join(','));
                } else {
                    const initialValue = this.initialValue != null ? String(this.initialValue).trim() : '';
                    if (initialValue && initialValue !== '0') {
                        params.append('selected', initialValue);
                    }
                }

                console.log('Enhanced dropdown: Initial params:', {
                    pageNumber: this.currentPage + 1,
                    pageSize: effectivePageSize,
                    search: this.searchTerm || ''
                });

                const url = this.config.endpoint + (params.toString() ? (this.config.endpoint.includes('?') ? '&' : '?') + params.toString() : '');
                console.log('Enhanced dropdown: Final URL:', url);
                console.log('Enhanced dropdown: All params before request:', Object.fromEntries(params.entries()));

                const response = await fetch(url, { signal: fetchSignal });
                if (!response.ok) {
                    throw new Error(`HTTP ошибка ${response.status}: ${response.statusText}`);
                }

                const data = await response.json();
                const items = data.items || [];

                // Filter out duplicate items based on ID
                const uniqueItems = items.filter((item, index, self) => {
                    const id = (item[this.config.idField] || item.id || item.value)?.toString();
                    return index === self.findIndex(i => (i[this.config.idField] || i.id || i.value)?.toString() === id);
                });

                console.log('Enhanced dropdown: Received', items.length, 'items, filtered to', uniqueItems.length, 'unique items');

                const isInitialLoad = this.currentPage === 0;
                let appendedItems = null;

                if (this.currentPage === 0) {
                    // First load - replace all items
                    this.allItems = uniqueItems;
                    this.filteredItems = [...uniqueItems];

                    // For multiselect: track which items from the response are selected (pinned by API)
                    if (this.isMultiselect) {
                        uniqueItems.forEach(item => {
                            const id = (item[this.config.idField] || item.id || item.value)?.toString();
                            if (id && this.selectedValues.has(id)) {
                                this.selectedItemsMap.set(id, {
                                    value: id,
                                    text: item[this.config.nameField] || item.name || item.text || item.value || ''
                                });
                            }
                        });
                    }

                    // Cache results only for non-search queries without multiselect selected pinning
                    if (!isSearch && !skipCacheForSelected) {
                        window.setCachedData(cacheKey, uniqueItems);
                    }
                } else {
                    // Pagination - append items avoiding duplicates
                    const existingIds = new Set(this.allItems.map(item => 
                        (item[this.config.idField] || item.id || item.value)?.toString()
                    ));
                    
                    const newItems = uniqueItems.filter(item => {
                        const itemId = (item[this.config.idField] || item.id || item.value)?.toString();
                        return !existingIds.has(itemId);
                    });
                    
                    console.log('Enhanced dropdown: Appending', newItems.length, 'new items out of', uniqueItems.length, 'received');
                    
                    this.allItems = [...this.allItems, ...newItems];
                    this.filteredItems = [...this.filteredItems, ...newItems];
                    appendedItems = newItems;
                }

                if (data.totalCount !== undefined && data.totalCount !== null) {
                    this.totalCount = data.totalCount;
                } else if (this.currentPage === 0) {
                    this.totalCount = uniqueItems.length;
                }
                this.applyCatalogTotalCountHint();
                console.log('Enhanced dropdown: totalCount =', this.totalCount, 'from API response');

                this.updateHasMoreData(uniqueItems.length, effectivePageSize);
                if (this.currentPage > 0 && appendedItems && appendedItems.length === 0) {
                    this.hasMoreData = false;
                }
                this.updateSearchVisibility();

                if (this.renderer) {
                    if (isInitialLoad) {
                        this.renderer.renderItems(this.filteredItems, false);
                    } else {
                        this.renderer.renderItems(this.filteredItems, true, appendedItems || []);
                    }
                }

                // Принудительно обновляем .active на серверных элементах,
                // если renderItems не перерисовал их (например, API вернул 0 элементов)
                if (this.isMultiselect) {
                    this.syncActiveOnExistingItems();
                }

                // Restore selection after data update
                if (currentValue) {
                    this.setValue(currentValue, currentText);
                }

            } catch (error) {
                if (error && error.name === 'AbortError') {
                    console.log('Enhanced dropdown: loadData aborted (superseded by newer request)');
                    // Don't return early — let finally handle loading state cleanup
                } else {
                    console.error('Enhanced dropdown: Ошибка загрузки данных:', error);
                    if (this.renderer) {
                        this.renderer.renderError('Ошибка загрузки: ' + error.message);
                    }
                }
            } finally {
                // Clear loading only if this is still the latest request.
                // If superseded (a newer loadData has run), the new request manages the loading state.
                // If aborted externally with no replacement, this is still the latest controller → clear loading.
                if (this._loadDataAbortController === myController) {
                    this.setLoading(false);
                }
            }
        }

        async loadMore() {
            if (this._loadMoreInFlight) {
                console.log('Enhanced dropdown: loadMore already in flight, joining existing promise');
                return this._loadMoreInFlight;
            }

            if (this.isLoading) {
                console.log('Enhanced dropdown: already loading, skipping loadMore');
                return;
            }

            if (!this.hasMoreData) return;

            const scrollAnchor = this.captureScrollAnchor();
            this.teardownLoadMoreObserver();

            console.log('Enhanced dropdown: loadMore - anchor:', scrollAnchor);

            this.isLoading = true;
            this.currentPage++;

            this._loadMoreInFlight = (async () => {
                try {
                    await this.loadData(false);
                } finally {
                    this.isLoading = false;
                }

                this.restoreScrollAnchor(scrollAnchor);

                if (this.hasMoreData && this.config.endpoint) {
                    this.ensureLoadMoreSentinel();
                    this.setupLoadMoreObserver();
                }
            })();

            try {
                await this._loadMoreInFlight;
            } finally {
                this._loadMoreInFlight = null;
            }
        }

        async loadInitialData() {
            if (!this.config.endpoint) {
                // For static dropdowns, just render existing items
                const existingItems = this.listContainer.querySelectorAll('.dropdown-item:not(.reset-option)');
                const items = Array.from(existingItems).map(item => ({
                    value: item.getAttribute('data-value'),
                    text: twDropdownItemLabel(item),
                    element: item
                }));
                this.allItems = items;
                this.filteredItems = [...this.allItems];
                this.updateSearchVisibility();
                
                // Set initial value for static dropdowns
                this.setInitialValue();
                return;
            }

            // Check if dropdown already has items populated server-side
            const existingItems = this.listContainer.querySelectorAll('a.dropdown-item:not(.reset-option):not([data-value=""])');
            if (existingItems.length > 0) {
                console.log('Enhanced dropdown: Skipping initial load - dropdown already has', existingItems.length, 'items populated server-side');
                // Initialize allItems and filteredItems from existing DOM items
                this.allItems = Array.from(existingItems).map(item => ({
                    [this.config.idField]: item.getAttribute('data-value'),
                    [this.config.nameField]: twDropdownItemLabel(item)
                }));
                this.filteredItems = [...this.allItems];
                this.updateSearchVisibility();

                const catalogTotal = this.config.catalogTotalCount;
                if (typeof catalogTotal === 'number' && catalogTotal > 0) {
                    this.totalCount = catalogTotal;
                    this.hasMoreData = this.allItems.length < Math.max(catalogTotal, this.totalCount);
                    // SSR anti-pattern: catalog total equals first-page size (unreliable filtered total).
                    if (this.hasMoreData === false &&
                        this.allItems.length >= this.config.initialLoadCount &&
                        catalogTotal === this.allItems.length) {
                        this.hasMoreData = true;
                        console.log('Enhanced dropdown: catalog total equals first page size — enabling load-more probe',
                            'catalog:', catalogTotal, 'domItems:', this.allItems.length);
                    }
                    console.log('Enhanced dropdown: server-populated with catalog total', catalogTotal,
                        'domItems:', this.allItems.length, 'hasMoreData:', this.hasMoreData);
                } else if (this.allItems.length < this.config.initialLoadCount) {
                    this.totalCount = this.allItems.length;
                    this.hasMoreData = false;
                    console.log('Enhanced dropdown: server-populated full catalog (items < initialLoadCount)');
                } else {
                    this.totalCount = 0;
                    this.hasMoreData = true;
                    console.log('Enhanced dropdown: server-populated first page, load-more enabled');
                }
                
                // Для мультиселекта: синхронизируем .active на ВСЕХ серверных элементах
                // Страница 1 уже в DOM; currentPage остаётся 0 — первый loadMore запросит pageNumber=2
                this.currentPage = 0;

                if (this.isMultiselect) {
                    this.syncActiveOnExistingItems();
                    this.syncSelectedItemsMapFromDom();
                    this.updateButtonText();
                } else {
                    this.setInitialValue();
                    // Deep-link/дублирование вкладки: если выбранный id не попал в SSR-страницу опций,
                    // подпись осталась плейсхолдером. Дотягиваем элемент с сервера (loadData шлёт selected=<id>),
                    // затем повторно проставляем подпись. Переиспользуем существующий selected=-механизм.
                    const pinnedValue = this.initialValue != null ? String(this.initialValue).trim() : '';
                    if (pinnedValue && pinnedValue !== '0' && this.config.endpoint) {
                        const alreadyResolved = (this.allItems || []).some(it => {
                            const v = it[this.config.idField] || it.id || it.value;
                            return v != null && v.toString().trim() === pinnedValue;
                        });
                        if (!alreadyResolved) {
                            await this.loadData(false, this.config.initialLoadCount);
                            this.setInitialValue();
                            return;
                        }
                    }
                }

                if (this.hasMoreData && this.config.endpoint) {
                    this.ensureLoadMoreSentinel();
                }
                return;
            }

            // For API dropdowns, load initial data with custom pageSize
            console.log('Enhanced dropdown: Loading initial data from server with initialLoadCount', this.config.initialLoadCount);
            await this.loadData(false, this.config.initialLoadCount);
            // Всегда синхронизируем кнопку/скрытое поле с initialValue после загрузки (раньше при пустом result setInitialValue не вызывался).
            this.setInitialValue();
        }
        
        /** Заполняет selectedItemsMap из DOM для SSR-populated multiselect. */
        syncSelectedItemsMapFromDom() {
            if (!this.listContainer || this.selectedValues.size === 0) return;
            this.listContainer.querySelectorAll('.dropdown-item[data-value]').forEach(function(a) {
                const val = a.getAttribute('data-value');
                if (!val || val === '' || !this.selectedValues.has(val)) return;
                this.selectedItemsMap.set(val, {
                    value: val,
                    text: twDropdownItemLabel(a)
                });
            }.bind(this));
        }

        /** Синхронизирует .active на всех существующих DOM-элементах на основе selectedValues. */
        syncActiveOnExistingItems() {
            if (!this.listContainer) return;
            this.listContainer.querySelectorAll('.dropdown-item[data-value]').forEach(function(a) {
                const val = a.getAttribute('data-value');
                if (!val || val === '') return;
                if (this.selectedValues.has(val)) {
                    a.classList.add('active');
                } else {
                    a.classList.remove('active');
                }
            }.bind(this));
            console.log('Enhanced dropdown: Synced .active on existing items for multiselect, selectedValues:', Array.from(this.selectedValues));
        }
        
        setInitialValue() {
            console.log('Enhanced dropdown: setInitialValue called for', this.dropdownElement);
            console.log('Enhanced dropdown: initialValue:', this.initialValue);
            console.log('Enhanced dropdown: allItems count:', this.allItems?.length || 0);
            
            // Normalize initialValue for comparison
            const normalizedInitialValue = this.initialValue ? this.initialValue.toString().trim() : '';
            
            // Check if we have an initial value from hidden input
            if (normalizedInitialValue && normalizedInitialValue !== '0') {
                console.log('Enhanced dropdown: Setting initial value from hidden input:', normalizedInitialValue);
                
                // First try to find item in allItems (for API-loaded dropdowns)
                if (this.allItems && this.allItems.length > 0) {
                    const item = this.allItems.find(item => {
                        const itemValue = item[this.config.idField] || item.id || item.value;
                        return itemValue && itemValue.toString().trim() === normalizedInitialValue;
                    });
                    
                    if (item) {
                        const text = item[this.config.nameField] || item.name || item.text || normalizedInitialValue;
                        this.setValue(normalizedInitialValue, text);
                        console.log('Enhanced dropdown: Set initial value from allItems to:', normalizedInitialValue, 'with text:', text);
                        return;
                    }
                }
                
                // If not found in allItems, try to find active item in DOM (for server-rendered dropdowns)
                const activeItem = this.listContainer.querySelector('.dropdown-item.active[data-value="' + normalizedInitialValue + '"]');
                if (activeItem) {
                    const text = twDropdownItemLabel(activeItem);
                    this.setValue(normalizedInitialValue, text);
                    console.log('Enhanced dropdown: Set initial value from active DOM element:', normalizedInitialValue, 'with text:', text);
                    return;
                }
                
                // If still not found, try to find any item with matching value in DOM
                const matchingItem = this.listContainer.querySelector('.dropdown-item[data-value="' + normalizedInitialValue + '"]');
                if (matchingItem) {
                    const text = twDropdownItemLabel(matchingItem);
                    this.setValue(normalizedInitialValue, text);
                    console.log('Enhanced dropdown: Set initial value from matching DOM element:', normalizedInitialValue, 'with text:', text);
                    return;
                }
                
                console.log('Enhanced dropdown: Could not find item for initial value:', normalizedInitialValue);
                // Preserve SSR button caption from deep-link pin; sync hidden input only
                this.currentValue = normalizedInitialValue;
                this.updateHiddenInputField(normalizedInitialValue);
                return;
            } else {
                console.log('Enhanced dropdown: No initial value — placeholder only (no auto-select from .active)');
            }
        }
    };

    // Initialize enhanced dropdowns
    function initEnhancedDropdowns() {
        console.log('Enhanced dropdown: initEnhancedDropdowns called');
        const allDropdowns = document.querySelectorAll('.enhanced-dropdown');
        console.log('Enhanced dropdown: found', allDropdowns.length, 'enhanced dropdowns');
        
        allDropdowns.forEach((element, index) => {
            console.log(`Enhanced dropdown: processing element ${index}`, element);
            
            // Skip if already initialized
            if (element._enhancedDropdownInstance || EnhancedDropdown.instances.has(element)) {
                console.log('Enhanced dropdown: skipping already initialized element');
                return;
            }

            // Mark as being initialized to prevent race conditions
            element._enhancedDropdownInstance = 'initializing';

            // Get configuration from data attributes
            const config = {
                searchEnabled: element.dataset.searchEnabled === 'true',
                maxVisibleItems: parseInt(element.dataset.maxVisibleItems) || DEFAULT_CONFIG.maxVisibleItems,
                pageSize: parseInt(element.dataset.pageSize) || DEFAULT_CONFIG.pageSize,
                initialLoadCount: parseInt(element.dataset.initialLoadCount) || DEFAULT_CONFIG.initialLoadCount,
                endpoint: element.getAttribute('data-endpoint') || DEFAULT_CONFIG.endpoint,
                type: element.dataset.type || DEFAULT_CONFIG.type,
                searchField: element.dataset.searchField || DEFAULT_CONFIG.searchField,
                idField: element.dataset.idField || DEFAULT_CONFIG.idField,
                nameField: element.dataset.nameField || DEFAULT_CONFIG.nameField,
                delay: parseInt(element.dataset.delay) || DEFAULT_CONFIG.delay,
                minSearchLength: parseInt(element.dataset.minSearchLength) || DEFAULT_CONFIG.minSearchLength,
                selectedValue: element.getAttribute('data-selected-value') || null,
                catalogTotalCount: element.dataset.catalogTotalCount
                    ? parseInt(element.dataset.catalogTotalCount, 10)
                    : null,
                sortBy: element.dataset.sortBy || DEFAULT_CONFIG.sortBy,
                sortAscending: element.dataset.sortAscending !== 'false'
            };

            // Add filters from data attributes (especially for group dropdowns)
            if (element.dataset.filterGroupid) {
                config.filters = config.filters || {};
                config.filters.GroupId = element.dataset.filterGroupid;
                console.log('Enhanced dropdown: Added GroupId filter from data-filter-groupid:', element.dataset.filterGroupid, 'for element:', element.id || element.className);
                console.log('Enhanced dropdown: Full config after adding filters:', JSON.stringify(config, null, 2));
            } else {
                console.log('Enhanced dropdown: No data-filter-groupid attribute found for element:', element.id || element.className, 'dataset:', JSON.stringify(element.dataset));
            }

            console.log('Enhanced dropdown: config for element', config);

            // Create instance
            const instance = new EnhancedDropdown(element, config);
            EnhancedDropdown.instances.set(element, instance);
            element._enhancedDropdownInstance = instance;
            
            // Set up search functionality for static search inputs
            const staticSearchInput = element.querySelector('.dropdown-search-input');
            if (staticSearchInput) {
                console.log('Enhanced dropdown: Setting up static search for element');
                staticSearchInput.addEventListener('input', function(e) {
                    const searchKey = stripAsciiSpaces(e.target.value).toLowerCase();
                    const items = element.querySelectorAll('.dropdown-item:not(.search-item):not(.reset-option)');
                    
                    console.log('Enhanced dropdown: Static search filtering', items.length, 'items with term:', searchKey);
                    
                    items.forEach(item => {
                        const text = stripAsciiSpaces(item.textContent).toLowerCase();
                        if (text.includes(searchKey)) {
                            item.style.display = 'block';
                        } else {
                            item.style.display = 'none';
                        }
                    });
                });
            }
            
            console.log('Enhanced dropdown: instance created for element');
        });
    }

    // Function to clean up ghost dropdowns - SIMPLIFIED
    function cleanupGhostDropdowns() {
        document.querySelectorAll('.dropdown-menu').forEach(menu => {
            const parentDropdown = menu.closest('.dropdown');
            
            // Only clean up if menu is truly orphaned (no parent dropdown)
            const isGhost = !parentDropdown || !parentDropdown.contains(menu);
            
            // Don't clean up if menu is properly positioned and has show class
            const isActive = menu.classList.contains('show') || menu.style.display === 'block';
            
            if (isGhost && !isActive) {
                console.log('Enhanced dropdown: Cleaning up ghost dropdown');
                menu.remove();
            }
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            cleanupGhostDropdowns();
            initEnhancedDropdowns();
        });
    } else {
        // Clean up any existing ghost dropdowns before initialization
        cleanupGhostDropdowns();
        initEnhancedDropdowns();
    }

    // Run cleanup periodically and on various events
    setInterval(cleanupGhostDropdowns, 1000);
    document.addEventListener('click', cleanupGhostDropdowns);
    document.addEventListener('scroll', cleanupGhostDropdowns, true);
    window.addEventListener('resize', cleanupGhostDropdowns);

    // Observe for dynamically added content
    const observer = new MutationObserver(function(mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const dropdowns = node.querySelectorAll ? node.querySelectorAll('.enhanced-dropdown') : [];
                        if (dropdowns.length > 0) {
                            initEnhancedDropdowns();
                        }
                    }
                }
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Export to global scope - INSIDE function
    window.EnhancedDropdown = EnhancedDropdown;
    window.EnhancedDropdownRenderer = EnhancedDropdownRenderer;
    window.initEnhancedDropdowns = initEnhancedDropdowns;
    
    // Initialize immediately if jQuery is available
    if (typeof $ !== 'undefined') {
        console.log('Enhanced dropdown: jQuery available, initializing immediately');
        initEnhancedDropdowns();
    } else {
        console.log('Enhanced dropdown: jQuery not available, waiting...');
        // Start initialization
        waitForJQuery();
    }

} // End of initEnhancedDropdownModule

// Initialize the module
initEnhancedDropdownModule();

})();

(function() {
    'use strict';
    if (window.__twAutoEnhancedDropdownModuleInit) return;
    window.__twAutoEnhancedDropdownModuleInit = true;

    // Конфигурация по умолчанию
    const DEFAULT_CONFIG = {
        pageSize: 5,
        searchMinLength: 2,
        searchDelay: 300,
        enableVirtualScroll: true,
        enableCache: true,
        cacheExpiry: 300000 // 5 минут
    };

    // Ожидание загрузки EnhancedDropdown
    function waitForEnhancedDropdown() {
        if (typeof window.EnhancedDropdown !== 'undefined') {
            console.log('[AUTO-ENHANCED] EnhancedDropdown available, initializing...');
            initAutoEnhancedDropdown();
        } else {
            console.log('[AUTO-ENHANCED] Waiting for EnhancedDropdown...');
            setTimeout(waitForEnhancedDropdown, 100);
        }
    }

    // Инициализация auto-enhanced dropdowns
    function initAutoEnhancedDropdown() {
        console.log('[AUTO-ENHANCED] Initializing auto-enhanced dropdowns...');
        
        // Обработка всех существующих dropdowns
        processAllDropdowns();
        
        // Наблюдение за изменениями DOM для новых dropdowns
        observeDOMChanges();
        
        // Глобальная функция для принудительного обновления
        window.enhanceDropdownsIfNeeded = processAllDropdowns;
        
        // Listen for enhanced dropdown change events and trigger table updates/related dropdown refresh
        document.addEventListener('enhancedDropdownChange', function(e) {
            try {
                console.log('[AUTO-ENHANCED] enhancedDropdownChange event received:', e.detail);

                // Get dropdown element that triggered the event
                let dropdownElement =
                    (e.detail && e.detail.dropdownElement) ||
                    (e.detail && e.detail.dropdownId ? document.getElementById(e.detail.dropdownId) : null);
                if (!dropdownElement && e.target && typeof e.target.closest === 'function') {
                    dropdownElement = e.target.closest('.dropdown');
                }

                if (!dropdownElement) {
                    console.warn('[AUTO-ENHANCED] Could not find dropdown element for enhancedDropdownChange event');
                    return;
                }

                if (dropdownElement.querySelector && dropdownElement.querySelector('.dropdown-item[data-theme]')) {
                    return;
                }

                console.log('[AUTO-ENHANCED] Processing change for dropdown:', dropdownElement.id || dropdownElement.className);

                // === 1. Главная страница - topGroupDropdown фильтрует ТОЛЬКО карточки ===
                if (dropdownElement.id === 'topGroupDropdownContainer') {
                    // Полностью обрабатывается в dashboard-cards.js (URL sync + AJAX карточек).
                    return;
                }

                // === 2. Страница редактирования (PointOfSales/Edit) - выбор товара/типа ===
                // На странице редактирования нет таблицы с пагинацией, только формы
                const isEditPage = window.location.pathname.includes('/PointOfSales/Edit') ||
                                   window.location.pathname.includes('/PointOfSales/Create');
                
                if (isEditPage) {
                    console.log('[AUTO-ENHANCED] Страница редактирования - пропускаем обновление таблицы');
                    // На странице редактирования своя логика (обновление цены товара и т.д.)
                    // Она обрабатывается в pointofsale-common.js
                    return;
                }

                // === 3. Проверка наличия updateTableData или updateDashboardTableData ===
                // Если нет функций обновления таблицы, значит это не страница с фильтруемой таблицей
                const hasTableUpdate = typeof window.updateTableData === 'function' ||
                                       typeof window.updateDashboardTableData === 'function';
                
                if (!hasTableUpdate) {
                    console.log('[AUTO-ENHANCED] Функции обновления таблицы не найдены - пропускаем');
                    return;
                }

                const isDashboardPage = window.location.pathname === '/' || window.location.pathname.includes('/Home');
                const isShipmentPlanningPage = window.location.pathname.toLowerCase().includes('/shipmentplanning');

                if (isDashboardPage && window.updateDashboardTableData) {
                    setTimeout(() => {
                        const filters = window.collectDashboardFilters ? window.collectDashboardFilters() : {};
                        window.updateDashboardTableData(filters, 1, window.getEffectivePageSize());
                    }, 50);
                } else if (isShipmentPlanningPage) {
                    // ShipmentPlanning: свой сбор в shipment-planning.js
                } else if (typeof window.collectListPagesFilters === 'function') {
                    // List pages (MachineStatus, Sales, etc.): list-pages-search.js subscribes to the same event
                    // and calls debouncedUpdateTableData — skip here to avoid duplicate requests
                } else if (window.updateTableData) {
                    const firstPaginationLink = document.querySelector('.ajax-pagination');
                    const controller = firstPaginationLink && firstPaginationLink.getAttribute('data-controller');
                    const action = firstPaginationLink && firstPaginationLink.getAttribute('data-action');
                    if (controller && action) {
                        const filters = typeof window.collectFilters === 'function' ? window.collectFilters() : {};
                        window.updateTableData(filters, controller, action, 1, window.getEffectivePageSize());
                    }
                }

                // Refresh dependent dropdowns (points/products) after change
                if (window.populateDropdowns && typeof window.populateDropdowns === 'function') {
                    try {
                        window.populateDropdowns();
                    } catch (ex) {
                        console.warn('Error populating dropdowns after enhanced change:', ex.message);
                    }
                }
            } catch (ex) {
                console.error('[AUTO-ENHANCED] Error in enhancedDropdownChange handler:', ex);
                console.warn('enhancedDropdownChange event warning:', ex.message);
            }
        });
    }

    function enhanceDropdownIfNeeded(dropdownElement) {
        if (dropdownElement.classList.contains('enhanced-dropdown')) {
            console.log('[AUTO-ENHANCED] Dropdown already enhanced:', dropdownElement.id || dropdownElement.className);
            return;
        }

        // Селектор темы (data-theme): не усиливаем — EnhancedDropdown перехватывает клик (stopPropagation),
        // ломая themes.js, и шлёт enhancedDropdownChange, из-за чего обновляются таблицы на list-страницах.
        if (dropdownElement.querySelector('.dropdown-item[data-theme]')) {
            return;
        }

        // Проверяем, есть ли у dropdown элементы для выбора
        const dropdownItems = dropdownElement.querySelectorAll('.dropdown-item, [data-value]');
        const selectableItems = Array.from(dropdownItems).filter(item => {
            return item.hasAttribute('data-value') || 
                   (item.textContent && item.textContent.trim() !== '');
        });

        if (selectableItems.length > DEFAULT_CONFIG.pageSize) {
            console.log('[AUTO-ENHANCED] Enhancing dropdown with', selectableItems.length, 'items:', dropdownElement.id || dropdownElement.className);
            
            const config = {
                ...DEFAULT_CONFIG,
                items: selectableItems.map((item, index) => ({
                    id: item.getAttribute('data-value') || item.textContent.trim(),
                    text: item.textContent.trim(),
                    value: item.getAttribute('data-value') || item.textContent.trim(),
                    element: item
                }))
            };

            // Initialize enhanced dropdown if available
            if (typeof window.EnhancedDropdown !== 'undefined') {
                try {
                    new window.EnhancedDropdown(dropdownElement, config);
                    console.log('Auto-enhanced dropdown: Successfully enhanced dropdown:', dropdownElement.id || dropdownElement.className);
                } catch (error) {
                    console.error('Auto-enhanced dropdown: Error enhancing dropdown:', error);
                }
            } else {
                console.warn('Auto-enhanced dropdown: EnhancedDropdown not available');
            }
        } else {
            console.log('[AUTO-ENHANCED] Dropdown does not need enhancement (', selectableItems.length, 'items):', dropdownElement.id || dropdownElement.className);
        }
    }

    function processAllDropdowns() {
        const dropdowns = document.querySelectorAll('.dropdown:not(.enhanced-dropdown)');
        console.log('[AUTO-ENHANCED] Processing', dropdowns.length, 'dropdowns for enhancement');
        
        dropdowns.forEach(enhanceDropdownIfNeeded);
    }

    function init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', processAllDropdowns);
        } else {
            processAllDropdowns();
        }

        // Наблюдение за изменениями в DOM
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const dropdowns = node.querySelectorAll ? node.querySelectorAll('.dropdown') : [];
                            if (dropdowns.length > 0) {
                                console.log('[AUTO-ENHANCED] Found new dropdowns in added nodes');
                                dropdowns.forEach(enhanceDropdownIfNeeded);
                            }
                        }
                    });
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function observeDOMChanges() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const dropdowns = node.querySelectorAll ? node.querySelectorAll('.dropdown:not(.enhanced-dropdown)') : [];
                            if (dropdowns.length > 0) {
                                console.log('[AUTO-ENHANCED] Found new dropdowns to enhance');
                                dropdowns.forEach(enhanceDropdownIfNeeded);
                            }
                        }
                    });
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Start initialization
    waitForEnhancedDropdown();
})();

(() => {
    "use strict";

    if (window.__twBugReportModuleInit) {
        return;
    }
    window.__twBugReportModuleInit = true;

    const MAX_ATTACHMENTS = 5;
    const MAX_FILE_BYTES = 5 * 1024 * 1024;
    const logsBuffer = [];
    const maxLogs = 100;
    const OVERLAY_HIDE_DELAY_MS = 250;
    const POST_PICKER_STABILIZE_MS = 550;
    const RETRY_CAPTURE_DELAY_MS = 250;
    const MAX_STACK_CHARS = 2000;
    const MAX_CONSOLE_ARG_CHARS = 500;

    const modalEl = document.getElementById("bugReportModal");
    const buttonEl = document.getElementById("bugReportButton");
    const submitButtonEl = document.getElementById("bugReportSubmitButton");
    const autoCaptureEl = document.getElementById("bugReportAutoScreenshot");
    const screenshotsInputEl = document.getElementById("bugReportScreenshots");
    const traceIdEl = document.getElementById("bugReportTraceId");

    if (!modalEl || !buttonEl || !submitButtonEl) {
        return;
    }

    const bugReportModal = new bootstrap.Modal(modalEl);
    refreshTraceIdDisplay();

    patchConsoleError();
    wireGlobalErrorHandlers();

    buttonEl.addEventListener("click", () => bugReportModal.show());
    modalEl.addEventListener("show.bs.modal", refreshTraceIdDisplay);
    document.addEventListener("keydown", (event) => {
        if (event.ctrlKey && event.altKey && event.code === "KeyB") {
            event.preventDefault();
            bugReportModal.show();
        }
    });

    submitButtonEl.addEventListener("click", async () => {
        submitButtonEl.disabled = true;
        try {
            const currentTraceId = resolveTraceId();
            refreshTraceIdDisplay(currentTraceId);
            const payload = collectPayload(currentTraceId);
            const files = await collectAttachments();
            validateAttachments(files);
            const result = await sendBugReport(payload, files);
            if (typeof showNotification === "function") {
                const details = [];
                if (result?.reportId) details.push(`ID: ${result.reportId}`);
                if (result?.traceId) details.push(`TraceId: ${result.traceId}`);
                const suffix = details.length > 0 ? ` (${details.join(", ")})` : "";
                showNotification("success", `Багрепорт отправлен${suffix}`, "Отчет о проблеме");
            }
            bugReportModal.hide();
        } catch (error) {
            if (typeof showNotification === "function") {
                showNotification("error", error?.message || "Не удалось отправить багрепорт", "Отчет о проблеме");
            }
        } finally {
            submitButtonEl.disabled = false;
        }
    });

    async function collectAttachments() {
        const manualFiles = Array.from(screenshotsInputEl?.files || []);
        const collected = [];

        if (autoCaptureEl?.checked) {
            const screenshot = await tryAutoCapture();
            if (screenshot) {
                collected.push(screenshot);
            }
        }

        for (const file of manualFiles) {
            collected.push(file);
        }

        return collected;
    }

    function validateAttachments(files) {
        if (files.length > MAX_ATTACHMENTS) {
            throw new Error(`Можно приложить не более ${MAX_ATTACHMENTS} файлов`);
        }

        for (const file of files) {
            if (file.size > MAX_FILE_BYTES) {
                throw new Error(`Файл ${file.name} превышает 5MB`);
            }
        }
    }

    async function tryAutoCapture() {
        if (!navigator.mediaDevices?.getDisplayMedia) {
            return null;
        }

        const restoreOverlay = setBugReportOverlayVisible(false);
        await waitForOverlayToHide();
        let stream = null;
        try {
            stream = await navigator.mediaDevices.getDisplayMedia({
                video: { frameRate: 1 },
                audio: false
            });

            const [videoTrack] = stream.getVideoTracks();
            if (!videoTrack) {
                return null;
            }

            const imageCapture = new ImageCapture(videoTrack);
            await waitForCaptureReady();
            const bitmap = await grabFrameWithRetry(imageCapture);
            const canvas = document.createElement("canvas");
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;

            const context = canvas.getContext("2d");
            if (!context) {
                return null;
            }
            context.drawImage(bitmap, 0, 0);

            const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));

            if (!blob) {
                return null;
            }

            return new File([blob], `autocapture-${Date.now()}.png`, { type: "image/png" });
        } catch {
            return null;
        } finally {
            stream?.getTracks().forEach((t) => t.stop());
            restoreOverlay();
        }
    }

    async function grabFrameWithRetry(imageCapture) {
        try {
            return await imageCapture.grabFrame();
        } catch {
            // One short retry helps on slow devices where picker close animation lags.
            await waitMs(RETRY_CAPTURE_DELAY_MS);
            await waitForNextPaint();
            return imageCapture.grabFrame();
        }
    }

    async function waitForOverlayToHide() {
        await waitMs(OVERLAY_HIDE_DELAY_MS);
        await waitForNextPaint();
        await waitForNextPaint();
    }

    async function waitForCaptureReady() {
        await waitMs(POST_PICKER_STABILIZE_MS);
        await waitForNextPaint();
    }

    function waitMs(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    function waitForNextPaint() {
        return new Promise((resolve) => requestAnimationFrame(() => resolve()));
    }

    function collectPayload(currentTraceId) {
        const parsedPriority = parseInt(value("bugReportPriority") || "2", 10);
        const assignedUserSelect = document.getElementById("bugReportAssignedUser");
        const assignedToUserId = assignedUserSelect ? assignedUserSelect.value : null;
        return {
            title: value("bugReportTitle"),
            description: value("bugReportDescription"),
            stepsToReproduce: value("bugReportSteps"),
            expectedResult: value("bugReportExpected"),
            actualResult: value("bugReportActual"),
            pageUrl: safePageUrlForPayload(),
            userAgent: navigator.userAgent,
            appVersion: window.appDiagnostics?.appVersion || "unknown",
            traceId: currentTraceId,
            priority: Number.isNaN(parsedPriority) ? 2 : parsedPriority,
            assignedToUserId: assignedToUserId ? parseInt(assignedToUserId, 10) : null,
            clientTimestamp: formatMoscowNow(),
            windowWidth: window.innerWidth || 0,
            windowHeight: window.innerHeight || 0,
            screenWidth: window.screen?.width || 0,
            screenHeight: window.screen?.height || 0,
            devicePixelRatio: window.devicePixelRatio || 1,
            locale: navigator.language || "",
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
            referrer: document.referrer || "",
            platform: navigator.userAgentData?.platform || navigator.platform || "",
            cookiesEnabled: navigator.cookieEnabled === true,
            online: navigator.onLine === true,
            logs: logsBuffer.slice(-maxLogs)
        };
    }

    async function sendBugReport(payload, files) {
        const formData = new FormData();
        formData.append("payload", JSON.stringify(payload));
        for (const file of files) {
            formData.append("screenshots", file, file.name);
        }
        const af = document.querySelector('#bugReportModal input[name="__RequestVerificationToken"]');
        if (af && af.value) {
            formData.append("__RequestVerificationToken", af.value);
        }

        const response = await fetch("/bugreports-api", {
            method: "POST",
            body: formData,
            credentials: "same-origin"
        });

        if (!response.ok) {
            throw new Error(`Ошибка отправки: ${response.status}`);
        }

        const text = await response.text();
        if (!text) {
            return null;
        }

        try {
            return JSON.parse(text);
        } catch {
            return null;
        }
    }

    function value(id) {
        return (document.getElementById(id)?.value || "").trim();
    }

    function resolveTraceId() {
        const lastRequestTraceId = window.appDiagnostics?.lastTraceId;
        if (lastRequestTraceId) {
            return lastRequestTraceId;
        }

        const fromApp = window.appDiagnostics?.traceId;
        if (fromApp) {
            return fromApp;
        }

        if (window.crypto?.randomUUID) {
            return window.crypto.randomUUID().replaceAll("-", "");
        }

        return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    function refreshTraceIdDisplay(traceId = resolveTraceId()) {
        if (traceIdEl) {
            traceIdEl.textContent = traceId || "-";
        }
    }

    function safePageUrlForPayload() {
        try {
            const u = new URL(window.location.href);
            const q = u.search ? u.search : "";
            const maxQ = 256;
            const qTrim = q.length > maxQ ? q.slice(0, maxQ) + "…" : q;
            return u.origin + u.pathname + qTrim + u.hash;
        } catch {
            return (window.location.pathname || "/") + (window.location.search.length > 256 ? "…" : window.location.search);
        }
    }

    function clientLogUrlNoQuery() {
        try {
            return window.location.origin + window.location.pathname;
        } catch {
            return "";
        }
    }

    function truncateForBuffer(text, maxLen) {
        const s = String(text || "");
        return s.length <= maxLen ? s : s.slice(0, maxLen) + "…";
    }

    function pushLog(level, message, stack = "", source = "", lineNumber = 0, columnNumber = 0) {
        logsBuffer.push({
            level,
            message: truncateForBuffer(message, 2000),
            stack: truncateForBuffer(stack, MAX_STACK_CHARS),
            source: String(source || "").split("?")[0],
            lineNumber,
            columnNumber,
            timestamp: formatMoscowNow(),
            url: clientLogUrlNoQuery()
        });

        if (logsBuffer.length > maxLogs) {
            logsBuffer.splice(0, logsBuffer.length - maxLogs);
        }
    }

    function wireGlobalErrorHandlers() {
        window.addEventListener("error", (event) => {
            pushLog("error", event.message, event.error?.stack || "", event.filename, event.lineno, event.colno);
        });

        window.addEventListener("unhandledrejection", (event) => {
            const reason = event.reason;
            const message = typeof reason === "string" ? reason : (reason?.message || "Unhandled rejection");
            pushLog("error", message, reason?.stack || "");
        });
    }

    function summarizeConsoleArg(a) {
        if (a === null || a === undefined) return String(a);
        if (typeof a === "string") return truncateForBuffer(a, MAX_CONSOLE_ARG_CHARS);
        if (typeof a === "number" || typeof a === "boolean") return String(a);
        if (a instanceof Error) return truncateForBuffer(a.message || "Error", MAX_CONSOLE_ARG_CHARS);
        if (typeof a === "object") {
            try {
                const keys = Object.keys(a);
                return keys.length ? `[object:${keys.slice(0, 8).join(",")}${keys.length > 8 ? "…" : ""}]` : "[object]";
            } catch {
                return "[object]";
            }
        }
        return truncateForBuffer(String(a), MAX_CONSOLE_ARG_CHARS);
    }

    function patchConsoleError() {
        const original = console.error;
        console.error = function (...args) {
            try {
                const text = args.map(summarizeConsoleArg).join(" ");
                pushLog("error", text);
            } catch {
                // ignore buffer errors
            }
            original.apply(console, args);
        };
    }

    function formatMoscowNow() {
        const value = new Date().toLocaleString("sv-SE", { timeZone: "Europe/Moscow" });
        return value.replace(" ", "T");
    }

    function setBugReportOverlayVisible(visible) {
        const previousModalVisibility = modalEl.style.visibility;
        const previousModalPointerEvents = modalEl.style.pointerEvents;
        const backdrops = Array.from(document.querySelectorAll(".modal-backdrop"));
        const previousBackdropVisibility = backdrops.map((el) => el.style.visibility);

        if (!visible) {
            modalEl.style.visibility = "hidden";
            modalEl.style.pointerEvents = "none";
            backdrops.forEach((el) => {
                el.style.visibility = "hidden";
            });
        }

        return () => {
            modalEl.style.visibility = previousModalVisibility;
            modalEl.style.pointerEvents = previousModalPointerEvents;
            backdrops.forEach((el, index) => {
                el.style.visibility = previousBackdropVisibility[index] || "";
            });
        };
    }
})();

